import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  Unit_instanceat14thlj150z as Unit_instance,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629330ogi7dvp as Duration__hashCode_impl_u4exz6,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toHexString5bhtjxqec7ow as toHexString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  sorted354mfsiv4s7x5 as sorted,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  RuntimeException1r3t0zl97011n as RuntimeException,
  captureStack1fzi4aczwc4hg as captureStack,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  numberToLong1a4cndvg6c52s as numberToLong,
  toDurationba1nlt78o6vu as toDuration_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  toInt2q8uldh7sc951 as toInt,
  getOrNullef5jbxih7r4f as getOrNull,
  _UByteArray___init__impl__ip4y9n3sp5zyufbcv0v as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv1encpe8trq9zx as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  copyOf39s58md6y6rn6 as copyOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  println2shhhgwwt4c61 as println,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toShort36kaw0zjdq3ex as toShort,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UBytep4j7r1t64gz1 as UByte,
  UByte__hashCode_impl_mmczcb2bk1orv63vhkp as UByte__hashCode_impl_mmczcb,
  createThis2j2avj17cvnv2 as createThis,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  fill3lmv1pckd4inv as fill,
  fill34ox8qmmmh3u3 as fill_0,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getOrNull1d60i0672n7ns as getOrNull_0,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  boxApply1qmzdb3dh90hg as boxApply,
  KProperty1ca4yb4wlo496 as KProperty1,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_0,
  DateTime__minus_impl_10njw81qwhaqtma3616 as DateTime__minus_impl_10njw8,
  DateTime__minus_impl_10njw812puhhvc4b9kf as DateTime__minus_impl_10njw8_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  get_niceStr3crhxydmlnaoj as get_niceStr,
  extract2vhru1ihy4ogl as extract,
  hasFlagsibfubl68mj8u as hasFlags,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  delay1blitpytzu6gr as delay,
  yield17af0dtgvr9x7 as yield_0,
  delay1f60wyf8ua1gc as delay_0,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  readStream3f0dxaq1c55fg as readStream,
  toSyncOrNull2d7etdx5kh7ns as toSyncOrNull,
  readBytesUpTo1px2t44z4b9v7 as readBytesUpTo_0,
  openSync2m3qn99fqytu0 as openSync,
  readString20u8kjncp0xlx as readString,
  readString3h14fm47a2tde as readString_0,
  readBytesExact305h8zdeltghk as readBytesExact,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readS16LE3rt2utyxlgw3g as readS16LE,
  readS32LE2r371m40u4y6y as readS32LE,
  readU32LE31t9li7x6s60w as readU32LE,
  MemorySyncStreamw5bwb9yy0cam as MemorySyncStream,
  toAsyncc87ncfb6nti7 as toAsync,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  binarySearch1lxbagta5e4q4 as binarySearch,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  ByteArrayDeque2dezgzzyyl6zm as ByteArrayDeque,
  ShortArrayDeque13dn2tr6asm80 as ShortArrayDeque,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  _UByteArrayInt___get_bytes__impl__pj0ilcub6wlvph43r as _UByteArrayInt___get_bytes__impl__pj0ilc,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  getU83agrw8yj0shar as getU8,
  indexOf1wbggs5i7ilsw as indexOf,
  _UByteArrayInt___init__impl__xif7bu29rfv0s29knch as _UByteArrayInt___init__impl__xif7bu_0,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_1,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy52dxe7vhzf14 as arraycopy,
  arraycopy3n78tfzvkl4kg as arraycopy_0,
  UByteArrayInt__set_impl_gn45321v79kdhd4y5qt as UByteArrayInt__set_impl_gn4532_0,
  UByteArrayInt__fill$default_impl_mdydxi1wz00ttbtxw3z as UByteArrayInt__fill$default_impl_mdydxi,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS24LE1b229asvs5i3l as getS24LE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  readStringzinkjpjt71hyo as readStringz,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  invalidOp1stebxh2m3n07 as invalidOp,
  unsupported198cz39rr1ztw as unsupported,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  _AudioSampleArray___init__impl__qpxoq02y04g82w4ty79 as _AudioSampleArray___init__impl__qpxoq0,
  _AudioSample___init__impl__s54gd52xugxuumb5p5l as _AudioSample___init__impl__s54gd5,
  AudioSampleArray__set_impl_tqgfwk2e4yme6xw91vg as AudioSampleArray__set_impl_tqgfwk,
  _AudioSample___get_short__impl__uk8ygu25qxorykipf8f as _AudioSample___get_short__impl__uk8ygu,
  AudioSampleArray__asShortArray_impl_iyd0md153iqk9vsos7c as AudioSampleArray__asShortArray_impl_iyd0md,
  AudioSampleArray__get_impl_w0l0xc3ifihtwr00dm3 as AudioSampleArray__get_impl_w0l0xc,
  _AudioSampleArray___get_size__impl__8l8tm8x01vap0727wl as _AudioSampleArray___get_size__impl__8l8tm8,
  AudioSampleArray262uyoodhuuvf as AudioSampleArray,
  AudioSamples3pmkh9en9mrjs as AudioSamples,
  AudioData3ewbxcbopprh8 as AudioData,
  ReadonlySoundProps270enpa6r4amt as ReadonlySoundProps,
  SoundProps3stqh6vq4ra4p as SoundProps,
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  Companion_getInstance2wrvcuzneq6bn as Companion_getInstance_1,
  AudioSampleArray__fill$default_impl_gh9lh0607zwvqcotvv as AudioSampleArray__fill$default_impl_gh9lh0,
  Companion_instance1o81m7d7a4ex as Companion_instance,
} from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  get_baseName2yf63efofm8te as get_baseName,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { Companion_getInstance1yq7a1f60lp2k as Companion_getInstance_2 } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  onCancel134048q5p9j85 as onCancel,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  q7a(formats) {
    return (new AudioFormats()).u7a(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp.v7a_1 = toSet(destination);
  }
  a7b() {
    return this.v7a_1;
  }
  w7a(data, props, $completion) {
    return null;
  }
  b7b(data, props, $completion) {
    return null;
  }
  z7a(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStream__ydjika.bind(VOID, this, data, props), $completion);
  }
  c7b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamOrError__s0emn1.bind(VOID, this, data, props), $completion);
  }
  q3() {
    return 'AudioFormat';
  }
  toString() {
    return this.q3() + '(' + toString(sorted(this.a7b())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.s7a_1 = ArrayList.z();
    this.t7a_1 = null;
  }
  a7b() {
    if (this.t7a_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.s7a_1;
      var destination = ArrayList.z();
      var tmp0_iterator = this_0.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.a7b();
        addAll(destination, list);
      }
      tmp.t7a_1 = toSet(destination);
    }
    return ensureNotNull(this.t7a_1);
  }
  u7a(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.s7a_1;
    addAll_0(this_1, formats);
    return this_0;
  }
  w7a(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh.bind(VOID, this, data, props), $completion);
  }
  b7b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877.bind(VOID, this, data, props), $completion);
  }
}
class Info {
  constructor(duration, channels, decodingTime) {
    var tmp;
    if (duration === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = duration;
    }
    duration = tmp;
    channels = channels === VOID ? 2 : channels;
    decodingTime = decodingTime === VOID ? null : decodingTime;
    this.d7b_1 = new Mixin();
    this.e7b_1 = duration;
    this.f7b_1 = channels;
    this.g7b_1 = decodingTime;
  }
  c28(_set____db54di) {
    this.d7b_1.c28(_set____db54di);
  }
  d28() {
    return this.d7b_1.d28();
  }
  h7b() {
    var tmp0_elvis_lhs = this.e7b_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'Info(duration=' + get_niceStr(get_milliseconds(this.h7b())) + 'ms, channels=' + this.f7b_1 + ')';
  }
  hashCode() {
    var tmp;
    var tmp_0 = this.e7b_1;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = 0;
    } else {
      tmp = Duration__hashCode_impl_u4exz6(this.e7b_1);
    }
    var result = tmp;
    result = imul(result, 31) + this.f7b_1 | 0;
    var tmp_1 = imul(result, 31);
    var tmp_2;
    var tmp_3 = this.g7b_1;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      tmp_2 = 0;
    } else {
      tmp_2 = Duration__hashCode_impl_u4exz6(this.g7b_1);
    }
    result = tmp_1 + tmp_2 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    var tmp = this.e7b_1;
    var tmp_0 = tmp == null ? null : new Duration(tmp);
    var tmp_1 = tmp0_other_with_cast.e7b_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Duration(tmp_1)))
      return false;
    if (!(this.f7b_1 === tmp0_other_with_cast.f7b_1))
      return false;
    var tmp_2 = this.g7b_1;
    var tmp_3 = tmp_2 == null ? null : new Duration(tmp_2);
    var tmp_4 = tmp0_other_with_cast.g7b_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new Duration(tmp_4)))
      return false;
    return true;
  }
}
class AudioFormat$decodeStream$slambda {
  constructor(this$0, $data, $props) {
    this.o7b_1 = this$0;
    this.p7b_1 = $data;
    this.q7b_1 = $props;
  }
  f2y($this$withContext, $completion) {
    return this.o7b_1.b7b(this.p7b_1, this.q7b_1, $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.x7a_1 = new AudioDecodingProps();
    this.y7a_1 = new AudioDecodingProps(false, false);
  }
}
class AudioDecodingProps {
  constructor(exactTimings, readInMemory, formats, maxSamples, dispatcher) {
    Companion_getInstance_4();
    exactTimings = exactTimings === VOID ? null : exactTimings;
    readInMemory = readInMemory === VOID ? true : readInMemory;
    formats = formats === VOID ? null : formats;
    maxSamples = maxSamples === VOID ? 39690000 : maxSamples;
    dispatcher = dispatcher === VOID ? null : dispatcher;
    this.i7b_1 = new Mixin();
    this.j7b_1 = exactTimings;
    this.k7b_1 = readInMemory;
    this.l7b_1 = formats;
    this.m7b_1 = maxSamples;
    this.n7b_1 = dispatcher;
  }
  c28(_set____db54di) {
    this.i7b_1.c28(_set____db54di);
  }
  d28() {
    return this.i7b_1.d28();
  }
  toString() {
    return 'AudioDecodingProps(exactTimings=' + this.j7b_1 + ', readInMemory=' + this.k7b_1 + ', formats=' + toString_0(this.l7b_1) + ', maxSamples=' + this.m7b_1 + ', dispatcher=' + toString_0(this.n7b_1) + ')';
  }
  hashCode() {
    var result = this.j7b_1 == null ? 0 : getBooleanHashCode(this.j7b_1);
    result = imul(result, 31) + getBooleanHashCode(this.k7b_1) | 0;
    result = imul(result, 31) + (this.l7b_1 == null ? 0 : hashCode(this.l7b_1)) | 0;
    result = imul(result, 31) + this.m7b_1 | 0;
    result = imul(result, 31) + (this.n7b_1 == null ? 0 : hashCode(this.n7b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioDecodingProps ? other : THROW_CCE();
    if (!(this.j7b_1 == tmp0_other_with_cast.j7b_1))
      return false;
    if (!(this.k7b_1 === tmp0_other_with_cast.k7b_1))
      return false;
    if (!equals(this.l7b_1, tmp0_other_with_cast.l7b_1))
      return false;
    if (!(this.m7b_1 === tmp0_other_with_cast.m7b_1))
      return false;
    if (!equals(this.n7b_1, tmp0_other_with_cast.n7b_1))
      return false;
    return true;
  }
}
class InvalidAudioFormatException extends RuntimeException {
  static u7b(message) {
    var $this = this.bb(message);
    captureStack($this, $this.t7b_1);
    return $this;
  }
}
class MP3Base extends AudioFormat {
  constructor() {
    super(['mp3']);
  }
  w7a(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_0.bind(VOID, this, data, props), $completion);
  }
}
class MP3 extends MP3Base {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_1 extends MP3 {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.y7b_1, item);
      destination.h(tmp$ret$0);
    }
    tmp.a7c_1 = toMap(destination);
  }
}
class ChannelMode extends Enum {
  constructor(name, ordinal, id, channels) {
    super(name, ordinal);
    this.y7b_1 = id;
    this.z7b_1 = channels;
  }
}
class Mp3Info {
  constructor(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this.b7c_1 = version;
    this.c7c_1 = layer;
    this.d7c_1 = bitrate;
    this.e7c_1 = samplingRate;
    this.f7c_1 = channelMode;
    this.g7c_1 = frameSize;
    this.h7c_1 = samples;
  }
  toString() {
    return 'Mp3Info(version=' + this.b7c_1 + ', layer=' + this.c7c_1 + ', bitrate=' + this.d7c_1 + ', samplingRate=' + this.e7c_1 + ', channelMode=' + this.f7c_1.toString() + ', frameSize=' + this.g7c_1 + ', samples=' + this.h7c_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.b7c_1);
    result = imul(result, 31) + this.c7c_1 | 0;
    result = imul(result, 31) + this.d7c_1 | 0;
    result = imul(result, 31) + this.e7c_1 | 0;
    result = imul(result, 31) + this.f7c_1.hashCode() | 0;
    result = imul(result, 31) + this.g7c_1 | 0;
    result = imul(result, 31) + this.h7c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this.b7c_1 === tmp0_other_with_cast.b7c_1))
      return false;
    if (!(this.c7c_1 === tmp0_other_with_cast.c7c_1))
      return false;
    if (!(this.d7c_1 === tmp0_other_with_cast.d7c_1))
      return false;
    if (!(this.e7c_1 === tmp0_other_with_cast.e7c_1))
      return false;
    if (!this.f7c_1.equals(tmp0_other_with_cast.f7c_1))
      return false;
    if (!(this.g7c_1 === tmp0_other_with_cast.g7c_1))
      return false;
    if (!(this.h7c_1 === tmp0_other_with_cast.h7c_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l7c_1 = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.m7c_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.r7c(1, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$4 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp$ret$4);
    var tmp_4 = this.r7c(1, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$5 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp$ret$5);
    var tmp_6 = this.r7c(1, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$6 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp$ret$6);
    var tmp_8 = this.r7c(2, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$7 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp$ret$7);
    var tmp_10 = this.r7c(2, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$8 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp$ret$8);
    var tmp_12 = this.r7c(2, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$9 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1.n7c_1 = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp$ret$9)]);
    var tmp_13 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$10 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp$ret$10);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$11 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp$ret$11);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$12 = new Int32Array([11025, 12000, 8000]);
    tmp_13.o7c_1 = mapOf([tmp_14, tmp_15, to('2.5', tmp$ret$12)]);
    this.p7c_1 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  r7c(version, layer) {
    return imul(version, 10) + layer | 0;
  }
  q7c(f4) {
    var b0 = UByteArrayInt__get_impl_px6q8a(f4, 0);
    var b1 = UByteArrayInt__get_impl_px6q8a(f4, 1);
    var b2 = UByteArrayInt__get_impl_px6q8a(f4, 2);
    var b3 = UByteArrayInt__get_impl_px6q8a(f4, 3);
    if (!(b0 === 255)) {
      get_invalidOp();
    }
    var version = this.l7c_1[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this.m7c_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.r7c(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp6_safe_receiver = this.n7c_1.e3(bitrate_key);
    var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : getOrNull(tmp6_safe_receiver, bitrate_idx);
    var bitrate = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp7_safe_receiver = this.o7c_1.e3(version);
    var tmp1_elvis_lhs = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, extract(b2, 2, 2));
    var sample_rate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_6().a7c_1.e3(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp8_safe_receiver = this.p7c_1.e3(simple_version);
    var tmp2_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.e3(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
  }
}
class SeekingTable {
  constructor(microseconds, filePositions) {
    this.u7c_1 = microseconds;
    this.v7c_1 = filePositions;
  }
  w7c() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.u7c_1.h1(this.u7c_1.g1() - 1 | 0);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  x7c(rate) {
    return numberToLong(get_seconds(this.w7c()) * rate);
  }
  y7c(time) {
    // Inline function 'korlibs.time.microseconds' call
    var searchMicro = _Duration___get_inWholeNanoseconds__impl__r5x4mr(time).n4() / 1000.0;
    var result = binarySearch(this.u7c_1, searchMicro);
    return numberToLong(this.v7c_1.h1(_BSearchResult___get_nearIndex__impl__s8nq43(result)));
  }
}
class Parser {
  constructor(data, dataLength) {
    Companion_getInstance_7();
    this.i7c_1 = data;
    this.j7c_1 = dataLength;
    this.k7c_1 = null;
  }
  t7c($completion) {
    return _getDuration$default(this, true, VOID, $completion);
  }
  s7c($completion) {
    return _getDuration$default(this, false, VOID, $completion);
  }
  z7c($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getSeekingTable__ywx4sa.bind(VOID, this), $completion);
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_8();
    super(['mp3']);
    this.b7d_1 = Minimp3AudioFormat_getInstance();
  }
  w7a(data, props, $completion) {
    return this.b7d_1.w7a(data, props, $completion);
  }
  b7b(data, props, $completion) {
    return this.b7d_1.z7a(data, props, $completion);
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_4 extends MP3Decoder {
  constructor() {
    Companion_instance_5 = null;
    super();
    Companion_instance_5 = this;
  }
}
class MiniMp3Program {
  constructor() {
    Companion_getInstance_10();
    this.v7d_1 = new Int32Array(3);
    this.w7d_1 = new Float32Array(9);
    this.x7d_1 = new Float32Array(9);
    this.y7d_1 = new Float32Array(4);
    this.z7d_1 = new Float32Array(4);
    this.a7e_1 = Mp3Scratch.e7k();
    this.b7e_1 = new Bs();
  }
  b7f(dst, src, size) {
    arraycopy(src.m7k_1, src.n7k_1, dst.m7k_1, dst.n7k_1, size);
  }
  c7f(dst, src, size) {
    arraycopy_0(src.i7k_1, src.j7k_1, dst.i7k_1, dst.j7k_1, size);
  }
  d7f(bs, data, bytes) {
    bs.t7j_1 = data;
    bs.u7j_1 = 0;
    bs.v7j_1 = imul(bytes, 8);
  }
  e7f(bs, n) {
    var cache = 0;
    var s = bs.u7j_1 & 7;
    var shl = n + s | 0;
    var p = bs.t7j_1.h7k(bs.u7j_1 >>> 3 | 0);
    bs.u7j_1 = bs.u7j_1 + n | 0;
    if (bs.u7j_1 > bs.v7j_1)
      return 0;
    var next = p.w1() & (255 >>> s | 0);
    p = p.a4();
    $l$loop: while (true) {
      shl = shl - 8 | 0;
      if (shl <= 0)
        break $l$loop;
      cache = cache | next << shl;
      next = p.w1();
      p = p.a4();
    }
    return cache | (next >>> (-shl | 0) | 0);
  }
  f7f(h) {
    var h0 = h.h1(0);
    var h1 = h.h1(1);
    var h2 = h.h1(2);
    return h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226) && !((h1 >> 1 & 3) === 0) && !(h2 >> 4 === 15) && !((h2 >> 2 & 3) === 3);
  }
  g7f(h1, h2) {
    return toInt_0(this.f7f(h2) && ((h1.h1(1) ^ h2.h1(1)) & 254) === 0 && ((h1.h1(2) ^ h2.h1(2)) & 12) === 0 && (toInt_0((h1.h1(2) & 240) === 0, this) ^ toInt_0((h2.h1(2) & 240) === 0, this)) === 0, this);
  }
  h7f(h) {
    return imul(2, UByteArrayInt__get_impl_px6q8a(Companion_getInstance_10().w7i_1[toInt_0(!((h.h1(1) & 8) === 0), this)][(h.h1(1) >> 1 & 3) - 1 | 0].e2c_1, h.h1(2) >> 4));
  }
  i7f(h) {
    var g_hz = Companion_getInstance_10().v7i_1;
    return g_hz[h.h1(2) >> 2 & 3] >> toInt_0((h.h1(1) & 8) === 0, this) >> toInt_0((h.h1(1) & 16) === 0, this);
  }
  j7f(h) {
    return (h.h1(1) & 6) === 6 ? 384 : 1152 >> toInt_0((h.h1(1) & 14) === 2, this);
  }
  k7f(h, free_format_size) {
    var frame_bytes = imul(imul(this.j7f(h), this.h7f(h)), 125) / this.i7f(h) | 0;
    if ((h.h1(1) & 6) === 6) {
      frame_bytes = frame_bytes & -4;
    }
    return !(frame_bytes === 0) ? frame_bytes : free_format_size;
  }
  l7f(h) {
    return !((h.h1(2) & 2) === 0) ? (h.h1(1) & 6) === 6 ? 4 : 1 : 0;
  }
  m7f(hdr, sci) {
    var alloc = Companion_getInstance_10().k7j_1;
    var mode = hdr.h1(3) >> 6 & 3;
    var nbands;
    var stereo_bands;
    switch (mode) {
      case 3:
        stereo_bands = 0;
        break;
      case 1:
        stereo_bands = ((hdr.h1(3) >> 4 & 3) << 2) + 4 | 0;
        break;
      default:
        stereo_bands = 32;
        break;
    }
    if ((hdr.h1(1) & 6) === 6) {
      alloc = Companion_getInstance_10().k7j_1;
      nbands = 32;
    } else if ((hdr.h1(1) & 8) === 0) {
      alloc = Companion_getInstance_10().l7j_1;
      nbands = 30;
    } else {
      var sample_rate_idx = hdr.h1(2) >> 2 & 3;
      var kbps = this.h7f(hdr) >> toInt_0(!(mode === 3), this);
      if (kbps === 0)
        kbps = 192;
      alloc = Companion_getInstance_10().m7j_1;
      nbands = 27;
      if (kbps < 56) {
        alloc = Companion_getInstance_10().n7j_1;
        nbands = sample_rate_idx === 2 ? 12 : 8;
      } else if (kbps >= 96 && !(sample_rate_idx === 1)) {
        nbands = 30;
      }
    }
    sci.m7l_1 = nbands;
    sci.n7l_1 = stereo_bands > nbands ? nbands : stereo_bands;
    return alloc;
  }
  n7f(bs, pba, scfcod, bands, scf) {
    var scfOffset = 0;
    var g_deq_L12 = Companion_getInstance_10().u7i_1;
    var inductionVariable = 0;
    if (inductionVariable < bands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s = 0.0;
        var ba = UByteArrayInt__get_impl_px6q8a(pba, i);
        var mask = !(ba === 0) ? 4 + (19 >> UByteArrayInt__get_impl_px6q8a(scfcod, i) & 3) | 0 : 0;
        var m = 4;
        while (!(m === 0)) {
          if (!((mask & m) === 0)) {
            var b = this.e7f(bs, 6);
            s = g_deq_L12[(imul(ba, 3) - 6 | 0) + (b % 3 | 0) | 0] * (2097152 >> (b / 3 | 0));
          }
          scf.p7k(scfOffset, s);
          m = m >> 1;
          scfOffset = scfOffset + 1 | 0;
        }
      }
       while (inductionVariable < bands);
  }
  o7f(hdr, bs, sci) {
    var g_bitalloc_code_tab = new UByteArrayIntPtr(Companion_getInstance_10().f7j_1);
    var subband_alloc = this.m7f(hdr, sci);
    var subband_alloc_n = 0;
    var k = 0;
    var ba_bits = 0;
    var ba_code_tab = g_bitalloc_code_tab;
    var inductionVariable = 0;
    var last = sci.m7l_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ba = 0;
        if (i === k) {
          var tmp = k;
          // Inline function 'kotlin.UByte.toInt' call
          var this_0 = subband_alloc[subband_alloc_n].r7j_1;
          k = tmp + (_UByte___get_data__impl__jof9qr(this_0) & 255) | 0;
          // Inline function 'kotlin.UByte.toInt' call
          var this_1 = subband_alloc[subband_alloc_n].q7j_1;
          ba_bits = _UByte___get_data__impl__jof9qr(this_1) & 255;
          // Inline function 'kotlin.UByte.toInt' call
          var this_2 = subband_alloc[subband_alloc_n].p7j_1;
          var tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
          ba_code_tab = g_bitalloc_code_tab.h7k(tmp$ret$2);
          subband_alloc_n = subband_alloc_n + 1 | 0;
        }
        ba = ba_code_tab.h1(this.e7f(bs, ba_bits));
        UByteArrayInt__set_impl_gn4532(sci.o7l_1, imul(2, i), ba);
        if (i < sci.n7l_1) {
          ba = ba_code_tab.h1(this.e7f(bs, ba_bits));
        }
        UByteArrayInt__set_impl_gn4532(sci.o7l_1, imul(2, i) + 1 | 0, !(sci.n7l_1 === 0) ? ba : 0);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = imul(2, sci.m7l_1);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.p7l_1, i_0, !(UByteArrayInt__get_impl_px6q8a(sci.o7l_1, i_0) === 0) ? (hdr.h1(1) & 6) === 6 ? 2 : this.e7f(bs, 2) : 6);
      }
       while (inductionVariable_0 < last_0);
    this.n7f(bs, sci.o7l_1, sci.p7l_1, imul(sci.m7l_1, 2), new FloatArrayPtr(sci.l7l_1));
    var inductionVariable_1 = sci.n7l_1;
    var last_1 = sci.m7l_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.o7l_1, imul(2, i_1) + 1 | 0, 0);
      }
       while (inductionVariable_1 < last_1);
  }
  p7f(grbuf, bs, sci, group_size) {
    var choff = 576;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dst = grbuf.h7k(imul(group_size, j));
        var inductionVariable_0 = 0;
        var last = imul(2, sci.m7l_1);
        if (inductionVariable_0 < last)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ba = UByteArrayInt__get_impl_px6q8a(sci.o7l_1, i);
            if (!(ba === 0)) {
              if (ba < 17) {
                var half = (1 << (ba - 1 | 0)) - 1 | 0;
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < group_size)
                  do {
                    var k = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    dst.p7k(k, this.e7f(bs, ba) - half | 0);
                  }
                   while (inductionVariable_1 < group_size);
              } else {
                var mod = (2 << (ba - 17 | 0)) + 1 | 0;
                var code = this.e7f(bs, (mod + 2 | 0) - (mod >> 3) | 0);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < group_size)
                  do {
                    var k_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    dst.p7k(k_0, (code % mod | 0) - (mod / 2 | 0) | 0);
                    code = code / mod | 0;
                  }
                   while (inductionVariable_2 < group_size);
              }
            }
            dst = dst.h7k(choff);
            choff = 18 - choff | 0;
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < 4);
    return imul(group_size, 4);
  }
  q7f(sci, scf, dst) {
    var scf_0 = scf;
    var dst_0 = dst;
    this.b7f(dst_0.h7k(576).h7k(imul(sci.n7l_1, 18)), dst_0.h7k(imul(sci.n7l_1, 18)), imul(sci.m7l_1 - sci.n7l_1 | 0, 18));
    var inductionVariable = 0;
    var last = sci.m7l_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 12)
          do {
            var k = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            dst_0.p7k(k + 0 | 0, dst_0.h1(k + 0 | 0) * scf_0.h1(0));
            dst_0.p7k(k + 576 | 0, dst_0.h1(k + 576 | 0) * scf_0.h1(3));
          }
           while (inductionVariable_0 < 12);
        dst_0 = dst_0.h7k(18);
        scf_0 = scf_0.h7k(6);
      }
       while (inductionVariable < last);
  }
  r7f(bs, gr, hdr) {
    var gr_0 = gr;
    var g_scf_long = Companion_getInstance_10().g7j_1;
    var g_scf_short = Companion_getInstance_10().h7j_1;
    var g_scf_mixed = Companion_getInstance_10().i7j_1;
    var tables;
    var scfsi = 0;
    var main_data_begin;
    var part_23_sum = 0;
    var sr_idx = (hdr.h1(2) >> 2 & 3) + imul((hdr.h1(1) >> 3 & 1) + (hdr.h1(1) >> 4 & 1) | 0, 3) | 0;
    sr_idx = sr_idx - toInt_0(!(sr_idx === 0), this) | 0;
    var gr_count = (hdr.h1(3) & 192) === 192 ? 1 : 2;
    if (!((hdr.h1(1) & 8) === 0)) {
      gr_count = imul(gr_count, 2);
      main_data_begin = this.e7f(bs, 9);
      scfsi = this.e7f(bs, 7 + gr_count | 0);
    } else {
      main_data_begin = this.e7f(bs, 8 + gr_count | 0) >> gr_count;
    }
    $l$1: do {
      $l$0: do {
        if ((hdr.h1(3) & 192) === 192) {
          scfsi = scfsi << 4;
        }
        gr_0.w1().w7k_1 = this.e7f(bs, 12);
        part_23_sum = part_23_sum + gr_0.w1().w7k_1 | 0;
        gr_0.w1().x7k_1 = this.e7f(bs, 9);
        if (gr_0.w1().x7k_1 > 288)
          return -1;
        gr_0.w1().z7k_1 = this.e7f(bs, 8);
        gr_0.w1().y7k_1 = this.e7f(bs, !((hdr.h1(1) & 8) === 0) ? 4 : 9);
        gr_0.w1().v7k_1 = new UByteArrayIntPtr(g_scf_long[sr_idx].e2c_1);
        gr_0.w1().c7l_1 = 22;
        gr_0.w1().d7l_1 = 0;
        if (!(this.e7f(bs, 1) === 0)) {
          gr_0.w1().a7l_1 = this.e7f(bs, 2);
          if (gr_0.w1().a7l_1 === 0)
            return -1;
          gr_0.w1().b7l_1 = this.e7f(bs, 1);
          UByteArrayInt__set_impl_gn4532_0(gr_0.w1().f7l_1, 0, _UByte___init__impl__g9hnc4(7));
          UByteArrayInt__set_impl_gn4532(gr_0.w1().f7l_1, 1, 255);
          if (gr_0.w1().a7l_1 === 2) {
            scfsi = scfsi & 3855;
            if (gr_0.w1().b7l_1 === 0) {
              UByteArrayInt__set_impl_gn4532(gr_0.w1().f7l_1, 0, 8);
              gr_0.w1().v7k_1 = new UByteArrayIntPtr(g_scf_short[sr_idx].e2c_1);
              gr_0.w1().c7l_1 = 0;
              gr_0.w1().d7l_1 = 39;
            } else {
              gr_0.w1().v7k_1 = new UByteArrayIntPtr(g_scf_mixed[sr_idx].e2c_1);
              gr_0.w1().c7l_1 = !((hdr.h1(1) & 8) === 0) ? 8 : 6;
              gr_0.w1().d7l_1 = 30;
            }
          }
          tables = this.e7f(bs, 10);
          tables = tables << 5;
          UByteArrayInt__set_impl_gn4532(gr_0.w1().g7l_1, 0, this.e7f(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.w1().g7l_1, 1, this.e7f(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.w1().g7l_1, 2, this.e7f(bs, 3));
        } else {
          gr_0.w1().a7l_1 = 0;
          gr_0.w1().b7l_1 = 0;
          tables = this.e7f(bs, 15);
          UByteArrayInt__set_impl_gn4532(gr_0.w1().f7l_1, 0, this.e7f(bs, 4));
          UByteArrayInt__set_impl_gn4532(gr_0.w1().f7l_1, 1, this.e7f(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.w1().f7l_1, 2, 255);
        }
        UByteArrayInt__set_impl_gn4532(gr_0.w1().e7l_1, 0, tables >> 10);
        UByteArrayInt__set_impl_gn4532(gr_0.w1().e7l_1, 1, tables >> 5 & 31);
        UByteArrayInt__set_impl_gn4532(gr_0.w1().e7l_1, 2, tables & 31);
        gr_0.w1().h7l_1 = !((hdr.h1(1) & 8) === 0) ? this.e7f(bs, 1) : toInt_0(gr_0.w1().y7k_1 >= 500, this);
        gr_0.w1().i7l_1 = this.e7f(bs, 1);
        gr_0.w1().j7l_1 = this.e7f(bs, 1);
        gr_0.w1().k7l_1 = scfsi >> 12 & 15;
        scfsi = scfsi << 4;
        gr_0 = gr_0.a4();
      }
       while (false);
      gr_count = gr_count - 1 | 0;
    }
     while (!(gr_count === 0));
    if ((part_23_sum + bs.u7j_1 | 0) > (bs.v7j_1 + imul(main_data_begin, 8) | 0))
      return -1;
    return main_data_begin;
  }
  s7f(scf, ist_pos, scf_size, scf_count, bitbuf, scfsi) {
    var scf_0 = scf;
    var ist_pos_0 = new UByteArrayIntPtr(ist_pos);
    var scfsi_0 = scfsi;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (scf_count.h1(i) === 0)
          break $l$loop;
        var cnt = scf_count.h1(i);
        if (!((scfsi_0 & 8) === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < cnt)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              scf_0.w3w(n, ist_pos_0.h1(n));
            }
             while (inductionVariable_0 < cnt);
        } else {
          var bits = UByteArrayInt__get_impl_px6q8a(scf_size, i);
          if (bits === 0) {
            scf_0.l7k(_UByte___init__impl__g9hnc4(0), 0, cnt);
            ist_pos_0.l7k(_UByte___init__impl__g9hnc4(0), 0, cnt);
          } else {
            var max_scf = (scfsi_0 < 0 ? toLong((1 << bits) - 1 | 0) : new Long(-1, -1)).l2();
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < cnt)
              do {
                var k = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var s = this.e7f(bitbuf, bits);
                ist_pos_0.w3w(k, (s === max_scf ? new Long(-1, -1) : toLong(s)).l2());
                scf_0.w3w(k, s);
              }
               while (inductionVariable_1 < cnt);
          }
        }
        ist_pos_0 = ist_pos_0.h7k(cnt);
        scf_0 = scf_0.h7k(cnt);
        scfsi_0 = imul(scfsi_0, 2);
      }
       while (inductionVariable < 4);
    scf_0.w3w(0, 0);
    scf_0.w3w(1, 0);
    scf_0.w3w(2, 0);
  }
  t7f(y, exp_q2) {
    var y_0 = y;
    var exp_q2_0 = exp_q2;
    var g_expfrac = Companion_getInstance_10().t7i_1;
    do {
      var e = 120 > exp_q2_0 ? exp_q2_0 : 120;
      y_0 = y_0 * (g_expfrac[e & 3] * (1073741824 >> (e >> 2)));
      exp_q2_0 = exp_q2_0 - e | 0;
    }
     while (exp_q2_0 > 0);
    return y_0;
  }
  u7f(hdr, ist_pos, bs, gr, scf, ch) {
    var g_scf_partitions = Companion_getInstance_10().j7j_1;
    var scf_partition = new UByteArrayIntPtr(g_scf_partitions[toInt_0(!(gr.w1().d7l_1 === 0), this) + toInt_0(gr.w1().c7l_1 === 0, this) | 0].e2c_1);
    var scf_size = _UByteArrayInt___init__impl__xif7bu_1(4);
    var iscf = _UByteArrayInt___init__impl__xif7bu_1(40);
    var scf_shift = gr.w1().i7l_1 + 1 | 0;
    var scfsi = gr.w1().k7l_1;
    if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
      var g_scfc_decode = Companion_getInstance_10().x7i_1;
      var part = UByteArrayInt__get_impl_px6q8a(g_scfc_decode, gr.w1().y7k_1);
      UByteArrayInt__set_impl_gn4532(scf_size, 0, part >> 2);
      UByteArrayInt__set_impl_gn4532(scf_size, 1, UByteArrayInt__get_impl_px6q8a(scf_size, 0));
      UByteArrayInt__set_impl_gn4532(scf_size, 2, part & 3);
      UByteArrayInt__set_impl_gn4532(scf_size, 3, UByteArrayInt__get_impl_px6q8a(scf_size, 2));
    } else {
      var g_mod = Companion_getInstance_10().y7i_1;
      var ist = toInt_0(!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 16) === 0) && !(ch === 0), this);
      var sfc = gr.w1().y7k_1 >> ist;
      var k = imul(imul(ist, 3), 4);
      while (sfc >= 0) {
        var modprod = 1;
        var inductionVariable = 3;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            UByteArrayInt__set_impl_gn4532(scf_size, i, (sfc / modprod | 0) % UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0) | 0);
            modprod = imul(modprod, UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0));
          }
           while (0 <= inductionVariable);
        sfc = sfc - modprod | 0;
        k = k + 4 | 0;
      }
      scf_partition = scf_partition.h7k(k);
      scfsi = -16;
    }
    this.s7f(new UByteArrayIntPtr(iscf), ist_pos, scf_size, scf_partition, bs, scfsi);
    if (!(gr.w1().d7l_1 === 0)) {
      var sh = 3 - scf_shift | 0;
      var progression = step(until(0, gr.w1().d7l_1), 3);
      var inductionVariable_0 = progression.f2_1;
      var last = progression.g2_1;
      var step_0 = progression.h2_1;
      if (step_0 > 0 && inductionVariable_0 <= last || (step_0 < 0 && last <= inductionVariable_0))
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          UByteArrayInt__set_impl_gn4532(iscf, (gr.w1().c7l_1 + i_0 | 0) + 0 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.w1().c7l_1 + i_0 | 0) + 0 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.w1().g7l_1, 0) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.w1().c7l_1 + i_0 | 0) + 1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.w1().c7l_1 + i_0 | 0) + 1 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.w1().g7l_1, 1) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.w1().c7l_1 + i_0 | 0) + 2 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.w1().c7l_1 + i_0 | 0) + 2 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.w1().g7l_1, 2) << sh) | 0);
        }
         while (!(i_0 === last));
    } else {
      if (!(gr.w1().h7l_1 === 0)) {
        var g_preamp = Companion_getInstance_10().z7i_1;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 10)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(iscf, 11 + i_1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, 11 + i_1 | 0) + UByteArrayInt__get_impl_px6q8a(g_preamp, i_1) | 0);
          }
           while (inductionVariable_1 < 10);
      }
    }
    var gain_exp = (numberToLong(gr.w1().z7k_1).w3(new Long(-4, -1)).l2() - 210 | 0) - ((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 224) === 96 ? 2 : 0) | 0;
    var gain = this.t7f(2048, (new Long(44, 0)).c2(toLong(gain_exp)).l2());
    var inductionVariable_2 = 0;
    var last_0 = gr.w1().c7l_1 + gr.w1().d7l_1 | 0;
    if (inductionVariable_2 < last_0)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        scf.p7k(i_2, this.t7f(gain, UByteArrayInt__get_impl_px6q8a(iscf, i_2) << scf_shift));
      }
       while (inductionVariable_2 < last_0);
  }
  v7f(x) {
    var x_0 = x;
    var mult = 256;
    if (x_0 < 129)
      return Companion_getInstance_10().o7j_1[16 + x_0 | 0];
    if (x_0 < 1024) {
      mult = 16;
      x_0 = x_0 << 3;
    }
    var sign = imul(2, x_0) & 64;
    var frac = ((x_0 & 63) - sign | 0) / ((x_0 & -64) + sign | 0);
    return Companion_getInstance_10().o7j_1[16 + ((x_0 + sign | 0) >> 6) | 0] * (1.0 + frac * (4.0 / 3.0 + frac * (2.0 / 9.0))) * mult;
  }
  w7f(dst, bs, gr_info, scf, layer3gr_limit) {
    var dst_0 = dst;
    var scf_0 = scf;
    var tabs = Companion_getInstance_10().a7j_1;
    var tab32 = Companion_getInstance_10().b7j_1;
    var tab33 = Companion_getInstance_10().c7j_1;
    var tabindex = Companion_getInstance_10().d7j_1;
    var g_linbits = Companion_getInstance_10().e7j_1;
    var one = 0.0;
    var ireg = 0;
    var big_val_cnt = gr_info.w1().x7k_1;
    var sfb = gr_info.w1().v7k_1;
    var bs_next_ptr = bs.t7j_1.h7k(bs.u7j_1 / 8 | 0);
    // Inline function 'kotlin.toUInt' call
    var this_0 = (imul(imul(imul(bs_next_ptr.h1(0), 256) + bs_next_ptr.h1(1) | 0, 256) + bs_next_ptr.h1(2) | 0, 256) + bs_next_ptr.h1(3) | 0) << (bs.u7j_1 & 7);
    var bs_cache = _UInt___init__impl__l7qpdl(this_0);
    var pairs_to_decode = 0;
    var np = 0;
    var bs_sh = (bs.u7j_1 & 7) - 8 | 0;
    bs_next_ptr = bs_next_ptr.h7k(4);
    while (big_val_cnt > 0) {
      var tab_num = UByteArrayInt__get_impl_px6q8a(gr_info.w1().e7l_1, ireg);
      var tmp = gr_info.w1().f7l_1;
      var _unary__edvuaz = ireg;
      ireg = _unary__edvuaz + 1 | 0;
      var sfb_cnt = UByteArrayInt__get_impl_px6q8a(tmp, _unary__edvuaz);
      var codebook = tabindex[tab_num];
      var linbits = UByteArrayInt__get_impl_px6q8a(g_linbits, tab_num);
      if (!(linbits === 0)) {
        $l$3: do {
          $l$2: do {
            np = sfb.w1() / 2 | 0;
            sfb = sfb.a4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_0 = scf_0;
            scf_0 = _unary__edvuaz_0.a4();
            one = _unary__edvuaz_0.w1();
            $l$1: do {
              $l$0: do {
                var w = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_1 = bs_cache;
                var bitCount = 32 - w | 0;
                var this_2 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> bitCount | 0);
                var leaf = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_2) | 0];
                while (leaf < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_3 = bs_cache;
                  var bitCount_0 = w;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) << bitCount_0);
                  bs_sh = bs_sh + w | 0;
                  w = leaf & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_4 = bs_cache;
                  var bitCount_1 = 32 - w | 0;
                  var this_5 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> bitCount_1 | 0);
                  leaf = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_5) | 0) - (leaf >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_6 = bs_cache;
                var bitCount_2 = leaf >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_6) << bitCount_2);
                bs_sh = bs_sh + (leaf >> 8) | 0;
                var inductionVariable = 0;
                if (inductionVariable < 2)
                  do {
                    var j = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var lsb = leaf & 15;
                    if (lsb === 15) {
                      var tmp_0 = lsb;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_7 = bs_cache;
                      var bitCount_3 = 32 - linbits | 0;
                      var this_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_7) >>> bitCount_3 | 0);
                      lsb = tmp_0 + _UInt___get_data__impl__f0vqqw(this_8) | 0;
                      // Inline function 'kotlin.UInt.shl' call
                      var this_9 = bs_cache;
                      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_9) << linbits);
                      bs_sh = bs_sh + linbits | 0;
                      while (bs_sh >= 0) {
                        // Inline function 'kotlin.UInt.or' call
                        var this_10 = bs_cache;
                        // Inline function 'kotlin.toUInt' call
                        var this_11 = bs_next_ptr.w1() << bs_sh;
                        var other = _UInt___init__impl__l7qpdl(this_11);
                        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_10) | _UInt___get_data__impl__f0vqqw(other));
                        bs_next_ptr = bs_next_ptr.a4();
                        bs_sh = bs_sh - 8 | 0;
                      }
                      var tmp_1 = dst_0;
                      var tmp_2 = one * this.v7f(lsb);
                      var tmp_3;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_12 = bs_cache;
                      if (_UInt___get_data__impl__f0vqqw(this_12) < 0) {
                        tmp_3 = new Long(-1, -1);
                      } else {
                        tmp_3 = new Long(1, 0);
                      }
                      tmp_1.o7k(tmp_2 * tmp_3.m4());
                    } else {
                      var tmp_4 = dst_0;
                      var tmp_5 = Companion_getInstance_10().o7j_1;
                      var tmp_6 = 16 + lsb | 0;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_13 = bs_cache;
                      var this_14 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_13) >>> 31 | 0);
                      var tmp$ret$14 = _UInt___get_data__impl__f0vqqw(this_14);
                      tmp_4.o7k(tmp_5[tmp_6 - imul(16, tmp$ret$14) | 0] * one);
                    }
                    // Inline function 'kotlin.UInt.shl' call
                    var this_15 = bs_cache;
                    var bitCount_4 = !(lsb === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_15) << bitCount_4);
                    bs_sh = bs_sh + (!(lsb === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.a4();
                    leaf = leaf >> 4;
                  }
                   while (inductionVariable < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_16 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_17 = bs_next_ptr.w1() << bs_sh;
                  var other_0 = _UInt___init__impl__l7qpdl(this_17);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_16) | _UInt___get_data__impl__f0vqqw(other_0));
                  bs_next_ptr = bs_next_ptr.a4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_7;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_7 = sfb_cnt >= 0;
          } else {
            tmp_7 = false;
          }
        }
         while (tmp_7);
      } else {
        $l$7: do {
          $l$6: do {
            np = sfb.w1() / 2 | 0;
            sfb = sfb.a4();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_1 = scf_0;
            scf_0 = _unary__edvuaz_1.a4();
            one = _unary__edvuaz_1.w1();
            $l$5: do {
              $l$4: do {
                var w_0 = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_18 = bs_cache;
                var bitCount_5 = 32 - w_0 | 0;
                var this_19 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_18) >>> bitCount_5 | 0);
                var leaf_0 = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_19) | 0];
                while (leaf_0 < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_20 = bs_cache;
                  var bitCount_6 = w_0;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_20) << bitCount_6);
                  bs_sh = bs_sh + w_0 | 0;
                  w_0 = leaf_0 & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_21 = bs_cache;
                  var bitCount_7 = 32 - w_0 | 0;
                  var this_22 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_21) >>> bitCount_7 | 0);
                  leaf_0 = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_22) | 0) - (leaf_0 >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_23 = bs_cache;
                var bitCount_8 = leaf_0 >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_23) << bitCount_8);
                bs_sh = bs_sh + (leaf_0 >> 8) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < 2)
                  do {
                    var j_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var lsb_0 = leaf_0 & 15;
                    var tmp_8 = dst_0;
                    var tmp_9 = Companion_getInstance_10().o7j_1;
                    var tmp_10 = 16 + lsb_0 | 0;
                    // Inline function 'kotlin.UInt.toInt' call
                    // Inline function 'kotlin.UInt.shr' call
                    var this_24 = bs_cache;
                    var this_25 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_24) >>> 31 | 0);
                    var tmp$ret$25 = _UInt___get_data__impl__f0vqqw(this_25);
                    tmp_8.o7k(tmp_9[tmp_10 - imul(16, tmp$ret$25) | 0] * one);
                    // Inline function 'kotlin.UInt.shl' call
                    var this_26 = bs_cache;
                    var bitCount_9 = !(lsb_0 === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_26) << bitCount_9);
                    bs_sh = bs_sh + (!(lsb_0 === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.a4();
                    leaf_0 = leaf_0 >> 4;
                  }
                   while (inductionVariable_0 < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_27 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_28 = bs_next_ptr.w1() << bs_sh;
                  var other_1 = _UInt___init__impl__l7qpdl(this_28);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_27) | _UInt___get_data__impl__f0vqqw(other_1));
                  bs_next_ptr = bs_next_ptr.a4();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_11;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_11 = sfb_cnt >= 0;
          } else {
            tmp_11 = false;
          }
        }
         while (tmp_11);
      }
    }
    np = 1 - big_val_cnt | 0;
    $l$loop_1: while (true) {
      var codebook_count1 = !(gr_info.w1().j7l_1 === 0) ? tab33 : tab32;
      // Inline function 'kotlin.UInt.toInt' call
      // Inline function 'kotlin.UInt.shr' call
      var this_29 = bs_cache;
      var this_30 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_29) >>> 28 | 0);
      var tmp$ret$30 = _UInt___get_data__impl__f0vqqw(this_30);
      var leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp$ret$30);
      if ((leaf_1 & 8) === 0) {
        var tmp_12 = leaf_1 >> 3;
        // Inline function 'kotlin.UInt.toInt' call
        // Inline function 'kotlin.UInt.shr' call
        // Inline function 'kotlin.UInt.shl' call
        var this_31 = bs_cache;
        var this_32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_31) << 4);
        var bitCount_10 = 32 - (leaf_1 & 3) | 0;
        var this_33 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_32) >>> bitCount_10 | 0);
        var tmp$ret$33 = _UInt___get_data__impl__f0vqqw(this_33);
        leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp_12 + tmp$ret$33 | 0);
      }
      // Inline function 'kotlin.UInt.shl' call
      var this_34 = bs_cache;
      var bitCount_11 = leaf_1 & 7;
      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_34) << bitCount_11);
      bs_sh = bs_sh + (leaf_1 & 7) | 0;
      if (((imul(bs_next_ptr.k7k(bs.t7j_1), 8) - 24 | 0) + bs_sh | 0) > layer3gr_limit) {
        break $l$loop_1;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.w1() / 2 | 0;
        sfb = sfb.a4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_2 = scf_0;
        scf_0 = _unary__edvuaz_2.a4();
        one = _unary__edvuaz_2.w1();
      }
      if (!((leaf_1 & 128) === 0)) {
        var tmp_13 = dst_0;
        var tmp_14;
        // Inline function 'kotlin.UInt.toInt' call
        var this_35 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_35) < 0) {
          tmp_14 = -one;
        } else {
          tmp_14 = one;
        }
        tmp_13.p7k(0, tmp_14);
        // Inline function 'kotlin.UInt.shl' call
        var this_36 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_36) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 64) === 0)) {
        var tmp_15 = dst_0;
        var tmp_16;
        // Inline function 'kotlin.UInt.toInt' call
        var this_37 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_37) < 0) {
          tmp_16 = -one;
        } else {
          tmp_16 = one;
        }
        tmp_15.p7k(1, tmp_16);
        // Inline function 'kotlin.UInt.shl' call
        var this_38 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_38) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.w1() / 2 | 0;
        sfb = sfb.a4();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_3 = scf_0;
        scf_0 = _unary__edvuaz_3.a4();
        one = _unary__edvuaz_3.w1();
      }
      if (!((leaf_1 & 32) === 0)) {
        var tmp_17 = dst_0;
        var tmp_18;
        // Inline function 'kotlin.UInt.toInt' call
        var this_39 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_39) < 0) {
          tmp_18 = -one;
        } else {
          tmp_18 = one;
        }
        tmp_17.p7k(2, tmp_18);
        // Inline function 'kotlin.UInt.shl' call
        var this_40 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_40) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 16) === 0)) {
        var tmp_19 = dst_0;
        var tmp_20;
        // Inline function 'kotlin.UInt.toInt' call
        var this_41 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_41) < 0) {
          tmp_20 = -one;
        } else {
          tmp_20 = one;
        }
        tmp_19.p7k(3, tmp_20);
        // Inline function 'kotlin.UInt.shl' call
        var this_42 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_42) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      while (bs_sh >= 0) {
        // Inline function 'kotlin.UInt.or' call
        var this_43 = bs_cache;
        // Inline function 'kotlin.toUInt' call
        var this_44 = bs_next_ptr.w1() << bs_sh;
        var other_2 = _UInt___init__impl__l7qpdl(this_44);
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_43) | _UInt___get_data__impl__f0vqqw(other_2));
        bs_next_ptr = bs_next_ptr.a4();
        bs_sh = bs_sh - 8 | 0;
      }
      dst_0 = dst_0.h7k(4);
    }
    bs.u7j_1 = layer3gr_limit;
  }
  x7f(left, n) {
    var right = left.h7k(576);
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = left.h1(i);
        var b = right.h1(i);
        left.p7k(i, a + b);
        right.p7k(i, a - b);
      }
       while (inductionVariable < n);
  }
  y7f(left, n, kl, kr) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        left.p7k(i + 576 | 0, left.h1(i) * kr);
        left.p7k(i, left.h1(i) * kl);
      }
       while (inductionVariable < n);
  }
  z7f(right, sfb, nbands, max_band) {
    var right_0 = right;
    max_band[0] = -1;
    max_band[1] = -1;
    max_band[2] = -1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        $l$loop: while (k < sfb.h1(i)) {
          if (!(right_0.h1(k) === 0.0) || !(right_0.h1(k + 1 | 0) === 0.0)) {
            max_band[i % 3 | 0] = i;
            break $l$loop;
          }
          k = k + 2 | 0;
        }
        right_0 = right_0.h7k(sfb.h1(i));
      }
       while (inductionVariable < nbands);
  }
  a7g(left, ist_pos, sfb, hdr, max_band, mpeg2_sh) {
    var left_0 = left;
    var g_pan = Companion_getInstance_10().p7i_1;
    var max_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 7 : 64;
    var i = 0;
    while (!(sfb.h1(i) === 0)) {
      var ipos = UByteArrayInt__get_impl_px6q8a(ist_pos, i);
      if (i > max_band[i % 3 | 0] && ipos < max_pos) {
        var kl;
        var kr;
        var s = !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0) ? 1.4142135 : 1.0;
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
          kl = g_pan[imul(2, ipos) + 0 | 0];
          kr = g_pan[imul(2, ipos) + 1 | 0];
        } else {
          kl = 1.0;
          kr = this.t7f(1.0, (ipos + 1 | 0) >> 1 << mpeg2_sh);
          if (!((ipos & 1) === 0)) {
            kl = kr;
            kr = 1.0;
          }
        }
        this.y7f(left_0, sfb.h1(i), kl * s, kr * s);
      } else {
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0)) {
          this.x7f(left_0, sfb.h1(i));
        }
      }
      left_0 = left_0.h7k(sfb.h1(i));
      i = i + 1 | 0;
    }
  }
  b7g(left, ist_pos, gr, hdr) {
    var max_band = this.v7d_1;
    var n_sfb = gr.w1().c7l_1 + gr.w1().d7l_1 | 0;
    var max_blocks = !(gr.w1().d7l_1 === 0) ? 3 : 1;
    this.z7f(left.h7k(576), gr.w1().v7k_1, n_sfb, max_band);
    if (!(gr.w1().c7l_1 === 0)) {
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.math.max' call
      var a = max_band[0];
      var b = max_band[1];
      var a_0 = Math.max(a, b);
      var b_0 = max_band[2];
      var v = Math.max(a_0, b_0);
      max_band[0] = v;
      max_band[1] = v;
      max_band[2] = v;
    }
    var inductionVariable = 0;
    if (inductionVariable < max_blocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var default_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 3 : 0;
        var itop = (n_sfb - max_blocks | 0) + i | 0;
        var prev = itop - max_blocks | 0;
        UByteArrayInt__set_impl_gn4532(ist_pos, itop, max_band[i] >= prev ? default_pos : UByteArrayInt__get_impl_px6q8a(ist_pos, prev));
      }
       while (inductionVariable < max_blocks);
    this.a7g(left, ist_pos, gr.w1().v7k_1, hdr, max_band, gr.h1(1).y7k_1 & 1);
  }
  c7g(grbuf, scratch, sfb) {
    var sfb_0 = sfb;
    var i = 0;
    var len = 0;
    var src = grbuf;
    var dst = scratch;
    $l$loop: while (true) {
      len = sfb_0.w1();
      if (len === 0)
        break $l$loop;
      i = 0;
      while (i < len) {
        var _unary__edvuaz = dst;
        dst = _unary__edvuaz.a4();
        _unary__edvuaz.o7k(src.h1(imul(0, len)));
        var _unary__edvuaz_0 = dst;
        dst = _unary__edvuaz_0.a4();
        _unary__edvuaz_0.o7k(src.h1(imul(1, len)));
        var _unary__edvuaz_1 = dst;
        dst = _unary__edvuaz_1.a4();
        _unary__edvuaz_1.o7k(src.h1(imul(2, len)));
        i = i + 1 | 0;
        src = src.a4();
      }
      sfb_0 = sfb_0.h7k(3);
      src = src.h7k(imul(2, len));
    }
    this.b7f(grbuf, scratch, dst.q7k(scratch));
  }
  d7g(grbuf, nbands) {
    var grbuf_0 = grbuf;
    var nbands_0 = nbands;
    var g_aa = Companion_getInstance_10().r7i_1;
    while (nbands_0 > 0) {
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var u = grbuf_0.h1(18 + i | 0);
          var d = grbuf_0.h1(17 - i | 0);
          grbuf_0.p7k(18 + i | 0, u * g_aa[0][i] - d * g_aa[1][i]);
          grbuf_0.p7k(17 - i | 0, u * g_aa[1][i] + d * g_aa[0][i]);
        }
         while (inductionVariable < 8);
      nbands_0 = nbands_0 - 1 | 0;
      grbuf_0 = grbuf_0.h7k(18);
    }
  }
  e7g(y) {
    var s0 = y[0];
    var s2 = y[2];
    var s4 = y[4];
    var s6 = y[6];
    var s8 = y[8];
    var t0 = s0 + s6 * 0.5;
    s0 = s0 - s6;
    var t4 = (s4 + s2) * 0.9396926;
    var t2 = (s8 + s2) * 0.76604444;
    s6 = (s4 - s8) * 0.17364818;
    s4 = s4 + (s8 - s2);
    s2 = s0 - s4 * 0.5;
    y[4] = s4 + s0;
    s8 = t0 - t2 + s6;
    s0 = t0 - t4 + t2;
    s4 = t0 + t4 - s6;
    var s1 = y[1];
    var s3 = y[3];
    var s5 = y[5];
    var s7 = y[7];
    s3 = s3 * 0.8660254;
    t0 = (s5 + s1) * 0.9848077;
    t4 = (s5 - s7) * 0.34202015;
    t2 = (s1 + s7) * 0.64278764;
    s1 = (s1 - s5 - s7) * 0.8660254;
    s5 = t0 - s3 - t2;
    s7 = t4 - s3 - t0;
    s3 = t4 + s3 - t2;
    y[0] = s4 - s7;
    y[1] = s2 + s1;
    y[2] = s0 - s3;
    y[3] = s8 + s5;
    y[5] = s8 - s5;
    y[6] = s0 + s3;
    y[7] = s2 - s1;
    y[8] = s4 + s7;
  }
  f7g(grbuf, overlap, window_0, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_twid9 = Companion_getInstance_10().m7i_1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var co = this.w7d_1;
        var si = this.x7d_1;
        co[0] = -grbuf_0.h1(0);
        si[0] = grbuf_0.h1(17);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            si[8 - imul(2, i) | 0] = grbuf_0.h1(imul(4, i) + 1 | 0) - grbuf_0.h1(imul(4, i) + 2 | 0);
            co[1 + imul(2, i) | 0] = grbuf_0.h1(imul(4, i) + 1 | 0) + grbuf_0.h1(imul(4, i) + 2 | 0);
            si[7 - imul(2, i) | 0] = grbuf_0.h1(imul(4, i) + 4 | 0) - grbuf_0.h1(imul(4, i) + 3 | 0);
            co[2 + imul(2, i) | 0] = -(grbuf_0.h1(imul(4, i) + 3 | 0) + grbuf_0.h1(imul(4, i) + 4 | 0));
          }
           while (inductionVariable_0 < 4);
        this.e7g(co);
        this.e7g(si);
        si[1] = -si[1];
        si[3] = -si[3];
        si[5] = -si[5];
        si[7] = -si[7];
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 9)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var ovl = overlap_0.h1(i_0);
            var sum = co[i_0] * g_twid9[9 + i_0 | 0] + si[i_0] * g_twid9[0 + i_0 | 0];
            overlap_0.p7k(i_0, co[i_0] * g_twid9[0 + i_0 | 0] - si[i_0] * g_twid9[9 + i_0 | 0]);
            grbuf_0.p7k(i_0, ovl * window_0[0 + i_0 | 0] - sum * window_0[9 + i_0 | 0]);
            grbuf_0.p7k(17 - i_0 | 0, ovl * window_0[9 + i_0 | 0] + sum * window_0[0 + i_0 | 0]);
          }
           while (inductionVariable_1 < 9);
        grbuf_0 = grbuf_0.h7k(18);
        overlap_0 = overlap_0.h7k(9);
      }
       while (inductionVariable < nbands);
  }
  g7g(x0, x1, x2, dst) {
    var m1 = x1 * 0.8660254;
    var a1 = x0 - x2 * 0.5;
    dst[1] = x0 + x2;
    dst[0] = a1 + m1;
    dst[2] = a1 - m1;
  }
  h7g(x, dst, overlap) {
    var g_twid3 = Companion_getInstance_10().n7i_1;
    var co = this.y7d_1;
    var si = this.z7d_1;
    this.g7g(-x.h1(0), x.h1(6) + x.h1(3), x.h1(12) + x.h1(9), co);
    this.g7g(x.h1(15), x.h1(12) - x.h1(9), x.h1(6) - x.h1(3), si);
    si[1] = -si[1];
    var inductionVariable = 0;
    if (inductionVariable < 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ovl = overlap.h1(i);
        var sum = co[i] * g_twid3[3 + i | 0] + si[i] * g_twid3[0 + i | 0];
        overlap.p7k(i, co[i] * g_twid3[0 + i | 0] - si[i] * g_twid3[3 + i | 0]);
        dst.p7k(i, ovl * g_twid3[2 - i | 0] - sum * g_twid3[5 - i | 0]);
        dst.p7k(5 - i | 0, ovl * g_twid3[5 - i | 0] + sum * g_twid3[2 - i | 0]);
      }
       while (inductionVariable < 3);
  }
  i7g(grbuf, overlap, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var nbands_0 = nbands;
    while (nbands_0 > 0) {
      var tmp = new FloatArrayPtr(new Float32Array(18));
      this.b7f(tmp, grbuf_0, 18);
      this.b7f(grbuf_0, overlap_0, 6);
      this.h7g(tmp, grbuf_0.h7k(6), overlap_0.h7k(6));
      this.h7g(tmp.h7k(1), grbuf_0.h7k(12), overlap_0.h7k(6));
      this.h7g(tmp.h7k(2), overlap_0, overlap_0.h7k(6));
      nbands_0 = nbands_0 - 1 | 0;
      overlap_0 = overlap_0.h7k(9);
      grbuf_0 = grbuf_0.h7k(18);
    }
  }
  j7g(grbuf) {
    var p = 18;
    var progression = step(until(0, 32), 2);
    var inductionVariable = progression.f2_1;
    var last = progression.g2_1;
    var step_0 = progression.h2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var b = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var progression_0 = step(until(1, 18), 2);
        var inductionVariable_0 = progression_0.f2_1;
        var last_0 = progression_0.g2_1;
        var step_1 = progression_0.h2_1;
        if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var index = p + i | 0;
            grbuf.p7k(index, -grbuf.h1(index));
          }
           while (!(i === last_0));
        p = p + 36 | 0;
      }
       while (!(b === last));
  }
  k7g(grbuf, overlap, block_type, n_long_bands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_mdct_window = Companion_getInstance_10().s7i_1;
    if (!(n_long_bands === 0)) {
      this.f7g(grbuf_0, overlap_0, g_mdct_window[0], n_long_bands);
      grbuf_0 = grbuf_0.h7k(imul(18, n_long_bands));
      overlap_0 = overlap_0.h7k(imul(9, n_long_bands));
    }
    if (block_type === 2) {
      this.i7g(grbuf_0, overlap_0, 32 - n_long_bands | 0);
    } else {
      this.f7g(grbuf_0, overlap_0, g_mdct_window[toInt_0(block_type === 3, this)], 32 - n_long_bands | 0);
    }
  }
  l7g(h, s) {
    var pos = (s.w7j_1.u7j_1 + 7 | 0) / 8 | 0;
    var remains = (s.w7j_1.v7j_1 / 8 | 0) - pos | 0;
    if (remains > 511) {
      pos = pos + (remains - 511 | 0) | 0;
      remains = 511;
    }
    if (remains > 0) {
      this.c7f(new UByteArrayIntPtr(h.t7d_1), s.x7j_1.h7k(pos), remains);
    }
    h.q7d_1 = remains;
  }
  m7g(h, bs, s, main_data_begin) {
    var frame_bytes = (bs.v7j_1 - bs.u7j_1 | 0) / 8 | 0;
    var bytes_have = h.q7d_1 > main_data_begin ? main_data_begin : h.q7d_1;
    this.c7f(s.x7j_1, (new UByteArrayIntPtr(h.t7d_1)).h7k(0 < (h.q7d_1 - main_data_begin | 0) ? h.q7d_1 - main_data_begin | 0 : 0), h.q7d_1 > main_data_begin ? main_data_begin : h.q7d_1);
    this.c7f(s.x7j_1.h7k(bytes_have), bs.t7j_1.h7k(bs.u7j_1 / 8 | 0), frame_bytes);
    this.d7f(s.w7j_1, s.x7j_1, bytes_have + frame_bytes | 0);
    return toInt_0(h.q7d_1 >= main_data_begin, this);
  }
  n7g(h, s, gr_info, nch) {
    var gr_info_0 = gr_info;
    var inductionVariable = 0;
    if (inductionVariable < nch)
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var layer3gr_limit = s.w7j_1.u7j_1 + gr_info_0.h1(ch).w7k_1 | 0;
        this.u7f(h.s7d_1, s.c7k_1[ch].e2c_1, s.w7j_1, gr_info_0.h7k(ch), s.a7k_1, ch);
        this.w7f(s.z7j_1[ch], s.w7j_1, gr_info_0.h7k(ch), s.a7k_1, layer3gr_limit);
      }
       while (inductionVariable < nch);
    if (!((UByteArrayInt__get_impl_px6q8a(h.s7d_1, 3) & 16) === 0)) {
      this.b7g(s.z7j_1[0], s.c7k_1[1].e2c_1, gr_info_0, h.s7d_1);
    } else if ((UByteArrayInt__get_impl_px6q8a(h.s7d_1, 3) & 224) === 96) {
      this.x7f(s.z7j_1[0], 576);
    }
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < nch)
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var aa_bands = 31;
        var n_long_bands = (!(gr_info_0.w1().b7l_1 === 0) ? 2 : 0) << toInt_0(((UByteArrayInt__get_impl_px6q8a(h.s7d_1, 2) >> 2 & 3) + imul((UByteArrayInt__get_impl_px6q8a(h.s7d_1, 1) >> 3 & 1) + (UByteArrayInt__get_impl_px6q8a(h.s7d_1, 1) >> 4 & 1) | 0, 3) | 0) === 2, this);
        if (!(gr_info_0.w1().d7l_1 === 0)) {
          aa_bands = n_long_bands - 1 | 0;
          this.c7g(s.z7j_1[ch_0].h7k(imul(n_long_bands, 18)), s.b7k_1[0], gr_info_0.w1().v7k_1.h7k(gr_info_0.w1().c7l_1));
        }
        this.d7g(s.z7j_1[ch_0], aa_bands);
        this.k7g(s.z7j_1[ch_0], new FloatArrayPtr(h.o7d_1[ch_0]), gr_info_0.w1().a7l_1, n_long_bands);
        this.j7g(s.z7j_1[ch_0]);
        gr_info_0 = gr_info_0.h7k(1);
      }
       while (inductionVariable_0 < nch);
  }
  o7g(grbuf, n) {
    var g_sec = Companion_getInstance_10().o7i_1;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(4), null);
    while (tmp < 4) {
      tmp_0[tmp] = new Float32Array(8);
      tmp = tmp + 1 | 0;
    }
    var t = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = grbuf.h7k(k);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 8)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var x0 = y.h1(imul(i, 18));
            var x1 = y.h1(imul(15 - i | 0, 18));
            var x2 = y.h1(imul(16 + i | 0, 18));
            var x3 = y.h1(imul(31 - i | 0, 18));
            var t0 = x0 + x3;
            var t1 = x1 + x2;
            var t2 = (x1 - x2) * g_sec[imul(3, i) + 0 | 0];
            var t3 = (x0 - x3) * g_sec[imul(3, i) + 1 | 0];
            t[0][i] = t0 + t1;
            t[1][i] = (t0 - t1) * g_sec[imul(3, i) + 2 | 0];
            t[2][i] = t3 + t2;
            t[3][i] = (t3 - t2) * g_sec[imul(3, i) + 2 | 0];
          }
           while (inductionVariable_0 < 8);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 4)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var x = t[i_0];
            var x0_0 = x[0];
            var x1_0 = x[1];
            var x2_0 = x[2];
            var x3_0 = x[3];
            var x4 = x[4];
            var x5 = x[5];
            var x6 = x[6];
            var x7 = x[7];
            var xt = x0_0 - x7;
            x0_0 = x0_0 + x7;
            x7 = x1_0 - x6;
            x1_0 = x1_0 + x6;
            x6 = x2_0 - x5;
            x2_0 = x2_0 + x5;
            x5 = x3_0 - x4;
            x3_0 = x3_0 + x4;
            x4 = x0_0 - x3_0;
            x0_0 = x0_0 + x3_0;
            x3_0 = x1_0 - x2_0;
            x1_0 = x1_0 + x2_0;
            x[0] = x0_0 + x1_0;
            x[4] = (x0_0 - x1_0) * 0.70710677;
            x5 = x5 + x6;
            x6 = (x6 + x7) * 0.70710677;
            x7 = x7 + xt;
            x3_0 = (x3_0 + x4) * 0.70710677;
            x5 = x5 - x7 * 0.19891237;
            x7 = x7 + x5 * 0.38268343;
            x5 = x5 - x7 * 0.19891237;
            x0_0 = xt - x6;
            xt = xt + x6;
            x[1] = (xt + x7) * 0.5097956;
            x[2] = (x4 + x3_0) * 0.5411961;
            x[3] = (x0_0 - x5) * 0.6013449;
            x[5] = (x0_0 + x5) * 0.8999762;
            x[6] = (x4 - x3_0) * 1.306563;
            x[7] = (xt - x7) * 2.5629156;
          }
           while (inductionVariable_1 < 4);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 7)
          do {
            var i_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            y.p7k(0, t[0][i_1]);
            y.p7k(18, t[2][i_1] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y.p7k(36, t[1][i_1] + t[1][i_1 + 1 | 0]);
            y.p7k(54, t[2][i_1 + 1 | 0] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y = y.h7k(72);
          }
           while (inductionVariable_2 < 7);
        y.p7k(0, t[0][7]);
        y.p7k(18, t[2][7] + t[3][7]);
        y.p7k(36, t[1][7]);
        y.p7k(54, t[3][7]);
      }
       while (inductionVariable < n);
  }
  p7g(sample) {
    if (sample >= 32766.5)
      return 32767;
    if (sample <= -32767.5)
      return -32768;
    var s = toShort(numberToInt(sample + 0.5));
    return toShort(s - toInt_0(s < 0, this) | 0);
  }
  q7g(pcm, nch, z) {
    var z_0 = z;
    var a = 0.0;
    a = a + (z_0.h1(896) - z_0.h1(0)) * 29.0;
    a = a + (z_0.h1(64) + z_0.h1(832)) * 213.0;
    a = a + (z_0.h1(768) - z_0.h1(128)) * 459.0;
    a = a + (z_0.h1(192) + z_0.h1(704)) * 2037.0;
    a = a + (z_0.h1(640) - z_0.h1(256)) * 5153.0;
    a = a + (z_0.h1(320) + z_0.h1(576)) * 6574.0;
    a = a + (z_0.h1(512) - z_0.h1(384)) * 37489.0;
    a = a + z_0.h1(448) * 75038.0;
    pcm.u7k(0, this.p7g(a));
    z_0 = z_0.h7k(2);
    a = z_0.h1(896) * 104.0;
    a = a + z_0.h1(768) * 1567.0;
    a = a + z_0.h1(640) * 9727.0;
    a = a + z_0.h1(512) * 64019.0;
    a = a + z_0.h1(384) * -9975.0;
    a = a + z_0.h1(256) * -45.0;
    a = a + z_0.h1(128) * 146.0;
    a = a + z_0.h1(0) * -5.0;
    pcm.u7k(imul(16, nch), this.p7g(a));
  }
  r7g(xl, dstl, nch, lins) {
    var xr = xl.h7k(imul(576, nch - 1 | 0));
    var dstr = dstl.h7k(nch - 1 | 0);
    var g_win = Companion_getInstance_10().q7i_1;
    var zlin = lins.h7k(960);
    var w = 0;
    zlin.p7k(60, xl.h1(288));
    zlin.p7k(61, xr.h1(288));
    zlin.p7k(62, xl.h1(0));
    zlin.p7k(63, xr.h1(0));
    zlin.p7k(124, xl.h1(289));
    zlin.p7k(125, xr.h1(289));
    zlin.p7k(126, xl.h1(1));
    zlin.p7k(127, xr.h1(1));
    this.q7g(dstr, nch, lins.h7k(60).h7k(1));
    this.q7g(dstr.h7k(imul(32, nch)), nch, lins.h7k(60).h7k(64).h7k(1));
    this.q7g(dstl, nch, lins.h7k(60));
    this.q7g(dstl.h7k(imul(32, nch)), nch, lins.h7k(60).h7k(64));
    var inductionVariable = 14;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var a = this.y7d_1;
        var b = this.z7d_1;
        zlin.p7k(imul(4, i), xl.h1(imul(18, 31 - i | 0)));
        zlin.p7k(imul(4, i) + 1 | 0, xr.h1(imul(18, 31 - i | 0)));
        zlin.p7k(imul(4, i) + 2 | 0, xl.h1(1 + imul(18, 31 - i | 0) | 0));
        zlin.p7k(imul(4, i) + 3 | 0, xr.h1(1 + imul(18, 31 - i | 0) | 0));
        zlin.p7k(imul(4, i + 16 | 0), xl.h1(1 + imul(18, 1 + i | 0) | 0));
        zlin.p7k(imul(4, i + 16 | 0) + 1 | 0, xr.h1(1 + imul(18, 1 + i | 0) | 0));
        zlin.p7k(imul(4, i - 16 | 0) + 2 | 0, xl.h1(imul(18, 1 + i | 0)));
        zlin.p7k(imul(4, i - 16 | 0) + 3 | 0, xr.h1(imul(18, 1 + i | 0)));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            b[j] = 0.0;
            a[j] = 0.0;
          }
           while (inductionVariable_0 < 4);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 8)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = w;
            w = _unary__edvuaz + 1 | 0;
            var w0 = g_win[_unary__edvuaz];
            var _unary__edvuaz_0 = w;
            w = _unary__edvuaz_0 + 1 | 0;
            var w1 = g_win[_unary__edvuaz_0];
            var vz = zlin.h7k(imul(4, i) - imul(n, 64) | 0);
            var vy = zlin.h7k(imul(4, i) - imul(15 - n | 0, 64) | 0);
            if ((n % 2 | 0) === 0) {
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < 4)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  b[j_0] = b[j_0] + vz.h1(j_0) * w1 + vy.h1(j_0) * w0;
                  a[j_0] = a[j_0] + vz.h1(j_0) * w0 - vy.h1(j_0) * w1;
                }
                 while (inductionVariable_2 < 4);
            } else {
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < 4)
                do {
                  var j_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  b[j_1] = b[j_1] + (vz.h1(j_1) * w1 + vy.h1(j_1) * w0);
                  a[j_1] = a[j_1] + (vy.h1(j_1) * w1 - vz.h1(j_1) * w0);
                }
                 while (inductionVariable_3 < 4);
            }
          }
           while (inductionVariable_1 < 8);
        dstr.u7k(imul(15 - i | 0, nch), this.p7g(a[1]));
        dstr.u7k(imul(17 + i | 0, nch), this.p7g(b[1]));
        dstl.u7k(imul(15 - i | 0, nch), this.p7g(a[0]));
        dstl.u7k(imul(17 + i | 0, nch), this.p7g(b[0]));
        dstr.u7k(imul(47 - i | 0, nch), this.p7g(a[3]));
        dstr.u7k(imul(49 + i | 0, nch), this.p7g(b[3]));
        dstl.u7k(imul(47 - i | 0, nch), this.p7g(a[2]));
        dstl.u7k(imul(49 + i | 0, nch), this.p7g(b[2]));
      }
       while (0 <= inductionVariable);
  }
  s7g(qmf_state, grbuf, nbands, nch, pcm, lins) {
    var i = 0;
    i = 0;
    while (i < nch) {
      this.o7g(grbuf.h7k(imul(576, i)), nbands);
      i = i + 1 | 0;
    }
    this.b7f(lins, qmf_state, 960);
    i = 0;
    while (i < nbands) {
      this.r7g(grbuf.h7k(i), pcm.h7k(imul(32, imul(nch, i))), nch, lins.h7k(imul(i, 64)));
      i = i + 2 | 0;
    }
    if (nch === 1) {
      i = 0;
      while (i < 960) {
        qmf_state.p7k(i, lins.h1(imul(nbands, 64) + i | 0));
        i = i + 2 | 0;
      }
    } else {
      this.b7f(qmf_state, lins.h7k(imul(nbands, 64)), 960);
    }
  }
  t7g(hdr, mp3_bytes, frame_bytes) {
    var i = 0;
    var inductionVariable = 0;
    if (inductionVariable < 10)
      do {
        var nmatch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        i = i + (this.k7f(hdr.h7k(i), frame_bytes) + this.l7f(hdr.h7k(i)) | 0) | 0;
        if ((i + 4 | 0) > mp3_bytes)
          return toInt_0(nmatch > 0, this);
        if (this.g7f(hdr, hdr.h7k(i)) === 0)
          return 0;
      }
       while (inductionVariable < 10);
    return 1;
  }
  u7g(mp3, mp3_bytes, free_format_bytes, ptr_frame_bytes) {
    var mp3_0 = mp3;
    var i = 0;
    var k = 0;
    i = 0;
    while (i < (mp3_bytes - 4 | 0)) {
      if (this.f7f(mp3_0)) {
        var frame_bytes = this.k7f(mp3_0, free_format_bytes[0]);
        var frame_and_padding = frame_bytes + this.l7f(mp3_0) | 0;
        k = 4;
        $l$loop: while (frame_bytes === 0 && k < 2304 && !((i + imul(2, toInt_0(k < (mp3_bytes - 4 | 0), this)) | 0) === 0)) {
          if (!(this.g7f(mp3_0, mp3_0.h7k(k)) === 0)) {
            var fb = k - this.l7f(mp3_0) | 0;
            var nextfb = fb + this.l7f(mp3_0.h7k(k)) | 0;
            if ((((i + k | 0) + nextfb | 0) + 4 | 0) > mp3_bytes || this.g7f(mp3_0, mp3_0.h7k(k).h7k(nextfb)) === 0) {
              k = k + 1 | 0;
              continue $l$loop;
            }
            frame_and_padding = k;
            frame_bytes = fb;
            free_format_bytes[0] = fb;
          }
          k = k + 1 | 0;
        }
        if (!(frame_bytes === 0) && !((i + toInt_0(frame_and_padding <= mp3_bytes, this) | 0) === 0) && !(this.t7g(mp3_0, mp3_bytes - i | 0, frame_bytes) === 0) || (i === 0 && frame_and_padding === mp3_bytes)) {
          ptr_frame_bytes[0] = frame_and_padding;
          return i;
        }
        free_format_bytes[0] = 0;
      }
      i = i + 1 | 0;
      mp3_0 = mp3_0.h7k(1);
    }
    ptr_frame_bytes[0] = 0;
    return mp3_bytes;
  }
  c7e(dec) {
    UByteArrayInt__set_impl_gn4532(dec.s7d_1, 0, 0);
  }
  u7e(dec, mp3, mp3_bytes, pcm, info) {
    var pcm_0 = pcm;
    var i = 0;
    var frame_size = new Int32Array(1);
    var success = 1;
    var bs_frame = this.b7e_1;
    var scratch = this.a7e_1;
    if (mp3_bytes > 4 && UByteArrayInt__get_impl_px6q8a(dec.s7d_1, 0) === 255 && !(this.g7f(new UByteArrayIntPtr(dec.s7d_1), mp3) === 0)) {
      frame_size[0] = this.k7f(mp3, dec.r7d_1[0]) + this.l7f(mp3) | 0;
      if (!(frame_size[0] === mp3_bytes) && ((frame_size[0] + 4 | 0) > mp3_bytes || this.g7f(mp3, mp3.h7k(frame_size[0])) === 0)) {
        frame_size[0] = 0;
      }
    }
    if (frame_size[0] === 0) {
      dec.q7d_1 = 0;
      dec.r7d_1[0] = 0;
      UByteArrayInt__fill$default_impl_mdydxi(dec.t7d_1, 0);
      UByteArrayInt__fill$default_impl_mdydxi(dec.s7d_1, 0);
      fill_0(dec.p7d_1, 0.0);
      fill_0(dec.o7d_1[0], 0.0);
      fill_0(dec.o7d_1[1], 0.0);
      i = this.u7g(mp3, mp3_bytes, dec.r7d_1, frame_size);
      if (frame_size[0] === 0 || !((i + toInt_0(frame_size[0] > mp3_bytes, this) | 0) === 0)) {
        info.w1().v7e_1 = i;
        return 0;
      }
    }
    var hdr = mp3.h7k(i);
    this.c7f(new UByteArrayIntPtr(dec.s7d_1), hdr, 4);
    info.w1().v7e_1 = i + frame_size[0] | 0;
    info.w1().w7e_1 = i;
    info.w1().x7e_1 = (hdr.h1(3) & 192) === 192 ? 1 : 2;
    info.w1().y7e_1 = this.i7f(hdr);
    info.w1().z7e_1 = 4 - (hdr.h1(1) >> 1 & 3) | 0;
    info.w1().a7f_1 = this.h7f(hdr);
    // Inline function 'kotlin.collections.isEmpty' call
    if (pcm_0.s7k_1.length === 0) {
      return this.j7f(hdr);
    }
    this.d7f(bs_frame, hdr.h7k(4), frame_size[0] - 4 | 0);
    if ((hdr.h1(1) & 1) === 0) {
      this.e7f(bs_frame, 16);
    }
    if (info.w1().z7e_1 === 3) {
      var main_data_begin = this.r7f(bs_frame, scratch.y7j_1, hdr);
      if (main_data_begin < 0 || bs_frame.u7j_1 > bs_frame.v7j_1) {
        this.c7e(dec);
        return 0;
      }
      success = this.m7g(dec, bs_frame, scratch, main_data_begin);
      if (!(success === 0)) {
        var igr = 0;
        while (igr < (!((hdr.h1(1) & 8) === 0) ? 2 : 1)) {
          scratch.z7j_1[0].r7k(0.0, 0, 1152);
          this.n7g(dec, scratch, scratch.y7j_1.h7k(imul(igr, info.w1().x7e_1)), info.w1().x7e_1);
          this.s7g(new FloatArrayPtr(dec.p7d_1), scratch.z7j_1[0], 18, info.w1().x7e_1, pcm_0, scratch.b7k_1[0]);
          igr = igr + 1 | 0;
          pcm_0 = pcm_0.h7k(imul(576, info.w1().x7e_1));
        }
      }
      this.l7g(dec, scratch);
    } else {
      var sci = new ScaleInfo();
      this.o7f(hdr, bs_frame, sci);
      scratch.z7j_1[0].r7k(0.0, 0, 1152);
      i = 0;
      var igr_0 = 0;
      while (igr_0 < 3) {
        i = i + this.p7f(scratch.z7j_1[0].h7k(i), bs_frame, sci, info.w1().z7e_1 | 1) | 0;
        if (12 === i) {
          i = 0;
          this.q7f(sci, (new FloatArrayPtr(sci.l7l_1)).h7k(igr_0), scratch.z7j_1[0]);
          this.s7g(new FloatArrayPtr(dec.p7d_1), scratch.z7j_1[0], 12, info.w1().x7e_1, pcm_0, scratch.b7k_1[0]);
          scratch.z7j_1[0].r7k(0.0, 0, 1152);
          pcm_0 = pcm_0.h7k(imul(384, info.w1().x7e_1));
        }
        if (bs_frame.u7j_1 > bs_frame.v7j_1) {
          this.c7e(dec);
          return 0;
        }
        igr_0 = igr_0 + 1 | 0;
      }
    }
    return imul(success, this.j7f(new UByteArrayIntPtr(dec.s7d_1)));
  }
}
class Minimp3Decoder extends MiniMp3Program {
  constructor() {
    super();
    this.k7d_1 = new Int16Array(9216);
    this.l7d_1 = Mp3Dec.u7d();
    this.m7d_1 = new Mp3FrameInfo();
    this.c7e(this.l7d_1);
    this.n7d_1 = new BaseMp3DecoderInfo();
  }
  d7e() {
    return this.n7d_1;
  }
  e7e(availablePeek) {
    var samples = this.u7e(this.l7d_1, new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu(this.n7d_1.f7e_1)), availablePeek, new ShortArrayPtr(this.k7d_1), this.m7d_1);
    var struct = this.m7d_1;
    this.n7d_1.k7e_1 = struct.x7e_1;
    this.n7d_1.i7e_1 = struct.y7e_1;
    this.n7d_1.j7e_1 = struct.a7f_1;
    this.n7d_1.m7e_1 = struct.v7e_1;
    this.n7d_1.l7e_1 = samples;
    if (this.n7d_1.k7e_1 === 0 || samples <= 0)
      return null;
    return copyOf(this.k7d_1, imul(samples, this.n7d_1.k7e_1));
  }
  p6() {
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_9();
    super(['mp3']);
  }
  w7a(data, props, $completion) {
    return Companion_getInstance_5().w7a(data, props, $completion);
  }
  b7b(data, props, $completion) {
    return createDecoderStream(this, data, props, null, $completion);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
  w7g() {
    return new Minimp3Decoder();
  }
}
class BaseMp3DecoderInfo {
  constructor() {
    this.f7e_1 = new Int8Array(4608);
    this.g7e_1 = new ByteArrayDeque();
    this.h7e_1 = null;
    this.i7e_1 = 0;
    this.j7e_1 = 0;
    this.k7e_1 = 0;
    this.l7e_1 = 0;
    this.m7e_1 = 0;
    this.n7e_1 = 0;
    this.o7e_1 = 0;
    this.p7e_1 = 0;
    this.q7e_1 = 0;
    this.r7e_1 = 0;
    this.s7e_1 = 0;
    this.t7e_1 = 0;
  }
  u1w() {
    var tmp11_safe_receiver = this.h7e_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.h3();
    }
    this.g7e_1.h3();
    this.n7e_1 = 0;
    this.o7e_1 = -1;
    this.q7e_1 = 0;
  }
  x7h(decoder) {
    var availablePeek = this.g7e_1.j2e(this.f7e_1, 0, this.f7e_1.length);
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(this.f7e_1, Companion_getInstance_9().y7h_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var xingIndex = tmp0_elvis_lhs == null ? this.f7e_1.length : tmp0_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(this.f7e_1, Companion_getInstance_9().z7h_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_1 >= 0) {
      tmp_0 = this_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var infoIndex = tmp1_elvis_lhs == null ? this.f7e_1.length : tmp1_elvis_lhs;
    if (xingIndex < this.f7e_1.length || infoIndex < this.f7e_1.length) {
      try {
        // Inline function 'kotlin.math.min' call
        var index = Math.min(xingIndex, infoIndex);
        var data = new FastByteArrayInputStream(this.f7e_1, index);
        data.b26(7);
        if (data.q25() >= 1) {
          var flags = data.l30();
          var FRAMES_FLAG = 1;
          var BYTES_FLAG = 2;
          var TOC_FLAG = 4;
          var VBR_SCALE_FLAG = 8;
          if (hasFlags(flags, FRAMES_FLAG) && data.q25() >= 4) {
            this.r7e_1 = data.p30();
            if (hasFlags(flags, BYTES_FLAG)) {
              data.b26(4);
            }
            if (hasFlags(flags, TOC_FLAG)) {
              data.b26(100);
            }
            if (hasFlags(flags, VBR_SCALE_FLAG)) {
              data.b26(4);
            }
            if (data.q25() >= 1) {
              var info = data.l30();
              if (!(info === 0)) {
                data.b26(20);
                if (data.q25() >= 3) {
                  var t0 = data.l30();
                  var t1 = data.l30();
                  var t2 = data.l30();
                  this.s7e_1 = (t0 << 4 | (t1 >>> 4 | 0)) + 529 | 0;
                  this.t7e_1 = ((t1 & 15) << 8 | t2) - 529 | 0;
                }
              }
            }
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    var buf = decoder.e7e(availablePeek);
    if (!(this.k7e_1 === 0) && (!(this.r7e_1 === 0) || !(this.s7e_1 === 0) || !(this.t7e_1 === 0))) {
      var rpadding = imul(this.t7e_1, this.k7e_1);
      var to_skip = imul(this.s7e_1, this.k7e_1);
      var detected_samples = imul(imul(this.l7e_1, this.r7e_1), this.k7e_1);
      if (detected_samples >= to_skip)
        detected_samples = detected_samples - to_skip | 0;
      if (1 <= rpadding ? rpadding <= detected_samples : false)
        detected_samples = detected_samples - rpadding | 0;
      this.n7e_1 = to_skip + imul(this.l7e_1, this.k7e_1) | 0;
      this.o7e_1 = detected_samples;
      this.p7e_1 = detected_samples / this.k7e_1 | 0;
      this.r7e_1 = 0;
      this.s7e_1 = 0;
      this.t7e_1 = 0;
    }
    if (!(this.k7e_1 === 0) && this.h7e_1 == null) {
      this.h7e_1 = new AudioSamplesDeque(this.k7e_1);
    }
    if (this.l7e_1 > 0) {
      var offset = 0;
      var toRead = imul(this.l7e_1, this.k7e_1);
      if (this.n7e_1 > 0) {
        // Inline function 'kotlin.math.min' call
        var a = this.n7e_1;
        var b = toRead;
        var skipNow = Math.min(a, b);
        offset = offset + skipNow | 0;
        toRead = toRead - skipNow | 0;
        this.n7e_1 = this.n7e_1 - skipNow | 0;
      }
      if (this.o7e_1 >= 0) {
        // Inline function 'kotlin.math.min' call
        var a_0 = toRead;
        var b_0 = this.o7e_1;
        toRead = Math.min(a_0, b_0);
        this.o7e_1 = this.o7e_1 - toRead | 0;
      }
      ensureNotNull(this.h7e_1).a7i(_AudioSampleArray___init__impl__qpxoq0(ensureNotNull(buf)), offset, toRead);
    }
    this.g7e_1.k2e(this.m7e_1);
    if (this.m7e_1 === 0 && this.l7e_1 === 0) {
      return false;
    }
    if (!(this.h7e_1 == null) && ensureNotNull(this.h7e_1).u2d() > 0) {
      return true;
    }
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.y7h_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.z7h_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class AudioStream {
  constructor(rate, channels, name, $box) {
    name = name === VOID ? null : name;
    boxApply(this, $box);
    this.n7h_1 = rate;
    this.o7h_1 = channels;
    this.p7h_1 = name;
    this.q7h_1 = false;
    this.r7h_1 = null;
    this.s7h_1 = new Long(0, 0);
  }
  b7i() {
    return this.q7h_1;
  }
  c7i() {
    return this.r7h_1;
  }
  h7i() {
    // Inline function 'korlibs.time.seconds' call
    var tmp0_elvis_lhs = this.c7i();
    var this_0 = (tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs).n4() / this.n7h_1;
    return toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  d7i() {
    return this.s7h_1;
  }
  i7i() {
    return this.j7i(this.d7i());
  }
  t7h(time) {
    return numberToLong(get_seconds(time) * this.n7h_1);
  }
  j7i(samples) {
    // Inline function 'korlibs.time.seconds' call
    var this_0 = samples.n4() / this.n7h_1;
    return toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  f7i(out, offset, length, $completion) {
    return 0;
  }
  p6() {
    return Unit_instance;
  }
}
class BaseMinimp3AudioFormat$createDecoderStream$2 extends AudioStream {
  constructor($decoder, $mp3SeekingTable, $data, $table, this$0, $dataStartPosition, $props, $box) {
    if ($box === VOID)
      $box = {};
    $box.g7h_1 = $decoder;
    $box.h7h_1 = $mp3SeekingTable;
    $box.i7h_1 = $data;
    $box.j7h_1 = $table;
    $box.k7h_1 = this$0;
    $box.l7h_1 = $dataStartPosition;
    $box.m7h_1 = $props;
    super($decoder.d7e().i7e_1, $decoder.d7e().k7e_1, VOID, $box);
    this.d7h_1 = false;
    var tmp = this;
    // Inline function 'kotlin.takeIf' call
    var this_0 = toLong($decoder.d7e().p7e_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.<no name provided>.totalLengthInSamples.<anonymous>' call
    if (!this_0.equals(new Long(0, 0))) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp10_safe_receiver = $mp3SeekingTable._v;
      tmp_1 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.x7c($decoder.d7e().i7e_1);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.e7h_1 = tmp_1;
    this.f7h_1 = new Long(0, 0);
  }
  b7i() {
    return this.d7h_1;
  }
  c7i() {
    return this.e7h_1;
  }
  d7i() {
    return this.f7h_1;
  }
  e7i(position, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_seek__qhx6y8.bind(VOID, this, position), $completion);
  }
  f7i(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, out, offset, length), $completion);
  }
  p6() {
    this.g7h_1.p6();
  }
  g7i($completion) {
    // Inline function 'kotlin.also' call
    var this_0 = this.i7h_1.z33();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.<no name provided>.clone.<anonymous>' call
    this_0.b33_1 = this.l7h_1;
    return createDecoderStream(this.k7h_1, this_0, this.m7h_1, this.j7h_1, $completion);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_7 = this;
    this.k7i_1 = 2304;
    this.l7i_1 = 511;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.m7i_1 = new Float32Array([0.7372773, 0.7933533, 0.8433915, 0.8870108, 0.9238795, 0.95371693, 0.976296, 0.9914449, 0.99904823, 0.6755902, 0.6087614, 0.53729963, 0.4617486, 0.38268343, 0.3007058, 0.2164396, 0.13052619, 0.04361938]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.n7i_1 = new Float32Array([0.7933533, 0.9238795, 0.9914449, 0.6087614, 0.38268343, 0.13052619]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.o7i_1 = new Float32Array([10.190008, 0.500603, 0.5024193, 3.4076085, 0.50547093, 0.5224986, 2.057781, 0.5154473, 0.56694406, 1.4841646, 0.5310426, 0.6468218, 1.1694399, 0.5531039, 0.7881546, 0.9725682, 0.582935, 1.0606776, 0.8393496, 0.6225041, 1.7224472, 0.7445363, 0.6748083, 5.1011486]);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.p7i_1 = new Float32Array([0.0, 1.0, 0.21132487, 0.7886751, 0.3660254, 0.6339746, 0.5, 0.5, 0.6339746, 0.3660254, 0.7886751, 0.21132487, 1.0, 0.0]);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_3.q7i_1 = new Float32Array([-1.0, 26.0, -31.0, 208.0, 218.0, 401.0, -519.0, 2063.0, 2000.0, 4788.0, -5517.0, 7134.0, 5959.0, 35640.0, -39336.0, 74992.0, -1.0, 24.0, -35.0, 202.0, 222.0, 347.0, -581.0, 2080.0, 1952.0, 4425.0, -5879.0, 7640.0, 5288.0, 33791.0, -41176.0, 74856.0, -1.0, 21.0, -38.0, 196.0, 225.0, 294.0, -645.0, 2087.0, 1893.0, 4063.0, -6237.0, 8092.0, 4561.0, 31947.0, -43006.0, 74630.0, -1.0, 19.0, -41.0, 190.0, 227.0, 244.0, -711.0, 2085.0, 1822.0, 3705.0, -6589.0, 8492.0, 3776.0, 30112.0, -44821.0, 74313.0, -1.0, 17.0, -45.0, 183.0, 228.0, 197.0, -779.0, 2075.0, 1739.0, 3351.0, -6935.0, 8840.0, 2935.0, 28289.0, -46617.0, 73908.0, -1.0, 16.0, -49.0, 176.0, 228.0, 153.0, -848.0, 2057.0, 1644.0, 3004.0, -7271.0, 9139.0, 2037.0, 26482.0, -48390.0, 73415.0, -2.0, 14.0, -53.0, 169.0, 227.0, 111.0, -919.0, 2032.0, 1535.0, 2663.0, -7597.0, 9389.0, 1082.0, 24694.0, -50137.0, 72835.0, -2.0, 13.0, -58.0, 161.0, 224.0, 72.0, -991.0, 2001.0, 1414.0, 2330.0, -7910.0, 9592.0, 70.0, 22929.0, -51853.0, 72169.0, -2.0, 11.0, -63.0, 154.0, 221.0, 36.0, -1064.0, 1962.0, 1280.0, 2006.0, -8209.0, 9750.0, -998.0, 21189.0, -53534.0, 71420.0, -2.0, 10.0, -68.0, 147.0, 215.0, 2.0, -1137.0, 1919.0, 1131.0, 1692.0, -8491.0, 9863.0, -2122.0, 19478.0, -55178.0, 70590.0, -3.0, 9.0, -73.0, 139.0, 208.0, -29.0, -1210.0, 1870.0, 970.0, 1388.0, -8755.0, 9935.0, -3300.0, 17799.0, -56778.0, 69679.0, -3.0, 8.0, -79.0, 132.0, 200.0, -57.0, -1283.0, 1817.0, 794.0, 1095.0, -8998.0, 9966.0, -4533.0, 16155.0, -58333.0, 68692.0, -4.0, 7.0, -85.0, 125.0, 189.0, -83.0, -1356.0, 1759.0, 605.0, 814.0, -9219.0, 9959.0, -5818.0, 14548.0, -59838.0, 67629.0, -4.0, 7.0, -91.0, 117.0, 177.0, -106.0, -1428.0, 1698.0, 402.0, 545.0, -9416.0, 9916.0, -7154.0, 12980.0, -61289.0, 66494.0, -5.0, 6.0, -97.0, 111.0, 163.0, -127.0, -1498.0, 1634.0, 185.0, 288.0, -9585.0, 9838.0, -8540.0, 11455.0, -62684.0, 65290.0]);
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_5 = new Float32Array([0.8574929, 0.881742, 0.94962865, 0.9833146, 0.9955178, 0.9991606, 0.9998992, 0.99999315]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.r7i_1 = [tmp_5, new Float32Array([0.51449573, 0.47173196, 0.31337744, 0.1819132, 0.09457419, 0.04096558, 0.01419856, 0.00369997])];
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_7 = new Float32Array([0.99904823, 0.9914449, 0.976296, 0.95371693, 0.9238795, 0.8870108, 0.8433915, 0.7933533, 0.7372773, 0.04361938, 0.13052619, 0.2164396, 0.3007058, 0.38268343, 0.4617486, 0.53729963, 0.6087614, 0.6755902]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.s7i_1 = [tmp_7, new Float32Array([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.9914449, 0.9238795, 0.7933533, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.13052619, 0.38268343, 0.6087614])];
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_8.t7i_1 = new Float32Array([9.313226E-10, 7.831458E-10, 6.585445E-10, 5.537677E-10]);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_9.u7i_1 = new Float32Array([9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 7.0, 7.569318E-7 / 7.0, 6.007772E-7 / 7.0, 9.536743E-7 / 15.0, 7.569318E-7 / 15.0, 6.007772E-7 / 15.0, 9.536743E-7 / 31.0, 7.569318E-7 / 31.0, 6.007772E-7 / 31.0, 9.536743E-7 / 63.0, 7.569318E-7 / 63.0, 6.007772E-7 / 63.0, 9.536743E-7 / 127.0, 7.569318E-7 / 127.0, 6.007772E-7 / 127.0, 9.536743E-7 / 255.0, 7.569318E-7 / 255.0, 6.007772E-7 / 255.0, 9.536743E-7 / 511.0, 7.569318E-7 / 511.0, 6.007772E-7 / 511.0, 9.536743E-7 / 1023.0, 7.569318E-7 / 1023.0, 6.007772E-7 / 1023.0, 9.536743E-7 / 2047.0, 7.569318E-7 / 2047.0, 6.007772E-7 / 2047.0, 9.536743E-7 / 4095.0, 7.569318E-7 / 4095.0, 6.007772E-7 / 4095.0, 9.536743E-7 / 8191.0, 7.569318E-7 / 8191.0, 6.007772E-7 / 8191.0, 9.536743E-7 / 16383.0, 7.569318E-7 / 16383.0, 6.007772E-7 / 16383.0, 9.536743E-7 / 32767.0, 7.569318E-7 / 32767.0, 6.007772E-7 / 32767.0, 9.536743E-7 / 65535.0, 7.569318E-7 / 65535.0, 6.007772E-7 / 65535.0, 9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 5.0, 7.569318E-7 / 5.0, 6.007772E-7 / 5.0, 9.536743E-7 / 9.0, 7.569318E-7 / 9.0, 6.007772E-7 / 9.0]);
    var tmp_10 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_10.v7i_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_11 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@HPX`p\x80'))];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_11.w7i_1 = [tmp_12, [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x14\x18\x1C (08@P`p\x80\xA0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@P`p\x80\xA0\xC0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10 0@P`p\x80\x90\xA0\xB0\xC0\xD0\xE0'))]];
    this.x7i_1 = arrayOfUByte$default(this, '\x00\x01\x02\x03\f\x05\x06\x07\t\n\x0B\r\x0E\x0F\x12\x13');
    this.y7i_1 = arrayOfUByte$default(this, '\x05\x05\x04\x04\x05\x05\x04\x01\x04\x03\x01\x01\x05\x06\x06\x01\x04\x04\x04\x01\x04\x03\x01\x01');
    this.z7i_1 = arrayOfUByte$default(this, '\x01\x01\x01\x01\x02\x02\x03\x03\x03\x02');
    this.a7j_1 = arrayOfShort$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFF01\u0521\u0512\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0122\u0120\uFF01\u0521\u0512\u0502\u0301\u0301\u0301\u0301\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0122\u0120\uFF03\uFEC2\uFEA1\uFE91\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0333\u0332\u0223\u0223\u0113\u0113\u0113\u0113\u0231\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF02\uFEE1\u0531\u0513\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0310\u0310\u0310\u0310\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\u0233\u0230\u0132\u0132\u0123\u0103\uFF04\uFE63\uFE23\uFDE2\u0512\uFDC1\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE81\uFE71\u0453\u0444\u0452\u0425\u0351\u0351\u0315\u0315\u0450\u0443\u0305\u0305\u0434\u0433\u0155\u0154\u0145\u0135\u0342\u0324\u0241\u0241\u0214\u0214\u0204\u0204\u0340\u0332\u0323\u0330\u0231\u0231\u0213\u0213\u0203\u0222\u0121\u0121\u0120\u0102\uFF04\uFE53\uFE13\uFDD1\u0421\u0421\u0412\u0412\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\uFE82\u0435\uFE61\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0433\u0342\u0342\u0255\u0245\u0154\u0154\u0153\u0144\u0324\u0341\u0214\u0214\u0340\u0304\u0332\u0323\u0331\u0313\u0330\u0303\u0122\u0122\u0122\u0122\u0120\u0102\uFF03\uFEA3\uFE62\uFE41\uFE31\u0531\u0513\uFE21\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\uFEC1\u0353\u0335\uFEB1\u0344\u0352\u0325\u0351\u0155\u0154\u0145\u0150\u0215\u0215\u0243\u0243\u0234\u0234\u0305\u0340\u0242\u0224\u0233\u0204\u0141\u0114\u0132\u0123\u0130\u0103\uFF05\uFDC4\uFD23\uFCC2\uFCA1\uFC91\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\u0574\u0547\u0565\u0556\u0573\u0537\u0564\uFDD1\u0536\u0472\u0472\u0427\u0427\u0546\u0570\u0407\u0407\u0426\u0426\u0554\u0553\u0460\u0460\u0535\u0544\u0371\u0371\u0371\u0371\u0177\u0176\u0167\u0175\u0157\u0166\u0155\u0145\u0317\u0317\u0463\u0462\uFD41\u0451\u0415\uFD31\u0361\u0361\u0316\u0316\u0306\u0306\u0450\u0405\u0152\u0125\u0143\u0134\uFCE1\uFCD1\u0341\u0314\u0304\u0332\u0323\u0330\u0142\u0124\u0133\u0140\u0231\u0213\u0203\u0222\u0121\u0112\u0120\u0102\uFF05\uFDF3\uFDA3\uFD53\uFD03\uFCC1\uFCB2\u0512\u0421\u0421\u0520\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0577\u0576\u0567\u0557\u0566\u0574\u0547\uFE01\u0565\u0556\u0473\u0473\u0437\u0437\u0464\u0464\u0554\u0545\u0553\u0535\u0372\u0372\u0372\u0372\u0327\u0327\u0327\u0327\u0446\u0446\u0470\u0470\u0175\u0155\u0217\u0217\u0371\u0307\u0363\u0336\u0306\uFDB1\u0144\u0152\uFD61\u0351\u0226\u0226\u0362\u0360\u0261\u0261\u0125\u0150\u0216\u0216\u0315\u0343\u0305\uFD11\u0342\u0324\u0134\u0133\u0341\u0314\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\uFF04\uFE73\uFE23\uFDD3\uFD92\uFD73\uFD31\uFD21\uFD12\u0531\u0513\u0522\u0421\u0421\u0412\u0412\u0520\u0502\u0400\u0400\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\uFE81\u0467\u0475\u0457\u0466\u0474\u0447\u0456\u0365\u0365\u0373\u0373\u0437\u0455\u0372\u0372\u0177\u0176\u0327\u0364\u0346\u0371\u0317\uFE31\u0363\u0336\u0170\u0107\u0354\u0345\u0344\uFDE1\u0262\u0262\u0226\u0226\u0160\u0150\u0216\u0216\u0361\u0306\u0353\u0335\u0352\u0325\u0251\u0215\u0243\u0234\u0305\u0340\u0242\u0242\u0224\u0224\u0241\u0241\u0133\u0114\u0132\u0123\u0204\u0230\u0103\u0103\uFF06\uF7C5\uF635\uF534\uF4A3\uF462\uF441\uF431\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFD01\uFBE4\uFB43\uFB03\uFAB2\uFA83\uFA43\uFA01\uF9F2\uF9D2\uF9B2\uF991\uF982\uF962\uF942\uF921\uF912\uF8F1\uF8E2\uF8C2\uF8A2\u061D\uF881\uF871\uF861\uF851\u06C3\u06C2\u062C\u06B5\uF841\u06C1\u061C\uF831\u060C\uF821\uF811\u06B3\u063B\uF801\u06B2\uF7F1\u064A\uF7E1\u0649\uF7D1\u052B\u052B\u05B1\u05B1\u051B\u051B\u06B0\u060B\u0669\u06A4\u06A3\u063A\u0695\u0659\u05A2\u05A2\u052A\u052A\uFCF4\uFC33\uFC72\u04FF\u04FE\u04FD\u04EE\u04FC\u04ED\u04FB\u04BF\u04EC\u04CD\uFC41\u03CE\u03CE\u03DD\u03DD\uFC51\u02DF\u01DE\u01DE\u01EF\u01CF\u01FA\u019E\uFBF1\u03EB\u03BE\u03F9\u039F\u03AE\u03DB\u03BD\u01AF\u01DC\u04F8\u048F\u04CC\uFB61\u04E8\uFB51\u037F\u037F\u03AD\u03AD\u04DA\u04CB\u04BC\u046F\u03F6\u03F6\u01EA\u01E9\u01F7\u01E7\u038E\u03F5\u03D9\u039D\u035F\u037E\u03CA\u03BB\u03F4\u034F\uFAC1\u033F\u02F3\u02F3\u03D8\u038D\u01AC\u016E\u02F2\u022F\uFA91\u02F0\u01E6\u01C9\u039C\u03E5\u02BA\u02BA\u03D7\u037D\u02E4\u02E4\u038C\u036D\u02E3\u02E3\u029B\u029B\u03B9\u03AA\u01F1\u011F\u010F\u010F\u02AB\u025E\u024E\u02C8\u02D6\u023E\u012E\u012E\u02E2\u02E0\u01E1\u011E\u020E\u02D5\u025D\u02C7\u027C\u02D4\u02B8\u028B\u024D\u02A9\u029A\u02C6\u016C\u01D3\u023D\u02B7\u01D2\u01D2\u012D\u01D1\u017B\u017B\u02C5\u025C\u0299\u02A7\u013C\u013C\u027A\u0279\u01B4\u01B4\u01D0\u010D\u01A8\u018A\u01C4\u014C\u01B6\u016B\u015B\u0198\u0189\u01C0\u014B\u01A6\u016A\u0197\u0188\u01A5\u015A\u0196\u0187\u0178\u0177\u0167\u05A1\u051A\uF6C1\u050A\uF6B1\u0539\uF6A1\uF691\u0592\u0529\uF681\u0583\u0538\uF671\uF661\uF651\u0491\u0491\u0419\u0419\u0590\u0509\u0584\u0548\u0527\uF641\u0482\u0482\u0428\u0428\u0481\u0481\u01A0\u0186\u0168\u0194\u0193\u0185\u0158\u0176\u0175\u0157\u0166\u0174\u0147\u0165\u0156\u0137\u0164\u0146\u0573\u0572\u0471\u0471\u0417\u0417\u0555\u0570\u0507\u0563\u0536\u0554\u0545\u0562\u0526\u0553\u0318\u0318\u0318\u0318\u0480\u0480\u0408\u0408\u0461\u0461\u0416\u0416\u0460\u0460\u0406\u0406\uF4B1\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0135\u0144\u0214\u0214\u0340\u0304\u0332\u0323\u0231\u0231\u0213\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF06\uFB65\uF9D5\uF8D4\uF834\uF7B4\uF733\uF6E3\uF693\uF653\uF612\uF5F2\uF5D1\uF5C2\uF5A1\u0522\u0521\u0512\u0520\u0502\u0311\u0311\u0311\u0311\u0410\u0410\u0401\u0401\u0300\u0300\u0300\u0300\uFD02\uFCE2\uFCC2\uFCA2\uFC81\uFC71\uFC61\uFC51\uFC41\uFC31\uFC21\uFC11\uFC01\uFBF1\uFBE1\uFBD2\u06BC\u066F\uFBB1\uFBA1\u065F\u06E7\u067E\u06CA\u06AC\u06BB\uFB91\u06F4\u064F\u06F3\u063F\u068D\u066E\u06F2\u062F\uFB81\u06F1\u061F\u06C9\u069C\u06E5\u06BA\u06AB\u065E\u06D7\u067D\u06E4\u064E\u06C8\u068C\u06E3\u06D6\u066D\u063E\u06B9\u069B\u06E2\u06AA\u062E\u06E1\u061E\uFB71\u06D5\u065D\u02FF\u02FE\u02EF\u02FD\u01EE\u01EE\u02DF\u02FC\u02CF\u02ED\u02DE\u02FB\u01BF\u01BF\u02EC\u02CE\u01DD\u01FA\u01AF\u01EB\u01BE\u01DC\u01CD\u01F9\u019F\u01AE\u01DB\u01BD\u01F8\u018F\u01CC\u01E9\u019E\u01F7\u017F\u01DA\u01AD\u01CB\u01F6\u01F6\u02EA\u02F0\u01E8\u018E\u01F5\u01D9\u019D\u01D8\u01E6\u010F\u01E0\u010E\uFA61\uFA51\u054D\uFA41\uFA31\uFA21\u053D\u052D\uFA11\u05D1\u05B7\u057B\u051D\uFA01\u055C\u05A8\u058A\u05C4\u054C\u05B6\u056B\uF9F1\u05C3\u053C\u05A7\u057A\u056A\uF9E1\u042C\u042C\u05C2\u05B5\u01C7\u017C\u01D4\u01B8\u018B\u01A9\u019A\u01C6\u016C\u01D3\u01D2\u01D0\u01C5\u010D\u0199\u01C0\u010C\u01B0\u055B\u05C1\u0598\u0589\u051C\u05B4\u054B\u05A6\u05B3\u0597\u043B\u043B\u0579\u0588\u05B2\u05A5\u042B\u042B\u055A\u05B1\u041B\u041B\u050B\u0596\u0569\u05A4\u054A\u0587\u0578\u05A3\u043A\u043A\u0495\u0459\u04A2\u042A\u04A1\u041A\uF851\u0486\u0468\u0494\u0449\u0493\u0439\uF841\u0485\u0458\u01A0\u010A\u0177\u0190\u0492\u0476\u0467\u0429\u0319\u0319\u0491\u0409\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0474\u0382\u0382\u0328\u0328\u0381\u0381\u0318\u0318\u0447\u0480\u0408\u0465\u0456\u0473\u0437\u0464\u0372\u0327\u0346\u0371\u0355\u0317\uF6F1\u0363\u0170\u0107\u0336\u0354\u0345\u0362\u0326\u0361\uF6A1\u0353\u0160\u0106\u0216\u0216\u0335\u0344\u0252\u0252\u0225\u0225\u0251\u0251\u0215\u0215\u0350\u0305\u0243\u0243\u0234\u0242\u0224\u0233\u0114\u0114\u0241\u0240\u0132\u0123\u0204\u0230\u0131\u0131\u0113\u0103\uFF05\uFC84\uF7F6\uF5C4\uF4F4\uF473\uF431\uF421\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\uFDD1\u05FA\uFDC1\uFDB1\u05F8\u05F7\u057F\u05F6\u056F\u03FF\u03FF\u03FF\u03FF\u05F5\u055F\u04F4\u04F4\u044F\u044F\u043F\u043F\u040F\u040F\u05F3\uFDA4\u032F\u032F\u032F\u032F\u01FE\u01EF\u01FD\u01DF\u01FC\u01CF\u01FB\u01BF\u01AF\u01F9\u019F\u018F\uFD22\uFCF2\u04EE\uFCD1\u04EB\u04DC\uFCC1\u04EA\u04CC\uFCB1\uFCA1\u04AC\uFC91\u04E5\u03DB\u03DB\u02EC\uFD01\u01ED\u01ED\u01CE\u01DD\u019E\u019E\u02AE\u029D\u01DE\u01BE\u01CD\u01BD\u01DA\u01AD\u01E7\u01CA\u019C\u01D7\u04F2\u04F0\u03F1\u03F1\u031F\u031F\uFC05\uFB04\uFA54\uF9D3\uF973\uF923\uF8E3\uF8A2\uF873\uF833\u04E9\u04E9\u05CB\u05BC\u05E8\u058E\u05D9\u057E\u05BB\u05D8\u058D\u05E6\u046E\u046E\u04C9\u04C9\u05BA\u05AB\u055E\u057D\u04E4\u04E4\u054E\u05C8\u048C\u048C\u04E3\u04E3\u04D6\u04D6\u056D\u05B9\uFA81\u041E\u044D\uFA71\u04B7\uFA61\u033E\u033E\u04E0\u040E\u04D5\u045D\u04C7\u047C\u04D4\u04B8\u019B\u01AA\u018B\u019A\u017B\u010D\u04A9\u04C6\u046C\u04D3\u04C5\u045C\u03D0\u03D0\u04A8\u048A\u0499\u04C4\u046B\u04A7\u03C3\u03C3\uF991\u03C1\u030C\uF981\u022E\u022E\u03E2\u03E1\u01B5\u0198\u0189\u0197\u033D\u03D2\u032D\u031D\u03B3\uF931\u02D1\u02D1\u0179\u0188\u034C\u03B6\u033C\u037A\u02C2\u02C2\u032C\u035B\u031C\u03C0\u03B4\u034B\u03A6\u036A\u023B\u023B\uF881\u02B2\u022B\u02B1\u01A5\u015A\u021B\u021B\u03B0\u030B\u0396\u0369\u03A4\u034A\u0387\u0378\u023A\u023A\u03A3\u0395\u02A2\u02A2\uF5F1\u061A\uF5E1\u0649\uF5D1\u0676\u052A\u052A\u05A1\u05A1\u06A0\u060A\u0693\u0639\u0685\u0658\u0592\u0592\u0529\u0529\u0667\u0690\u0591\u0591\u0519\u0519\u0609\u0684\u0648\u0657\u0683\u0638\u0666\u0682\u0528\u0528\u0674\u0647\u0581\u0581\u0518\u0518\u0508\u0508\u0680\u0665\u0573\u0573\u0537\u0537\u0656\u0664\u0572\u0572\u0527\u0527\u0646\u0655\u0570\u0570\u0471\u0471\u0471\u0471\u0159\u0186\u0168\u0177\u0194\u0175\u0417\uF541\uF531\uF521\u0426\u0461\u0416\uF511\u0435\uF501\u0452\u0425\u0315\u0315\u0451\u0450\u0107\u0163\u0136\u0154\u0145\u0162\u0160\u0106\u0153\u0144\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0314\u0314\u0440\u0404\u0332\u0332\u0323\u0323\u0231\u0231\u0213\u0213\u0330\u0303\u0222\u0222\u0121\u0112\u0120\u0102\uFF03\uFEC3\uFE83\uFE42\uFE22\uFE03\u04FF\u04FF\uFCD5\uFB65\uFA55\uF924\uF894\uF814\uF773\uF733\uF6E3\uF692\uF673\uF631\uF622\u0521\u0512\uF601\u0411\u0411\u0410\u0410\u0401\u0401\u0400\u0400\u03FE\u03EF\u03FD\u03DF\u03FC\u03CF\u03FB\u03BF\u02AF\u02AF\u03FA\u03F9\u029F\u029F\u028F\u028F\u03F8\u03F7\u027F\u027F\u02F6\u02F6\u026F\u026F\u02F5\u025F\u02F4\u024F\u02F3\u023F\u02F2\u022F\u021F\u021F\u03F1\u030F\uFDC1\uFD93\uFD53\uFD13\u01F0\uFDB2\u02EE\u02ED\u02DE\u02EC\u03CE\u03DD\u03EB\u03BE\u03DC\u03CD\u03EA\u03AE\u03DB\u03BD\u03CC\u03E9\u039E\u03DA\u03AD\u03CB\u03BC\u03E8\u038E\u03D9\u039D\u03E7\u037E\u03CA\uFBD1\uFBC1\uFBB2\u056E\uFB91\u059C\u05E5\u05AB\u055E\uFB81\u057D\u054E\u05C8\u058C\uFB71\u05E3\u05D6\u056D\u053E\u05B9\u059B\u05AA\u052E\u05E1\u051E\u05D5\u055D\u05C7\u057C\u05D4\u05B8\u058B\u01AC\u01BB\u01D8\u018D\u02E0\u020E\u01D0\u01D0\u01E6\u01C9\u01BA\u01D7\u01E4\u01E2\u054D\u05A9\u059A\u05C6\u056C\u05D3\u053D\u05D2\u052D\u05D1\u05B7\u057B\u051D\u05C5\u055C\u05A8\u058A\u0599\u05C4\u054C\u05B6\u056B\uFA61\u05C3\u053C\u05A7\u057A\u05C2\u052C\u05B5\u055B\u05C1\u010D\u01C0\u0598\u0589\u051C\u05B4\uF951\u05B3\uF941\u05A1\u044B\u044B\u05A6\u056A\u0597\u0579\uF931\u0509\u043B\u043B\u0488\u0488\u05B2\u05A5\u042B\u042B\u055A\u05B1\u051B\u0596\u0469\u0469\u044A\u044A\u010C\u01B0\u010B\u01A0\u010A\u0190\uF8A1\u0478\u04A3\u043A\u0495\u0459\u04A2\u042A\u041A\u0486\u0468\u0477\u0494\u0449\u0493\u0439\u01A4\u0187\u0485\u0458\u0492\u0476\u0467\u0429\u0491\u0419\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0482\u0428\u0481\u0474\u0447\u0418\uF791\u0465\u0456\u0471\uF781\u0337\u0337\u0473\u0472\u0327\u0327\u0180\u0108\u0170\u0107\u0364\u0346\u0355\u0317\u0363\u0336\u0354\u0345\u0362\u0326\u0361\u0316\uF6F1\u0353\u0335\u0344\u0160\u0106\u0352\u0325\u0351\uF6A1\u0215\u0215\u0343\u0334\u0150\u0105\u0242\u0224\u0233\u0241\u0214\u0214\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\u0120\u0102');
    this.b7j_1 = arrayOfUByte$default(this, '\x82\xA2\xC1\xD1,\x1CL\x8C\t\t\t\t\t\t\t\t\xBE\xFE\xDE\xEE~^\x9D\x9Dm=\xAD\xCD');
    this.c7j_1 = arrayOfUByte$default(this, '\xFC\xEC\xDC\xCC\xBC\xAC\x9C\x8C|l\\L<,\x1C\f');
    this.d7j_1 = arrayOfShort$default(this, '\x00 @b\x00\x84\xB4\xDA\u0124\u016C\u01AA\u021A\u0288\u02EA\x00\u0466\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u0732\u0732\u0732\u0732\u0732\u0732\u0732\u0732');
    this.e7j_1 = arrayOfUByte$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x01\x02\x03\x04\x06\b\n\r\x04\x05\x06\x07\b\t\x0B\r');
    this.f7j_1 = arrayOfUByte$default(this, '\x00\x11\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x10\x00\x11\x12\x03\x13\x04\x05\x10\x00\x11\x12\x10\x00\x11\x12\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x00\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10');
    var tmp_13 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_13.g7j_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\f\f\f\x10\x14\x18\x1C (08@LZ\x02\x02\x02\x02\x02\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x12\x16\x1A &.6>FL$\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\b\n\f\x10\x14\x18\x1C"*26L\x9E\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\n\f\x10\x12\x16\x1C"(.66\xC0\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\n\f\x10\x14\x18\x1E&.8DTf\x1A\x00'))];
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.h7j_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\b\b\b\b\b\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00'))];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.i7j_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\x04\x04\x04\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00', 40))];
    var tmp_16 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_16.j7j_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x05\x05\x05\x06\x05\x05\x05\x06\x05\x07\x03\x0B\n\x00\x00\x07\x07\x07\x00\x06\x06\x06\x03\b\b\x05\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\t\x06\f\x06\t\t\t\x06\t\f\x06\x0F\x12\x00\x00\x06\x0F\f\x00\x06\f\t\x06\x06\x12\t\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\t\t\x06\f\t\t\t\t\t\t\f\x06\x12\x12\x00\x00\f\f\f\x00\f\t\t\x06\x0F\f\t\x00'))];
    var tmp_17 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_17.k7j_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(76), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(32))];
    var tmp_18 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_18.l7j_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(60), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(4)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(7)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(19))];
    var tmp_19 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_19.m7j_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(0), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(3)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(16), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(8)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(32), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(12)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(40), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(7))];
    var tmp_20 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_20.n7j_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(2)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(10))];
    var tmp_21 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_21.o7j_1 = new Float32Array([0.0, -1.0, -2.519842, -4.326749, -6.349604, -8.54988, -10.902724, -13.390518, -16.0, -18.720755, -21.544348, -24.463781, -27.473143, -30.56735, -33.741993, -36.99318, 0.0, 1.0, 2.519842, 4.326749, 6.349604, 8.54988, 10.902724, 13.390518, 16.0, 18.720755, 21.544348, 24.463781, 27.473143, 30.56735, 33.741993, 36.99318, 40.317474, 43.71179, 47.173344, 50.69963, 54.288353, 57.93741, 61.644863, 65.40894, 69.22798, 73.10044, 77.024895, 81.0, 85.02449, 89.09719, 93.21697, 97.3828, 101.593666, 105.84863, 110.146805, 114.48732, 118.869385, 123.292206, 127.755066, 132.25725, 136.79808, 141.3769, 145.99312, 150.64612, 155.33533, 160.0602, 164.8202, 169.61482, 174.44357, 179.30598, 184.20157, 189.12991, 194.09058, 199.08315, 204.10721, 209.16238, 214.24829, 219.36456, 224.51085, 229.68678, 234.89206, 240.12633, 245.38928, 250.6806, 256.0, 261.34717, 266.72183, 272.12372, 277.55255, 283.00806, 288.48996, 293.99805, 299.53207, 305.09177, 310.6769, 316.28726, 321.92258, 327.5827, 333.26736, 338.97638, 344.70956, 350.46664, 356.24747, 362.05188, 367.8796, 373.73053, 379.60443, 385.50113, 391.4205, 397.3623, 403.32642, 409.31268, 415.3209, 421.3509, 427.4026, 433.47574, 439.57028, 445.68597, 451.82275, 457.98044, 464.15887, 470.35797, 476.57755, 482.81744, 489.0776, 495.35788, 501.65808, 507.97815, 514.31793, 520.6773, 527.0562, 533.4544, 539.8719, 546.3085, 552.76404, 559.2386, 565.7319, 572.2439, 578.7744, 585.3235, 591.89087, 598.47656, 605.08044, 611.70233, 618.3422, 625.0, 631.67554, 638.3688, 645.0796]);
  }
}
class L12_subband_alloc_tStruct {
  constructor(tab_offset, code_tab_width, band_count) {
    this.p7j_1 = tab_offset;
    this.q7j_1 = code_tab_width;
    this.r7j_1 = band_count;
  }
  toString() {
    return 'L12_subband_alloc_tStruct(tab_offset=' + new UByte(this.p7j_1) + ', code_tab_width=' + new UByte(this.q7j_1) + ', band_count=' + new UByte(this.r7j_1) + ')';
  }
  hashCode() {
    var result = UByte__hashCode_impl_mmczcb(this.p7j_1);
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.q7j_1) | 0;
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.r7j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof L12_subband_alloc_tStruct))
      return false;
    var tmp0_other_with_cast = other instanceof L12_subband_alloc_tStruct ? other : THROW_CCE();
    if (!(this.p7j_1 === tmp0_other_with_cast.p7j_1))
      return false;
    if (!(this.q7j_1 === tmp0_other_with_cast.q7j_1))
      return false;
    if (!(this.r7j_1 === tmp0_other_with_cast.r7j_1))
      return false;
    return true;
  }
}
class Mp3Dec {
  static s7j(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    var $this = createThis(this);
    $this.o7d_1 = mdct_overlap;
    $this.p7d_1 = qmf_state;
    $this.q7d_1 = reserv;
    $this.r7d_1 = free_format_bytes_array;
    $this.s7d_1 = header;
    $this.t7d_1 = reserv_buf;
    return $this;
  }
  static u7d() {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(2), null);
    while (tmp < 2) {
      tmp_0[tmp] = new Float32Array(288);
      tmp = tmp + 1 | 0;
    }
    return this.s7j(tmp_0, new Float32Array(960), 0, new Int32Array(1), _UByteArrayInt___init__impl__xif7bu_1(4), _UByteArrayInt___init__impl__xif7bu_1(511));
  }
}
class Bs {
  constructor(buf, pos, limit) {
    buf = buf === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : buf;
    pos = pos === VOID ? 0 : pos;
    limit = limit === VOID ? 0 : limit;
    this.t7j_1 = buf;
    this.u7j_1 = pos;
    this.v7j_1 = limit;
  }
}
class Mp3Scratch {
  static d7k(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    var $this = createThis(this);
    $this.w7j_1 = bs;
    $this.x7j_1 = maindata;
    $this.y7j_1 = gr_info;
    $this.z7j_1 = grbuf;
    $this.a7k_1 = scf;
    $this.b7k_1 = syn;
    $this.c7k_1 = ist_pos;
    return $this;
  }
  static e7k() {
    var tmp = new Bs();
    var tmp_0 = new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(2815));
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(4), null);
    while (tmp_1 < 4) {
      tmp_2[tmp_1] = new GrInfo();
      tmp_1 = tmp_1 + 1 | 0;
    }
    var tmp_3 = new ArrayPtr(tmp_2, 0);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE = 576;
    var data = new Float32Array(imul(2, CSIZE));
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(2), null);
    while (tmp_4 < 2) {
      var tmp_6 = tmp_4;
      tmp_5[tmp_6] = new FloatArrayPtr(data, imul(CSIZE, tmp_6));
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = new FloatArrayPtr(new Float32Array(40));
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE_0 = 64;
    var data_0 = new Float32Array(imul(33, CSIZE_0));
    var tmp_9 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(33), null);
    while (tmp_9 < 33) {
      var tmp_11 = tmp_9;
      tmp_10[tmp_11] = new FloatArrayPtr(data_0, imul(CSIZE_0, tmp_11));
      tmp_9 = tmp_9 + 1 | 0;
    }
    var tmp_12 = tmp_10;
    var tmp_13 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(2), null);
    while (tmp_13 < 2) {
      var tmp_15 = tmp_13;
      var tmp$ret$11 = _UByteArrayInt___init__impl__xif7bu_1(39);
      tmp_14[tmp_15] = new UByteArrayInt(tmp$ret$11);
      tmp_13 = tmp_13 + 1 | 0;
    }
    return this.d7k(tmp, tmp_0, tmp_3, tmp_7, tmp_8, tmp_12, tmp_14);
  }
}
class Mp3FrameInfo {
  constructor(frame_bytes, frame_offset, channels, hz, layer, bitrate_kbps) {
    frame_bytes = frame_bytes === VOID ? 0 : frame_bytes;
    frame_offset = frame_offset === VOID ? 0 : frame_offset;
    channels = channels === VOID ? 0 : channels;
    hz = hz === VOID ? 0 : hz;
    layer = layer === VOID ? 0 : layer;
    bitrate_kbps = bitrate_kbps === VOID ? 0 : bitrate_kbps;
    this.v7e_1 = frame_bytes;
    this.w7e_1 = frame_offset;
    this.x7e_1 = channels;
    this.y7e_1 = hz;
    this.z7e_1 = layer;
    this.a7f_1 = bitrate_kbps;
  }
  w1() {
    return this;
  }
}
class ArrayPtr {
  constructor(array, pos) {
    this.f7k_1 = array;
    this.g7k_1 = pos;
  }
  w1() {
    return this.f7k_1[this.g7k_1];
  }
  h1(index) {
    return this.f7k_1[this.g7k_1 + index | 0];
  }
  a4() {
    return new ArrayPtr(this.f7k_1, this.g7k_1 + 1 | 0);
  }
  h7k(other) {
    return new ArrayPtr(this.f7k_1, this.g7k_1 + other | 0);
  }
}
class UByteArrayIntPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.i7k_1 = array;
    this.j7k_1 = pos;
  }
  w1() {
    return UByteArrayInt__get_impl_px6q8a(this.i7k_1, this.j7k_1);
  }
  h1(index) {
    return UByteArrayInt__get_impl_px6q8a(this.i7k_1, this.j7k_1 + index | 0);
  }
  w3w(index, value) {
    UByteArrayInt__set_impl_gn4532(this.i7k_1, this.j7k_1 + index | 0, value);
  }
  a4() {
    return new UByteArrayIntPtr(this.i7k_1, this.j7k_1 + 1 | 0);
  }
  h7k(other) {
    return new UByteArrayIntPtr(this.i7k_1, this.j7k_1 + other | 0);
  }
  k7k(other) {
    return this.j7k_1 - other.j7k_1 | 0;
  }
  l7k(value, from, to) {
    var tmp = _UByteArrayInt___get_bytes__impl__pj0ilc(this.i7k_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    fill(tmp, tmp$ret$0, this.j7k_1 + from | 0, this.j7k_1 + to | 0);
  }
}
class FloatArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.m7k_1 = array;
    this.n7k_1 = pos;
  }
  o7k(value) {
    this.m7k_1[this.n7k_1] = value;
  }
  w1() {
    return this.m7k_1[this.n7k_1];
  }
  h1(index) {
    return this.m7k_1[this.n7k_1 + index | 0];
  }
  p7k(index, value) {
    this.m7k_1[this.n7k_1 + index | 0] = value;
  }
  a4() {
    return new FloatArrayPtr(this.m7k_1, this.n7k_1 + 1 | 0);
  }
  h7k(other) {
    return new FloatArrayPtr(this.m7k_1, this.n7k_1 + other | 0);
  }
  q7k(other) {
    return this.n7k_1 - other.n7k_1 | 0;
  }
  r7k(value, from, to) {
    fill_0(this.m7k_1, value, this.n7k_1 + from | 0, this.n7k_1 + to | 0);
  }
}
class ShortArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.s7k_1 = array;
    this.t7k_1 = pos;
  }
  u7k(index, value) {
    this.s7k_1[this.t7k_1 + index | 0] = value;
  }
  h7k(other) {
    return new ShortArrayPtr(this.s7k_1, this.t7k_1 + other | 0);
  }
}
class GrInfo {
  constructor(sfbtab, part_23_length, big_values, scalefac_compress, global_gain, block_type, mixed_block_flag, n_long_sfb, n_short_sfb, table_select, region_count, subblock_gain, preflag, scalefac_scale, count1_table, scfsi) {
    sfbtab = sfbtab === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : sfbtab;
    part_23_length = part_23_length === VOID ? 0 : part_23_length;
    big_values = big_values === VOID ? 0 : big_values;
    scalefac_compress = scalefac_compress === VOID ? 0 : scalefac_compress;
    global_gain = global_gain === VOID ? 0 : global_gain;
    block_type = block_type === VOID ? 0 : block_type;
    mixed_block_flag = mixed_block_flag === VOID ? 0 : mixed_block_flag;
    n_long_sfb = n_long_sfb === VOID ? 0 : n_long_sfb;
    n_short_sfb = n_short_sfb === VOID ? 0 : n_short_sfb;
    table_select = table_select === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : table_select;
    region_count = region_count === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : region_count;
    subblock_gain = subblock_gain === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : subblock_gain;
    preflag = preflag === VOID ? 0 : preflag;
    scalefac_scale = scalefac_scale === VOID ? 0 : scalefac_scale;
    count1_table = count1_table === VOID ? 0 : count1_table;
    scfsi = scfsi === VOID ? 0 : scfsi;
    this.v7k_1 = sfbtab;
    this.w7k_1 = part_23_length;
    this.x7k_1 = big_values;
    this.y7k_1 = scalefac_compress;
    this.z7k_1 = global_gain;
    this.a7l_1 = block_type;
    this.b7l_1 = mixed_block_flag;
    this.c7l_1 = n_long_sfb;
    this.d7l_1 = n_short_sfb;
    this.e7l_1 = table_select;
    this.f7l_1 = region_count;
    this.g7l_1 = subblock_gain;
    this.h7l_1 = preflag;
    this.i7l_1 = scalefac_scale;
    this.j7l_1 = count1_table;
    this.k7l_1 = scfsi;
  }
}
class ScaleInfo {
  constructor(scf, total_bands, stereo_bands, bitalloc, scfcod) {
    scf = scf === VOID ? new Float32Array(192) : scf;
    total_bands = total_bands === VOID ? 0 : total_bands;
    stereo_bands = stereo_bands === VOID ? 0 : stereo_bands;
    bitalloc = bitalloc === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : bitalloc;
    scfcod = scfcod === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : scfcod;
    this.l7l_1 = scf;
    this.m7l_1 = total_bands;
    this.n7l_1 = stereo_bands;
    this.o7l_1 = bitalloc;
    this.p7l_1 = scfcod;
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_11();
    super(['wav']);
  }
  w7a(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_1.bind(VOID, this, data, props), $completion);
  }
  b7b(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877_0.bind(VOID, this, data, props), $completion);
  }
  p7m(data, handle, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5.bind(VOID, this, data, handle), $completion);
  }
  q7m(data, handler, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_riff__qieez3.bind(VOID, this, data, handler), $completion);
  }
}
class Companion_7 extends WAV {
  constructor() {
    Companion_instance_8 = null;
    super();
    Companion_instance_8 = this;
  }
}
class Chunk {
  constructor(type, data) {
    this.e7m_1 = type;
    this.f7m_1 = data;
  }
  em() {
    return this.e7m_1;
  }
  fm() {
    return this.f7m_1;
  }
  toString() {
    return 'Chunk(type=' + this.e7m_1 + ', data=' + this.f7m_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.e7m_1);
    result = imul(result, 31) + hashCode(this.f7m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this.e7m_1 === tmp0_other_with_cast.e7m_1))
      return false;
    if (!equals(this.f7m_1, tmp0_other_with_cast.f7m_1))
      return false;
    return true;
  }
}
class ProcessedChunk {
  constructor(type, data, extra) {
    this.r7m_1 = type;
    this.s7m_1 = data;
    this.t7m_1 = extra;
  }
  toString() {
    return 'ProcessedChunk(type=' + this.r7m_1 + ', data=' + this.s7m_1.toString() + ', extra=' + toString(this.t7m_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r7m_1);
    result = imul(result, 31) + hashCode(this.s7m_1) | 0;
    result = imul(result, 31) + hashCode(this.t7m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this.r7m_1 === tmp0_other_with_cast.r7m_1))
      return false;
    if (!equals(this.s7m_1, tmp0_other_with_cast.s7m_1))
      return false;
    if (!equals(this.t7m_1, tmp0_other_with_cast.t7m_1))
      return false;
    return true;
  }
}
class WavAudioStream extends AudioStream {
  constructor(fmt, buffer, bufferLength, data, props) {
    super(fmt.l7m_1, fmt.k7m_1);
    this.w7l_1 = fmt;
    this.x7l_1 = buffer;
    this.y7l_1 = bufferLength;
    this.z7l_1 = data;
    this.a7m_1 = props;
    this.b7m_1 = this.w7l_1.u7m();
    this.c7m_1 = false;
  }
  b7i() {
    return this.c7m_1;
  }
  c7i() {
    // Inline function 'kotlin.Long.div' call
    var this_0 = this.y7l_1;
    var other = this.b7m_1;
    return this_0.y3(toLong(other));
  }
  d7i() {
    // Inline function 'kotlin.Long.div' call
    var this_0 = this.x7l_1.b33_1;
    var other = this.b7m_1;
    return this_0.y3(toLong(other));
  }
  e7i(position, $completion) {
    this.c7m_1 = false;
    var tmp = this.x7l_1;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.t7h(position);
    var other = this.b7m_1;
    tmp.b33_1 = this_0.x3(toLong(other));
  }
  f7i(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, out, offset, length), $completion);
  }
  g7i($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clone__nh2r5j.bind(VOID, this), $completion);
  }
}
class Fmt {
  constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    formatTag = formatTag === VOID ? -1 : formatTag;
    channels = channels === VOID ? 2 : channels;
    samplesPerSec = samplesPerSec === VOID ? 44100 : samplesPerSec;
    avgBytesPerSec = avgBytesPerSec === VOID ? new Long(0, 0) : avgBytesPerSec;
    blockAlign = blockAlign === VOID ? 0 : blockAlign;
    bitsPerSample = bitsPerSample === VOID ? 0 : bitsPerSample;
    this.j7m_1 = formatTag;
    this.k7m_1 = channels;
    this.l7m_1 = samplesPerSec;
    this.m7m_1 = avgBytesPerSec;
    this.n7m_1 = blockAlign;
    this.o7m_1 = bitsPerSample;
  }
  u7m() {
    return this.o7m_1 / 8 | 0;
  }
  toString() {
    return 'Fmt(formatTag=' + this.j7m_1 + ', channels=' + this.k7m_1 + ', samplesPerSec=' + this.l7m_1 + ', avgBytesPerSec=' + this.m7m_1.toString() + ', blockAlign=' + this.n7m_1 + ', bitsPerSample=' + this.o7m_1 + ')';
  }
  hashCode() {
    var result = this.j7m_1;
    result = imul(result, 31) + this.k7m_1 | 0;
    result = imul(result, 31) + this.l7m_1 | 0;
    result = imul(result, 31) + this.m7m_1.hashCode() | 0;
    result = imul(result, 31) + this.n7m_1 | 0;
    result = imul(result, 31) + this.o7m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this.j7m_1 === tmp0_other_with_cast.j7m_1))
      return false;
    if (!(this.k7m_1 === tmp0_other_with_cast.k7m_1))
      return false;
    if (!(this.l7m_1 === tmp0_other_with_cast.l7m_1))
      return false;
    if (!this.m7m_1.equals(tmp0_other_with_cast.m7m_1))
      return false;
    if (!(this.n7m_1 === tmp0_other_with_cast.n7m_1))
      return false;
    if (!(this.o7m_1 === tmp0_other_with_cast.o7m_1))
      return false;
    return true;
  }
}
class WAV$parse$slambda {
  constructor($fmt, $dataSize, $handle) {
    this.g7m_1 = $fmt;
    this.h7m_1 = $dataSize;
    this.i7m_1 = $handle;
  }
  v7m($this$riff, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$riff), $completion);
  }
  le(p1, $completion) {
    return this.v7m(p1 instanceof Chunk ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_8 {}
class AudioSamplesDeque {
  constructor(channels) {
    this.u7h_1 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.u7h_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new ShortArrayDeque();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.v7h_1 = tmp_2;
  }
  u2d() {
    var tmp34_safe_receiver = getOrNull_0(this.v7h_1, 0);
    var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.u2d();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  w7m() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var this_0 = this.v7h_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block;
      }
      // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
      var maxValue = this_0[0].u2d();
      var inductionVariable = 1;
      var last = get_lastIndex(this_0);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
          var v = this_0[i].u2d();
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$1 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  x7m(channel) {
    return _AudioSample___init__impl__s54gd5(this.v7h_1[channel].h3w());
  }
  y7m(channel, sample) {
    this.v7h_1[channel].i3w(_AudioSample___get_short__impl__uk8ygu(sample));
  }
  z7m(samples, offset, len) {
    var inductionVariable = 0;
    var last = this.u7h_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a7n(channel, samples.r79(channel % samples.v77_1 | 0), offset, len);
      }
       while (inductionVariable < last);
  }
  a7n(channel, data, offset, len) {
    this.v7h_1[channel].g3w(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
  }
  b7n(data, offset, len, channels) {
    switch (channels) {
      case 1:
        var inductionVariable = 0;
        var last = this.u7h_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.v7h_1[n].g3w(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
          }
           while (inductionVariable < last);
        break;
      case 2:
        var inductionVariable_0 = 0;
        var last_0 = len / 2 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.y7m(0, AudioSampleArray__get_impl_w0l0xc(data, imul(n_0, 2) + 0 | 0));
          }
           while (inductionVariable_0 < last_0);
        var inductionVariable_1 = 0;
        var last_1 = len / 2 | 0;
        if (inductionVariable_1 < last_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this.y7m(1, AudioSampleArray__get_impl_w0l0xc(data, imul(n_1, 2) + 1 | 0));
          }
           while (inductionVariable_1 < last_1);
        break;
      default:
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < channels)
          do {
            var c = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var inductionVariable_3 = 0;
            var last_2 = len / channels | 0;
            if (inductionVariable_3 < last_2)
              do {
                var n_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                this.y7m(c, AudioSampleArray__get_impl_w0l0xc(data, imul(n_2, channels) + c | 0));
              }
               while (inductionVariable_3 < last_2);
          }
           while (inductionVariable_2 < channels);
        break;
    }
  }
  a7i(data, offset, len, channels, $super) {
    len = len === VOID ? _AudioSampleArray___get_size__impl__8l8tm8(data) - offset | 0 : len;
    channels = channels === VOID ? this.u7h_1 : channels;
    var tmp;
    if ($super === VOID) {
      this.b7n(data, offset, len, channels);
      tmp = Unit_instance;
    } else {
      tmp = $super.b7n.call(this, new AudioSampleArray(data), offset, len, channels);
    }
    return tmp;
  }
  w7h(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.u2d();
    var rlen = Math.min(len, b);
    var inductionVariable = 0;
    var last = out.v77_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v7h_1[channel % this.u7h_1 | 0].f3w(AudioSampleArray__asShortArray_impl_iyd0md(out.r79(channel)), offset, rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  c7n(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.w77_1 - offset | 0 : len;
    return $super === VOID ? this.w7h(out, offset, len) : $super.w7h.call(this, out, offset, len);
  }
  d7n(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.u2d();
    var rlen = Math.min(len, b);
    var channels = this.u7h_1;
    var inductionVariable = 0;
    var last = out.y78_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inChannel = channel % channels | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < rlen)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.s79(channel, offset + n | 0, this.x7m(inChannel));
          }
           while (inductionVariable_0 < rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  e7n(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.z78_1 - offset | 0 : len;
    return $super === VOID ? this.d7n(out, offset, len) : $super.d7n.call(this, out, offset, len);
  }
  h3() {
    var inductionVariable = 0;
    var last = this.v7h_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v7h_1[c].h3();
      }
       while (inductionVariable <= last);
  }
  toString() {
    return 'AudioSamplesDeque(channels=' + this.u7h_1 + ', availableRead=' + this.u2d() + ')';
  }
}
class Companion_9 {}
class createSound$slambda {
  constructor($stream) {
    this.f7n_1 = $stream;
  }
  ke($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_11 = this;
    this.g7n_1 = _PlaybackTimes___init__impl__rt6rw2(0);
    this.h7n_1 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.i7n_1 = _PlaybackTimes___init__impl__rt6rw2(-1);
  }
}
class PlaybackTimes {
  constructor(count) {
    Companion_getInstance_14();
    this.j7n_1 = count;
  }
  toString() {
    return PlaybackTimes__toString_impl_l4chjq(this.j7n_1);
  }
  hashCode() {
    return PlaybackTimes__hashCode_impl_mtf95(this.j7n_1);
  }
  equals(other) {
    return PlaybackTimes__equals_impl_suah7n(this.j7n_1, other);
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    var tmp_0 = _PlaybackTimes___init__impl__rt6rw2(1);
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
    tmp.k7n_1 = new PlaybackParameters(tmp_0, tmp$ret$2);
  }
}
class PlaybackParameters {
  constructor(times, startTime, bufferTime, volume, pitch, panning, position, onCancel, onFinish) {
    Companion_getInstance_15();
    var tmp;
    if (times === VOID) {
      // Inline function 'korlibs.audio.sound.playbackTimes' call
      tmp = _PlaybackTimes___init__impl__rt6rw2(1);
    } else {
      tmp = times;
    }
    times = tmp;
    var tmp_0;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = startTime;
    }
    startTime = tmp_0;
    var tmp_1;
    if (bufferTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = bufferTime;
    }
    bufferTime = tmp_1;
    volume = volume === VOID ? 1.0 : volume;
    pitch = pitch === VOID ? 1.0 : pitch;
    panning = panning === VOID ? 0.0 : panning;
    position = position === VOID ? Companion_getInstance_2().o3t_1 : position;
    onCancel = onCancel === VOID ? null : onCancel;
    onFinish = onFinish === VOID ? null : onFinish;
    this.l7n_1 = times;
    this.m7n_1 = startTime;
    this.n7n_1 = bufferTime;
    this.o7n_1 = volume;
    this.p7n_1 = pitch;
    this.q7n_1 = panning;
    this.r7n_1 = position;
    this.s7n_1 = onCancel;
    this.t7n_1 = onFinish;
  }
  d79() {
    return this.o7n_1;
  }
  k79() {
    return this.p7n_1;
  }
  f79() {
    return this.q7n_1;
  }
  c30() {
    return this.r7n_1;
  }
  toString() {
    return 'PlaybackParameters(times=' + PlaybackTimes__toString_impl_l4chjq(this.l7n_1) + ', startTime=' + Duration__toString_impl_8d916b(this.m7n_1) + ', bufferTime=' + Duration__toString_impl_8d916b(this.n7n_1) + ', volume=' + this.o7n_1 + ', pitch=' + this.p7n_1 + ', panning=' + this.q7n_1 + ', position=' + this.r7n_1.toString() + ', onCancel=' + toString_0(this.s7n_1) + ', onFinish=' + toString_0(this.t7n_1) + ')';
  }
  hashCode() {
    var result = PlaybackTimes__hashCode_impl_mtf95(this.l7n_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.m7n_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.n7n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o7n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p7n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q7n_1) | 0;
    result = imul(result, 31) + this.r7n_1.hashCode() | 0;
    result = imul(result, 31) + (this.s7n_1 == null ? 0 : hashCode(this.s7n_1)) | 0;
    result = imul(result, 31) + (this.t7n_1 == null ? 0 : hashCode(this.t7n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!(this.l7n_1 === tmp0_other_with_cast.l7n_1))
      return false;
    if (!equals(this.m7n_1, tmp0_other_with_cast.m7n_1))
      return false;
    if (!equals(this.n7n_1, tmp0_other_with_cast.n7n_1))
      return false;
    if (!equals(this.o7n_1, tmp0_other_with_cast.o7n_1))
      return false;
    if (!equals(this.p7n_1, tmp0_other_with_cast.p7n_1))
      return false;
    if (!equals(this.q7n_1, tmp0_other_with_cast.q7n_1))
      return false;
    if (!this.r7n_1.equals(tmp0_other_with_cast.r7n_1))
      return false;
    if (!equals(this.s7n_1, tmp0_other_with_cast.s7n_1))
      return false;
    if (!equals(this.t7n_1, tmp0_other_with_cast.t7n_1))
      return false;
    return true;
  }
}
class SoundChannel {
  constructor(sound, $box) {
    boxApply(this, $box);
    this.u7n_1 = new Mixin();
    this.v7n_1 = sound;
    this.w7n_1 = Companion_getInstance_0().m35();
    this.x7n_1 = 1.0;
    this.y7n_1 = 1.0;
    this.z7n_1 = 0.0;
    this.a7o_1 = Companion_getInstance_2().o3t_1;
  }
  c28(_set____db54di) {
    this.u7n_1.c28(_set____db54di);
  }
  d28() {
    return this.u7n_1.d28();
  }
  c79(_set____db54di) {
    this.x7n_1 = _set____db54di;
  }
  d79() {
    return this.x7n_1;
  }
  j79(_set____db54di) {
    this.y7n_1 = _set____db54di;
  }
  k79() {
    return this.y7n_1;
  }
  e79(_set____db54di) {
    this.z7n_1 = _set____db54di;
  }
  f79() {
    return this.z7n_1;
  }
  c30() {
    return this.a7o_1;
  }
  b7o(value) {
    this.w7n_1 = DateTime__minus_impl_10njw8(Companion_getInstance_0().m35(), value);
  }
  c7o() {
    return DateTime__minus_impl_10njw8_0(Companion_getInstance_0().m35(), this.w7n_1);
  }
  d7o() {
    return this.v7n_1.n7o();
  }
  o7o() {
    return Duration__compareTo_impl_pchp0f(this.c7o(), this.d7o()) < 0 ? SoundChannelState_PLAYING_getInstance() : SoundChannelState_STOPPED_getInstance();
  }
  u1w() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
    this.b7o(tmp$ret$1);
  }
  p7o() {
    unsupported();
  }
  q7o() {
    unsupported();
  }
}
class SoundPlay {}
function play(params, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.hd();
  return this.r7o(tmp$ret$0, params);
}
function play$default(params, $completion, $super) {
  params = params === VOID ? Companion_getInstance_15().k7n_1 : params;
  return $super === VOID ? this.s7o(params, $completion) : play(params, $completion);
}
class Sound {
  constructor(creationCoroutineContext) {
    this.e7o_1 = new Mixin();
    this.f7o_1 = creationCoroutineContext;
    this.g7o_1 = this.f7o_1;
    this.h7o_1 = 'UnknownNativeSound';
    this.i7o_1 = 1.0;
    this.j7o_1 = 0.0;
    this.k7o_1 = 1.0;
    this.l7o_1 = Companion_getInstance_2().o3t_1;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.m7o_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  }
  c28(_set____db54di) {
    this.e7o_1.c28(_set____db54di);
  }
  d28() {
    return this.e7o_1.d28();
  }
  q3() {
    return this.h7o_1;
  }
  c79(_set____db54di) {
    this.i7o_1 = _set____db54di;
  }
  d79() {
    return this.i7o_1;
  }
  e79(_set____db54di) {
    this.j7o_1 = _set____db54di;
  }
  f79() {
    return this.j7o_1;
  }
  j79(_set____db54di) {
    this.k7o_1 = _set____db54di;
  }
  k79() {
    return this.k7o_1;
  }
  c30() {
    return this.l7o_1;
  }
  n7o() {
    return this.m7o_1;
  }
  r7o(coroutineContext, params) {
    throw NotImplementedError.je();
  }
  toString() {
    return "NativeSound('" + this.q3() + "')";
  }
}
class SoundChannelState extends Enum {
  w7o() {
    return this.equals(SoundChannelState_PAUSED_getInstance());
  }
}
class SoundAudioData$play$4 extends SoundChannel {
  constructor($nas, this$0, $pos, $box) {
    if ($box === VOID)
      $box = {};
    $box.t7p_1 = $nas;
    $box.u7p_1 = this$0;
    $box.v7p_1 = $pos;
    super(this$0, $box);
    var tmp = this;
    var tmp_0;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_0 = $nas._v;
    }
    tmp.q7p_1 = volume$factory(tmp_0);
    var tmp_1 = this;
    var tmp_2;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = $nas._v;
    }
    tmp_1.r7p_1 = pitch$factory(tmp_2);
    var tmp_3 = this;
    var tmp_4;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_4 = $nas._v;
    }
    tmp_3.s7p_1 = panning$factory(tmp_4);
  }
  c79(_set____db54di) {
    var this_0 = this.q7p_1;
    volume$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  d79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q7p_1;
    volume$factory_1();
    return this_0.get();
  }
  j79(_set____db54di) {
    var this_0 = this.r7p_1;
    pitch$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  k79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.r7p_1;
    pitch$factory_1();
    return this_0.get();
  }
  e79(_set____db54di) {
    var this_0 = this.s7p_1;
    panning$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  f79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s7p_1;
    panning$factory_1();
    return this_0.get();
  }
  b7o(value) {
    this.v7p_1._v = this.u7p_1.g7p_1.b78(value);
  }
  c7o() {
    return this.u7p_1.g7p_1.a78(this.v7p_1._v);
  }
  d7o() {
    return this.u7p_1.g7p_1.z77();
  }
  o7o() {
    var tmp;
    var tmp_0;
    if (this.t7p_1._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_0 = this.t7p_1._v;
    }
    if (!tmp_0.s78_1) {
      tmp = SoundChannelState_STOPPED_getInstance();
    } else {
      var tmp_1;
      if (this.t7p_1._v == null) {
        throwUninitializedPropertyAccessException('nas');
      } else {
        tmp_1 = this.t7p_1._v;
      }
      if (tmp_1.n78_1) {
        tmp = SoundChannelState_PAUSED_getInstance();
      } else {
        tmp = SoundChannelState_PLAYING_getInstance();
      }
    }
    return tmp;
  }
  p7o() {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (this.t7p_1._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = this.t7p_1._v;
    }
    tmp.n78_1 = true;
    return Unit_instance;
  }
  q7o() {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (this.t7p_1._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = this.t7p_1._v;
    }
    tmp.n78_1 = false;
    return Unit_instance;
  }
}
class SoundAudioData extends Sound {
  constructor(coroutineContext, audioData, soundProvider, name) {
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = audioData.t77_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    super(coroutineContext);
    this.g7p_1 = audioData;
    this.h7p_1 = soundProvider;
    this.i7p_1 = name;
  }
  q3() {
    return this.i7p_1;
  }
  r7o(coroutineContext, params) {
    var pos = {_v: 0};
    var times = {_v: new PlaybackTimes(params.l7n_1)};
    var nas = {_v: null};
    var tmp = this.h7p_1;
    var tmp_0 = this.g7p_1.u77();
    nas._v = tmp.a7a(tmp_0, this.g7p_1.r77_1, SoundAudioData$play$lambda(times, pos, this, nas));
    var tmp_1;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_1 = nas._v;
    }
    copySoundPropsFromCombined(tmp_1, params, this);
    var tmp_2;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = nas._v;
    }
    tmp_2.h79();
    var tmp_3 = SoundAudioData$play$lambda_0(nas);
    onCancel(coroutineContext, tmp_3, SoundAudioData$play$lambda_1(nas));
    return new SoundAudioData$play$4(nas, this, pos);
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.x7q_1 = ConcurrentPool.p42(VOID, VOID, SoundAudioStream$Companion$ID_POOL$lambda);
  }
}
class SoundAudioStream$play$slambda {
  constructor(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
    this.l7q_1 = this$0;
    this.m7q_1 = $newStream;
    this.n7q_1 = $params;
    this.o7q_1 = $playing;
    this.p7q_1 = $times;
    this.q7q_1 = $nas;
    this.r7q_1 = $currentPositionRequest;
    this.s7q_1 = $dequeLock;
    this.t7q_1 = $deque;
    this.u7q_1 = $BUFFER_SAMPLES;
    this.v7q_1 = $flushing;
    this.w7q_1 = $channelId;
  }
  f2y($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  le(p1, $completion) {
    return this.f2y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundAudioStream$play$1 extends SoundChannel {
  constructor($nas, this$0, $currentPositionRequest, $newStream, $playing, $job, $box) {
    if ($box === VOID)
      $box = {};
    $box.i7r_1 = $nas;
    $box.j7r_1 = this$0;
    $box.k7r_1 = $currentPositionRequest;
    $box.l7r_1 = $newStream;
    $box.m7r_1 = $playing;
    $box.n7r_1 = $job;
    super(this$0.k7q_1, $box);
    this.f7r_1 = volume$factory_2($nas);
    this.g7r_1 = pitch$factory_2($nas);
    this.h7r_1 = panning$factory_2($nas);
  }
  c79(_set____db54di) {
    var this_0 = this.f7r_1;
    volume$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  d79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f7r_1;
    volume$factory_4();
    return this_0.get();
  }
  j79(_set____db54di) {
    var this_0 = this.g7r_1;
    pitch$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  k79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g7r_1;
    pitch$factory_4();
    return this_0.get();
  }
  e79(_set____db54di) {
    var this_0 = this.h7r_1;
    panning$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  f79() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h7r_1;
    panning$factory_4();
    return this_0.get();
  }
  b7o(value) {
    this.k7r_1._v = new Duration(value);
  }
  c7o() {
    var tmp = this.k7r_1._v;
    var tmp0_elvis_lhs = tmp == null ? null : tmp.lk_1;
    var tmp_0;
    var tmp_1 = tmp0_elvis_lhs;
    if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
      var tmp45_safe_receiver = this.l7r_1._v;
      tmp_0 = tmp45_safe_receiver == null ? null : tmp45_safe_receiver.i7i();
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    var tmp_3 = tmp1_elvis_lhs;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      tmp_2 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    return tmp_2;
  }
  d7o() {
    var tmp46_safe_receiver = this.l7r_1._v;
    var tmp0_elvis_lhs = tmp46_safe_receiver == null ? null : tmp46_safe_receiver.h7i();
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = this.j7r_1.f7q_1.h7i();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  o7o() {
    return this.i7r_1.n78_1 ? SoundChannelState_PAUSED_getInstance() : this.m7r_1._v ? SoundChannelState_PLAYING_getInstance() : SoundChannelState_STOPPED_getInstance();
  }
  p7o() {
    this.i7r_1.n78_1 = true;
  }
  q7o() {
    this.i7r_1.n78_1 = false;
  }
}
class SoundAudioStream extends Sound {
  constructor(coroutineContext, stream, soundProvider, closeStream, name, onComplete) {
    Companion_getInstance_16();
    closeStream = closeStream === VOID ? false : closeStream;
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = stream.p7h_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.f7q_1 = stream;
    this.g7q_1 = soundProvider;
    this.h7q_1 = closeStream;
    this.i7q_1 = name;
    this.j7q_1 = onComplete;
    this.k7q_1 = this;
  }
  q3() {
    return this.i7q_1;
  }
  n7o() {
    return this.f7q_1.h7i();
  }
  o7r() {
    return this.f7q_1.o7h_1;
  }
  r7o(coroutineContext, params) {
    var dequeLock = new Lock();
    var deque = new AudioSamplesDeque(this.o7r());
    var playing = {_v: true};
    var flushing = {_v: false};
    var newStream = {_v: null};
    var channelId = Companion_getInstance_16().x7q_1.f42();
    var dispatcherName = 'SoundChannel-SoundAudioStream-' + channelId;
    var times = {_v: new PlaybackTimes(params.l7n_1)};
    var BUFFER_SAMPLES = nextMultipleOf(numberToInt(this.f7q_1.n7h_1 * get_seconds(params.n7n_1)), Companion_instance.f78_1);
    var tmp = this.g7q_1;
    var tmp_0 = this.o7r();
    var nas = tmp.a7a(tmp_0, this.f7q_1.n7h_1, SoundAudioStream$play$lambda(dequeLock, flushing, deque, BUFFER_SAMPLES));
    copySoundPropsFromCombined(nas, params, this);
    var currentPositionRequest = {_v: null};
    var tmp_1 = CoroutineScope_0(coroutineContext);
    var job = launch(tmp_1, coroutineContext, VOID, SoundAudioStream$play$slambda_0(this, newStream, params, playing, times, nas, currentPositionRequest, dequeLock, deque, BUFFER_SAMPLES, flushing, channelId));
    return new SoundAudioStream$play$1(nas, this, currentPositionRequest, newStream, playing, job);
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.w1();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.t7a_1 = null;
  return $this;
}
function *_generator_tryReadInfo__rowfdh($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.s7a_1.b1();
  $l$loop: while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var tmp = format.w7a(data.z33(), props, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return tmp_0;
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
        } else {
          throw $p;
        }
      }
    }
  }
  return null;
}
function *_generator_decodeStreamInternal__hls877($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.s7a_1.b1();
  $l$loop_0: while (_iterator__ex2g4s.c1()) {
    var format = _iterator__ex2g4s.d1();
    try {
      var tmp = format.w7a(data.z33(), Companion_getInstance_4().y7a_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      if (tmp == null)
        continue $l$loop_0;
      var tmp_0 = format.z7a(data.z33(), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp0_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      return tmp_1;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  return null;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.q7a([Companion_getInstance_11(), Companion_getInstance_8()]);
}
function *_generator_decodeStream__ydjika($this, data, props, $completion) {
  var tmp;
  if (!(props.n7b_1 == null)) {
    var tmp_0 = withContext(props.n7b_1, AudioFormat$decodeStream$slambda_0($this, data, props), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = $this.b7b(data, props, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamOrError__s0emn1($this, data, props, $completion) {
  var tmp = $this.z7a(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp_1 = $this.toString();
    var tmp_2 = readBytesUpTo(data.z33(), 8, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var message = "Can't decode audio stream [" + tmp_1 + '] ' + toHexString(tmp_2);
    throw IllegalStateException.h5(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function AudioFormat$decodeStream$slambda_0(this$0, $data, $props) {
  var i = new AudioFormat$decodeStream$slambda(this$0, $data, $props);
  var l = function ($this$withContext, $completion) {
    return i.f2y($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function invalidAudioFormat(message) {
  message = message === VOID ? 'invalid audio format' : message;
  _init_properties_AudioFormat_kt__9os7np();
  throw InvalidAudioFormatException.u7b(message);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var ChannelMode_STEREO_instance;
var ChannelMode_JOINT_STEREO_instance;
var ChannelMode_DUAL_CHANNEL_instance;
var ChannelMode_SINGLE_CHANNEL_instance;
var Companion_instance_3;
function Companion_getInstance_6() {
  ChannelMode_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
function values() {
  return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
}
var ChannelMode_entriesInitialized;
function ChannelMode_initEntries() {
  if (ChannelMode_entriesInitialized)
    return Unit_instance;
  ChannelMode_entriesInitialized = true;
  ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
  ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
  ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
  ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
  Companion_getInstance_6();
}
function framesize($this, layer, bitrate, sample_rate, padding_bit) {
  if (sample_rate === 0) {
    // Inline function 'kotlin.error' call
    var message = 'division by 0';
    throw IllegalStateException.h5(toString(message));
  }
  var tmp;
  if (layer === 1) {
    tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
  } else {
    tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
  }
  return tmp;
}
function ChannelMode_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_STEREO_instance;
}
function ChannelMode_JOINT_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_JOINT_STEREO_instance;
}
function ChannelMode_DUAL_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_DUAL_CHANNEL_instance;
}
function ChannelMode_SINGLE_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_SINGLE_CHANNEL_instance;
}
function *_generator_getSeekingTable__ywx4sa($this, $completion) {
  var times = DoubleArrayList.f3x();
  var filePositions = DoubleArrayList.f3x();
  var tmp = _getDuration($this, false, MP3Base$Parser$getSeekingTable$lambda(times, filePositions), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.lk_1;
  return new SeekingTable(times, filePositions);
}
function *_generator__getDuration__467r4t($this, use_cbr_estimate, emit, $completion) {
  $this.i7c_1.b33_1 = new Long(0, 0);
  var fd = $this.i7c_1.z33();
  var tmp = fd.g32($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var len = tmp;
  var durationMicroseconds = 0.0;
  var tmp_0 = readStream(fd, 100, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = skipID3v2Tag($this, tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var offset = tmp_1;
  var pos = offset;
  var info = null;
  var nframes = 0;
  var block2 = _UByteArrayInt___init__impl__xif7bu(new Int8Array(10));
  var fdbase = fd.a33_1;
  var fdsync = toSyncOrNull(fdbase);
  var nreads = 0;
  var nskips = 0;
  var nasync = 0;
  try {
    $l$loop: while (pos.b2(len) < 0) {
      var tmp_2;
      if (!(fdsync == null)) {
        tmp_2 = fdsync.q31(pos, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10);
      } else {
        nasync = nasync + 1 | 0;
        fd.b33_1 = pos;
        var tmp_3 = readBytesUpTo_0(fd, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      var block2Size = tmp_2;
      nreads = nreads + 1 | 0;
      if (block2Size < 10)
        break $l$loop;
      // Inline function 'kotlin.Long.plus' call
      pos = pos.w3(toLong(block2Size));
      if (UByteArrayInt__get_impl_px6q8a(block2, 0) === 255 && !((UByteArrayInt__get_impl_px6q8a(block2, 1) & 224) === 0)) {
        info = Companion_getInstance_7().q7c(block2);
        if (emit == null)
          null;
        else
          emit(pos, durationMicroseconds, info);
        nframes = nframes + 1 | 0;
        $this.k7c_1 = info;
        if (info.g7c_1 === 0) {
          // Inline function 'korlibs.time.microseconds' call
          var this_0 = durationMicroseconds;
          var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
          return new Duration(tmp$ret$1);
        }
        // Inline function 'kotlin.Long.plus' call
        var this_1 = pos;
        var other = info.g7c_1 - 10 | 0;
        pos = this_1.w3(toLong(other));
        var tmp_4 = durationMicroseconds;
        // Inline function 'kotlin.Long.div' call
        var this_2 = numberToLong(info.h7c_1).x3(new Long(1000000, 0));
        var other_0 = info.e7c_1;
        durationMicroseconds = tmp_4 + this_2.y3(toLong(other_0)).n4();
      } else if (readString(openSync(_UByteArrayInt___get_bytes__impl__pj0ilc(block2)), 3) === 'TAG') {
        // Inline function 'kotlin.Long.plus' call
        pos = pos.w3(toLong(118));
      } else {
        // Inline function 'kotlin.Long.minus' call
        pos = pos.c2(toLong(9));
        nskips = nskips + 1 | 0;
      }
      if (!(info == null) && use_cbr_estimate) {
        // Inline function 'korlibs.time.microseconds' call
        var tmp_5 = estimateDuration($this, info.d7c_1, info.f7c_1.z7b_1, offset.l2(), $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        var this_3 = tmp_5;
        var tmp$ret$6 = toDuration_0(this_3, DurationUnit_MICROSECONDS_getInstance());
        return new Duration(tmp$ret$6);
      }
    }
  }finally {
  }
  // Inline function 'korlibs.time.microseconds' call
  var this_4 = durationMicroseconds;
  var tmp$ret$7 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
  return new Duration(tmp$ret$7);
}
function _getDuration($this, use_cbr_estimate, emit, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__getDuration__467r4t.bind(VOID, $this, use_cbr_estimate, emit), $completion);
}
function _getDuration$default($this, use_cbr_estimate, emit, $completion, $super) {
  emit = emit === VOID ? null : emit;
  return _getDuration($this, use_cbr_estimate, emit, $completion);
}
function estimateDuration($this, bitrate, channels, offset, $completion) {
  var kbps = imul(bitrate, 1000) / 8 | 0;
  // Inline function 'kotlin.Long.minus' call
  var dataSize = $this.j7c_1.c2(toLong(offset));
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.Long.times' call
  var other = 2 / channels | 0;
  return dataSize.x3(toLong(other)).x3(new Long(1000000, 0)).y3(toLong(kbps));
}
function *_generator_skipID3v2Tag__vewobn($this, block, $completion) {
  var b = block.z33();
  var tmp = readString_0(b, 3, Charsets_instance.n25(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp === 'ID3') {
    var tmp_0 = readBytesExact(b, 7, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var bb = tmp_0;
    var id3v2_major_version = getU8(bb, 0);
    var id3v2_minor_version = getU8(bb, 1);
    var id3v2_flags = getU8(bb, 2);
    var z0 = getU8(bb, 3);
    var z1 = getU8(bb, 4);
    var z2 = getU8(bb, 5);
    var z3 = getU8(bb, 6);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_unsynchronisation = !(((id3v2_flags >>> 7 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_extended_header = !(((id3v2_flags >>> 6 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_experimental_ind = !(((id3v2_flags >>> 5 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_footer_present = !(((id3v2_flags >>> 4 | 0) & 1) === 0);
    if ((z0 & 128) === 0 && (z1 & 128) === 0 && (z2 & 128) === 0 && (z3 & 128) === 0) {
      var header_size = 10;
      var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
      var footer_size = flag_footer_present ? 10 : 0;
      return toLong((header_size + tag_size | 0) + footer_size | 0);
    }
  }
  return new Long(0, 0);
}
function skipID3v2Tag($this, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_skipID3v2Tag__vewobn.bind(VOID, $this, block), $completion);
}
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function MP3Base$Parser$getSeekingTable$lambda($times, $filePositions) {
  return function (filePos, totalMicro, info) {
    $times.s29(totalMicro);
    $filePositions.s29(filePos.n4());
    return Unit_instance;
  };
}
function *_generator_tryReadInfo__rowfdh_0($this, data, props, $completion) {
  try {
    var tmp = readBytesExact(data, 4, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var header = tmp;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = header.slice();
    var tmp$ret$2 = _UByteArray___init__impl__ip4y9n(tmp$ret$1);
    var this_0 = UByteArray__get_impl_t5f3hv(tmp$ret$2, 0);
    var h0 = _UByte___get_data__impl__jof9qr(this_0) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = header.slice();
    var tmp$ret$6 = _UByteArray___init__impl__ip4y9n(tmp$ret$5);
    var this_1 = UByteArray__get_impl_t5f3hv(tmp$ret$6, 1);
    var h1 = _UByte___get_data__impl__jof9qr(this_1) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = header.slice();
    var tmp$ret$10 = _UByteArray___init__impl__ip4y9n(tmp$ret$9);
    var this_2 = UByteArray__get_impl_t5f3hv(tmp$ret$10, 2);
    var h2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
    var isId3 = readStringz(header, 0, 3) === 'ID3';
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226)) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_2 = !(((h1 >>> 1 | 0) & 3) === 0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'korlibs.memory.extract4' call
      tmp_1 = !(((h2 >>> 4 | 0) & 15) === 15);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_0 = !(((h2 >>> 2 | 0) & 3) === 3);
    } else {
      tmp_0 = false;
    }
    var isSync = tmp_0;
    if (!isId3 && !isSync)
      return null;
    var tmp_3 = data.g32($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var parser = new Parser(data, tmp_3);
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.fk();
    // Inline function 'korlibs.audio.format.MP3Base.tryReadInfo.<anonymous>' call
    var tmp_4;
    switch (props.j7b_1) {
      case null:
        var tmp_5 = parser.s7c($completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5.lk_1;
        break;
      case true:
        var tmp_6 = parser.s7c($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        tmp_4 = tmp_6.lk_1;
        break;
      default:
        var tmp_7 = parser.t7c($completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        tmp_4 = tmp_7.lk_1;
        break;
    }
    var result = new Duration(tmp_4);
    var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    var duration = _destruct__k2r9zo.em().lk_1;
    var decodingTime = _destruct__k2r9zo.ss();
    var tmp3_safe_receiver = parser.k7c_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.f7c_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.z7b_1;
    return new Info(duration, tmp0_elvis_lhs == null ? 2 : tmp0_elvis_lhs, decodingTime);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      return null;
    } else {
      throw $p;
    }
  }
}
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 === VOID)
    new Companion_4();
  return Companion_instance_5;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
function *_generator_seek__qhx6y8($this, position, $completion) {
  $this.d7h_1 = false;
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$0 = toDuration(0.0, DurationUnit_SECONDS_getInstance());
  if (equals(position, tmp$ret$0)) {
    $this.i7h_1.b33_1 = new Long(0, 0);
    $this.f7h_1 = new Long(0, 0);
  } else {
    if ($this.h7h_1._v == null) {
      var tmp0_elvis_lhs = $this.j7h_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        var tmp_1 = $this.i7h_1.h32($completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        if (tmp_1) {
          var tmp_2 = $this.i7h_1.g32($completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
          var tmp_3 = (new Parser($this.i7h_1, tmp_2)).z7c($completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          tmp_0 = tmp_3;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      $this.h7h_1._v = tmp;
    }
    if (!($this.h7h_1._v == null)) {
      var offset = ensureNotNull($this.h7h_1._v).y7c(position);
      $this.i7h_1.b33_1 = offset;
      $this.f7h_1 = $this.t7h(position);
    } else {
      println("Couldn't create mp3SeekingTable");
    }
  }
  $this.g7h_1.d7e().u1w();
  return Unit_instance;
}
function *_generator_read__qih2oe($this, out, offset, length, $completion) {
  var noMoreSamples = false;
  $l$loop: while (ensureNotNull($this.g7h_1.d7e().h7e_1).u2d() < length) {
    var tmp = createDecoderStream$readMoreSamples($this.g7h_1, $this.i7h_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      noMoreSamples = true;
      break $l$loop;
    }
  }
  // Inline function 'kotlin.also' call
  var tmp_0;
  if (noMoreSamples && ensureNotNull($this.g7h_1.d7e().h7e_1).u2d() === 0) {
    $this.d7h_1 = true;
    tmp_0 = 0;
  } else {
    tmp_0 = ensureNotNull($this.g7h_1.d7e().h7e_1).w7h(out, offset, length);
  }
  var this_0 = tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.format.<no name provided>.read.<anonymous>' call
  var tmp_1 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_1.f7h_1 = $this.f7h_1.w3(toLong(this_0));
  return this_0;
}
function *_generator_createDecoderStream__oszsb8($this, data, props, table, $completion) {
  var dataStartPosition = data.b33_1;
  var decoder = $this.w7g();
  decoder.d7e().u1w();
  var tmp;
  if (props.j7b_1 === true) {
    var tmp_0;
    if (table == null) {
      var tmp_1;
      var tmp_2 = data.h32($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      if (tmp_2) {
        var tmp_3 = data.g32($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp_4 = (new Parser(data, tmp_3)).z7c($completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp_1 = tmp_4;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = table;
    }
    tmp = tmp_0;
  } else {
    tmp = null;
  }
  var mp3SeekingTable = {_v: tmp};
  var tmp_5 = createDecoderStream$readMoreSamples(decoder, data, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return new BaseMinimp3AudioFormat$createDecoderStream$2(decoder, mp3SeekingTable, data, table, $this, dataStartPosition, props);
}
function createDecoderStream($this, data, props, table, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream__oszsb8.bind(VOID, $this, data, props, table), $completion);
}
var Companion_instance_6;
function Companion_getInstance_9() {
  if (Companion_instance_6 === VOID)
    new Companion_5();
  return Companion_instance_6;
}
function *_generator_createDecoderStream$readMoreSamples__md5fam(decoder, $data, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (decoder.d7e().g7e_1.u2d() < decoder.d7e().f7e_1.length) {
      var tmp_0 = $data.x33($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = decoder.d7e().g7e_1;
      var tmp_2 = readBytesUpTo($data, 4096, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.q3v(tmp_2);
    }
    var result = decoder.d7e().x7h(decoder);
    if (decoder.d7e().i7e_1 === 0 || decoder.d7e().k7e_1 === 0)
      continue $l$loop;
    return result;
  }
}
function createDecoderStream$readMoreSamples(decoder, $data, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream$readMoreSamples__md5fam.bind(VOID, decoder, $data), $completion);
}
function arrayOfUByte($this, values, size) {
  return _UByteArrayInt___init__impl__xif7bu_0(size, MiniMp3Program$Companion$arrayOfUByte$lambda(values));
}
function arrayOfUByte$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfUByte($this, values, size);
}
function arrayOfShort($this, values, size) {
  var tmp = 0;
  var tmp_0 = new Int16Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= tmp_1 ? tmp_1 <= (charSequenceLength(values) - 1 | 0) : false) {
      tmp_2 = charSequenceGet(values, tmp_1);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfShort.<anonymous>' call
      tmp_2 = _Char___init__impl__6a9atx(0);
    }
    var this_0 = tmp_2;
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
    tmp_0[tmp_1] = toShort(tmp$ret$2);
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function arrayOfShort$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfShort($this, values, size);
}
function MiniMp3Program$Companion$arrayOfUByte$lambda($values) {
  return function (it) {
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = $values;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= it ? it <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, it);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfUByte.<anonymous>.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    var this_1 = tmp;
    return Char__toInt_impl_vasixd(this_1);
  };
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function toInt_0(_this__u8e3s4, $this) {
  return _this__u8e3s4 ? 1 : 0;
}
function *_generator_read__qih2oe_0($this, out, offset, length, $completion) {
  var tmp = readBytesUpTo($this.x7l_1, imul(imul(length, $this.b7m_1), $this.o7h_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  var tmp_0 = $this;
  var tmp_1 = $this.x7l_1.a34($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.c7m_1 = tmp_1;
  var availableSamples = (bytes.length / $this.b7m_1 | 0) / $this.o7h_1 | 0;
  var inductionVariable = 0;
  var last = $this.o7h_1;
  if (inductionVariable < last)
    do {
      var channel = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      switch ($this.b7m_1) {
        case 1:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels = $this.o7h_1;
          var bytesPerSample = $this.b7m_1;
          var increment = imul(channels, bytesPerSample);
          var index = imul(channel, bytesPerSample);
          var outc = out.r79(channel);
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < availableSamples)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp_2 = offset + n | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it = index;
              var tmp$ret$0 = _AudioSample___init__impl__s54gd5(toShortClamped(imul(getU8(bytes, it) - 128 | 0, 255)));
              AudioSampleArray__set_impl_tqgfwk(outc, tmp_2, tmp$ret$0);
              index = index + increment | 0;
            }
             while (inductionVariable_0 < availableSamples);
          break;
        case 2:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_0 = $this.o7h_1;
          var bytesPerSample_0 = $this.b7m_1;
          var increment_0 = imul(channels_0, bytesPerSample_0);
          var index_0 = imul(channel, bytesPerSample_0);
          var outc_0 = out.r79(channel);
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < availableSamples)
            do {
              var n_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_3 = offset + n_0 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_0 = index_0;
              var tmp$ret$1 = _AudioSample___init__impl__s54gd5(toShort(getS16LE(bytes, it_0)));
              AudioSampleArray__set_impl_tqgfwk(outc_0, tmp_3, tmp$ret$1);
              index_0 = index_0 + increment_0 | 0;
            }
             while (inductionVariable_1 < availableSamples);
          break;
        case 3:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_1 = $this.o7h_1;
          var bytesPerSample_1 = $this.b7m_1;
          var increment_1 = imul(channels_1, bytesPerSample_1);
          var index_1 = imul(channel, bytesPerSample_1);
          var outc_1 = out.r79(channel);
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < availableSamples)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp_4 = offset + n_1 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_1 = index_1;
              var tmp$ret$2 = _AudioSample___init__impl__s54gd5(toShort(getS24LE(bytes, it_1) >>> 8 | 0));
              AudioSampleArray__set_impl_tqgfwk(outc_1, tmp_4, tmp$ret$2);
              index_1 = index_1 + increment_1 | 0;
            }
             while (inductionVariable_2 < availableSamples);
          break;
        default:
          invalidOp('Unsupported bytesPerSample=' + $this.b7m_1);
          break;
      }
    }
     while (inductionVariable < last);
  return availableSamples;
}
function *_generator_clone__nh2r5j($this, $completion) {
  var tmp = (new WAV()).b7b($this.z7l_1.z33(), $this.a7m_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return ensureNotNull(tmp);
}
function *_generator_invoke__zhh2q8($this, $this$riff, $completion) {
  var type = $this$riff.em();
  var d2 = $this$riff.fm();
  var d = d2.z33();
  var cdata = Unit_instance;
  switch (type) {
    case 'fmt ':
      var tmp = $this.g7m_1;
      var tmp_0 = readS16LE(d, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp.j7m_1 = tmp_0;
      var tmp_1 = $this.g7m_1;
      var tmp_2 = readS16LE(d, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.k7m_1 = tmp_2;
      var tmp_3 = $this.g7m_1;
      var tmp_4 = readS32LE(d, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_3.l7m_1 = tmp_4;
      var tmp_5 = $this.g7m_1;
      var tmp_6 = readU32LE(d, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_5.m7m_1 = tmp_6;
      var tmp_7 = $this.g7m_1;
      var tmp_8 = readS16LE(d, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      tmp_7.n7m_1 = tmp_8;
      var tmp_9 = $this.g7m_1;
      var tmp_10 = readS16LE(d, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      tmp_9.o7m_1 = tmp_10;
      cdata = $this.g7m_1;
      break;
    case 'data':
      var tmp_11 = $this.h7m_1._v;
      var tmp_12 = d.g32($completion);
      if (tmp_12 === get_COROUTINE_SUSPENDED())
        tmp_12 = yield tmp_12;
      $this.h7m_1._v = tmp_11.w3(tmp_12);
      cdata = d;
      break;
    default:
      break;
  }
  $this.i7m_1(new ProcessedChunk($this$riff.e7m_1, $this$riff.f7m_1, cdata));
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function *_generator_tryReadInfo__rowfdh_1($this, data, props, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.p7m(data, WAV$tryReadInfo$lambda, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamInternal__hls877_0($this, data, props, $completion) {
  var fmt = {_v: new Fmt()};
  var buffer = {_v: toAsync(MemorySyncStream())};
  var tmp = $this.p7m(data, WAV$decodeStreamInternal$lambda(fmt, buffer), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = fmt._v;
  var tmp_1 = buffer._v;
  var tmp_2 = buffer._v.g32($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new WavAudioStream(tmp_0, tmp_1, tmp_2, data, props);
}
function *_generator_parse__tgo4f5($this, data, handle, $completion) {
  var fmt = new Fmt();
  var dataSize = {_v: new Long(0, 0)};
  var tmp = $this.q7m(data, WAV$parse$slambda_0(fmt, dataSize, handle), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (fmt.j7m_1 < 0) {
    invalidOp("Couldn't find RIFF 'fmt ' chunk");
  }
  // Inline function 'korlibs.time.microseconds' call
  // Inline function 'kotlin.Long.times' call
  // Inline function 'kotlin.Long.times' call
  var this_0 = dataSize._v.x3(toLong(1000)).x3(toLong(1000)).y3(fmt.m7m_1);
  var tmp$ret$2 = toDuration_0(this_0, DurationUnit_MICROSECONDS_getInstance());
  return new Info(tmp$ret$2, fmt.k7m_1);
}
function *_generator_riff__qieez3($this, data, handler, $completion) {
  var s2 = data.z33();
  var tmp = s2.y33($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp.b2(new Long(12, 0)) < 0) {
    // Inline function 'kotlin.error' call
    var message = 'Not enough data for a RIFF file';
    throw IllegalStateException.h5(toString(message));
  }
  var tmp_0 = readString_0(s2, 4, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var magic = tmp_0;
  var tmp_1 = readS32LE(s2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var length = tmp_1;
  var tmp_2 = readString_0(s2, 4, VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var magic2 = tmp_2;
  if (!(magic === 'RIFF')) {
    invalidAudioFormat("Not a RIFF file but '" + magic + "'");
  }
  if (!(magic2 === 'WAVE')) {
    invalidAudioFormat('Not a RIFF + WAVE file');
  }
  var tmp_3 = readStream(s2, length - 4 | 0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var s = tmp_3;
  $l$loop_1: while (true) {
    var tmp_4 = s.a34($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    if (!!tmp_4) {
      break $l$loop_1;
    }
    var tmp_5 = s.y33($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    if (tmp_5.b2(new Long(8, 0)) < 0)
      break $l$loop_1;
    var tmp_6 = readString_0(s, 4, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var type = tmp_6;
    var tmp_7 = readS32LE(s, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var size = tmp_7;
    var tmp_8 = s.y33($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    if (tmp_8.b2(toLong(size)) < 0)
      break $l$loop_1;
    var tmp_9 = readStream(s, size, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var d = tmp_9;
    var tmp_10 = handler(new Chunk(type, d), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  return Unit_instance;
}
function WAV$tryReadInfo$lambda(it) {
  return Unit_instance;
}
function WAV$decodeStreamInternal$lambda($fmt, $buffer) {
  return function (it) {
    var extra = it.t7m_1;
    var tmp;
    if (extra instanceof Fmt) {
      $fmt._v = extra;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (it.r7m_1 === 'data') {
      $buffer._v = it.s7m_1;
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function WAV$parse$slambda_0($fmt, $dataSize, $handle) {
  var i = new WAV$parse$slambda($fmt, $dataSize, $handle);
  var l = function ($this$riff, $completion) {
    return i.v7m($this$riff, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
var DEFAULT_MAX_SAMPLES;
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function *_generator_toData__gg6t99(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  var out = new AudioSamplesDeque(_this__u8e3s4.o7h_1);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(maxSamples, 65536);
  var buffer = new AudioSamples(_this__u8e3s4.o7h_1, tmp$ret$0);
  try {
    $l$loop_0: while (!_this__u8e3s4.b7i()) {
      // Inline function 'kotlin.math.min' call
      var a = maxSamples - out.u2d() | 0;
      var b = buffer.w77_1;
      var tmp$ret$1 = Math.min(a, b);
      var tmp = _this__u8e3s4.f7i(buffer, 0, tmp$ret$1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var read = tmp;
      if (read <= 0)
        break $l$loop_0;
      // Inline function 'kotlin.math.min' call
      var b_0 = maxSamples - out.u2d() | 0;
      var mread = Math.min(read, b_0);
      out.z7m(buffer, 0, mread);
      if (out.u2d() >= maxSamples)
        break $l$loop_0;
    }
  }finally {
    _this__u8e3s4.p6();
  }
  var maxOutSamples = out.w7m();
  // Inline function 'kotlin.apply' call
  var this_0 = new AudioSamples(_this__u8e3s4.o7h_1, maxOutSamples);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.sound.toData.<anonymous>' call
  out.c7n(this_0);
  return new AudioData(_this__u8e3s4.n7h_1, this_0);
}
function toData(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toData__gg6t99.bind(VOID, _this__u8e3s4, maxSamples), $completion);
}
function get_audioFormats(_this__u8e3s4) {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  // Inline function 'kotlin.getValue' call
  var this_0 = audioFormats$delegate;
  audioFormats$factory();
  return this_0.w1();
}
var audioFormats$delegate;
function *_generator_createSound__kkt3xd(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = createSound_0(_this__u8e3s4, tmp, streaming, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function createSound(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd.bind(VOID, _this__u8e3s4, file, streaming, props), $completion);
}
function createSound_0(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  return createSound_1(_this__u8e3s4, file.x3d(), file.d3e(), streaming, props, $completion);
}
function *_generator_createSound__kkt3xd_0(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  var tmp;
  if (streaming) {
    var vfsFile = vfs.d3g(path);
    var tmp_0;
    if (props.k7b_1) {
      var tmp_1 = vfsFile.b3h($completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = openAsync(tmp_1);
    } else {
      var tmp_2 = vfsFile.a3h(VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
    }
    var stream = tmp_0;
    var tmp0_elvis_lhs = props.l7b_1;
    var tmp_3 = (tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs).c7b(stream, props, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = get_baseName(vfsFile);
    var tmp_5 = createStreamingSound(_this__u8e3s4, tmp_3, VOID, tmp_4, createSound$slambda_0(stream), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp = tmp_5;
  } else {
    var tmp_6 = vfs.d3g(path).x3g($completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = createSound_2(_this__u8e3s4, tmp_6, streaming, props, get_baseName(vfs.cj(path)), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    tmp = tmp_7;
  }
  return tmp;
}
function createSound_1(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_0.bind(VOID, _this__u8e3s4, vfs, path, streaming, props), $completion);
}
function createStreamingSound(_this__u8e3s4, stream, closeStream, name, onComplete, $completion) {
  closeStream = closeStream === VOID ? false : closeStream;
  name = name === VOID ? 'Unknown' : name;
  onComplete = onComplete === VOID ? null : onComplete;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.hd();
  return new SoundAudioStream(tmp$ret$0, stream, _this__u8e3s4, closeStream, name, onComplete);
}
function *_generator_createSound__kkt3xd_1(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  name = name === VOID ? 'Unknown' : name;
  var tmp0_elvis_lhs = props.l7b_1;
  var format = tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs;
  var tmp = format.c7b(openAsync(data), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  var tmp_0;
  if (streaming) {
    var tmp_1 = createStreamingSound(_this__u8e3s4, stream, true, name, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    var tmp_2 = toData(stream, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = createNonStreamingSound(_this__u8e3s4, tmp_2, name, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  }
  return tmp_0;
}
function createSound_2(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  name = name === VOID ? 'Unknown' : name;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_1.bind(VOID, _this__u8e3s4, data, streaming, props, name), $completion);
}
function createNonStreamingSound(_this__u8e3s4, data, name, $completion) {
  name = name === VOID ? 'Unknown' : name;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp = $completion.hd();
  var tmp0_elvis_lhs = data.t77_1;
  return new SoundAudioData(tmp, data, _this__u8e3s4, tmp0_elvis_lhs == null ? name : tmp0_elvis_lhs);
}
function audioFormats$delegate$lambda() {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  return get_defaultAudioFormats();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.f7n_1.r2z($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function createSound$slambda_0($stream) {
  var i = new createSound$slambda($stream);
  var l = function ($completion) {
    return i.ke($completion);
  };
  l.$arity = 0;
  return l;
}
function audioFormats$factory() {
  return getPropertyCallableRef('audioFormats', 1, KProperty1, function (receiver) {
    return get_audioFormats(receiver);
  }, null);
}
var properties_initialized_NativeSoundProviderExt_kt_zegpk6;
function _init_properties_NativeSoundProviderExt_kt__owf0qw() {
  if (!properties_initialized_NativeSoundProviderExt_kt_zegpk6) {
    properties_initialized_NativeSoundProviderExt_kt_zegpk6 = true;
    audioFormats$delegate = lazy(audioFormats$delegate$lambda);
  }
}
function _PlaybackTimes___init__impl__rt6rw2(count) {
  return count;
}
function _PlaybackTimes___get_count__impl__ll6dcs($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  if (Companion_instance_11 === VOID)
    new Companion_10();
  return Companion_instance_11;
}
function _PlaybackTimes___get_hasMore__impl__ei8boc($this) {
  return !($this === Companion_getInstance_14().g7n_1);
}
function _PlaybackTimes___get_oneLess__impl__ea0jl8($this) {
  return $this === Companion_getInstance_14().i7n_1 ? Companion_getInstance_14().i7n_1 : _PlaybackTimes___init__impl__rt6rw2(_PlaybackTimes___get_count__impl__ll6dcs($this) - 1 | 0);
}
function PlaybackTimes__toString_impl_l4chjq($this) {
  return _PlaybackTimes___get_count__impl__ll6dcs($this) >= 0 ? '' + _PlaybackTimes___get_count__impl__ll6dcs($this) + ' times' : 'Infinite times';
}
function PlaybackTimes__hashCode_impl_mtf95($this) {
  return $this;
}
function PlaybackTimes__equals_impl_suah7n($this, other) {
  if (!(other instanceof PlaybackTimes))
    return false;
  if (!($this === (other instanceof PlaybackTimes ? other.j7n_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
function readSound(_this__u8e3s4, props, streaming, $completion) {
  props = props === VOID ? Companion_getInstance_4().x7a_1 : props;
  streaming = streaming === VOID ? false : streaming;
  return createSound(get_nativeSoundProvider(), _this__u8e3s4, streaming, props, $completion);
}
function get_paused(_this__u8e3s4) {
  return _this__u8e3s4.o7o().w7o();
}
var SoundChannelState_INITIAL_instance;
var SoundChannelState_PAUSED_instance;
var SoundChannelState_PLAYING_instance;
var SoundChannelState_STOPPED_instance;
var SoundChannelState_entriesInitialized;
function SoundChannelState_initEntries() {
  if (SoundChannelState_entriesInitialized)
    return Unit_instance;
  SoundChannelState_entriesInitialized = true;
  SoundChannelState_INITIAL_instance = new SoundChannelState('INITIAL', 0);
  SoundChannelState_PAUSED_instance = new SoundChannelState('PAUSED', 1);
  SoundChannelState_PLAYING_instance = new SoundChannelState('PLAYING', 2);
  SoundChannelState_STOPPED_instance = new SoundChannelState('STOPPED', 3);
}
function copySoundPropsFromCombined(_this__u8e3s4, l, r) {
  _this__u8e3s4.c79(l.d79() * r.d79());
  _this__u8e3s4.j79(l.k79() * r.k79());
  _this__u8e3s4.e79(r.f79());
}
function SoundChannelState_PAUSED_getInstance() {
  SoundChannelState_initEntries();
  return SoundChannelState_PAUSED_instance;
}
function SoundChannelState_PLAYING_getInstance() {
  SoundChannelState_initEntries();
  return SoundChannelState_PLAYING_instance;
}
function SoundChannelState_STOPPED_getInstance() {
  SoundChannelState_initEntries();
  return SoundChannelState_STOPPED_instance;
}
function SoundAudioData$play$lambda($times, $pos, this$0, $nas) {
  return function (buffer) {
    var tmp;
    if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().g7n_1))) {
      return Unit_instance;
    }
    var inductionVariable = 0;
    var last = buffer.z78_1;
    var tmp_0;
    if (inductionVariable < last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $pos._v;
        $pos._v = _unary__edvuaz + 1 | 0;
        var audioDataPos = _unary__edvuaz;
        if (audioDataPos >= this$0.g7p_1.y77() || $times._v.equals(new PlaybackTimes(Companion_getInstance_14().g7n_1))) {
          $pos._v = 0;
          audioDataPos = 0;
          $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.j7n_1));
          if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().g7n_1))) {
            var tmp_1;
            if ($nas._v == null) {
              throwUninitializedPropertyAccessException('nas');
            } else {
              tmp_1 = $nas._v;
            }
            tmp_1.i79();
            break $l$loop;
          }
        }
        var inductionVariable_0 = 0;
        var last_0 = buffer.y78_1;
        if (inductionVariable_0 < last_0)
          do {
            var ch = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var sample = audioDataPos < this$0.g7p_1.y77() ? this$0.g7p_1.c78(ch, audioDataPos) : Companion_getInstance_1().b79_1;
            buffer.s79(ch, n, sample);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function SoundAudioData$play$lambda_0($nas) {
  return function () {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    return tmp.s78_1;
  };
}
function SoundAudioData$play$lambda_1($nas) {
  return function (it) {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    tmp.i79();
    return Unit_instance;
  };
}
function volume$factory($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.p78_1;
  }, function (value) {
    $b0.p78_1 = value;
    return Unit_instance;
  });
}
function pitch$factory($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.k79();
  }, function (value) {
    return $b0.j79(value);
  });
}
function panning$factory($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.q78_1;
  }, function (value) {
    $b0.q78_1 = value;
    return Unit_instance;
  });
}
function volume$factory_0() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.d79();
  }, function (receiver, value) {
    return receiver.c79(value);
  });
}
function volume$factory_1() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.d79();
  }, function (receiver, value) {
    return receiver.c79(value);
  });
}
function pitch$factory_0() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.k79();
  }, function (receiver, value) {
    return receiver.j79(value);
  });
}
function pitch$factory_1() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.k79();
  }, function (receiver, value) {
    return receiver.j79(value);
  });
}
function panning$factory_0() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.f79();
  }, function (receiver, value) {
    return receiver.e79(value);
  });
}
function panning$factory_1() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.f79();
  }, function (receiver, value) {
    return receiver.e79(value);
  });
}
function SoundAudioStream$Companion$ID_POOL$lambda(it) {
  return it;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.l7q_1.f7q_1.g7i($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  $this.m7q_1._v = stream;
  var tmp_0 = stream.e7i($this.n7q_1.m7n_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.o7q_1._v = true;
  try {
    var temp = new AudioSamples(stream.o7h_1, 2048);
    var started = false;
    while (_PlaybackTimes___get_hasMore__impl__ei8boc($this.p7q_1._v.j7n_1)) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
      var tmp_1 = stream.e7i(tmp$ret$1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      $l$loop: while (true) {
        while ($this.q7q_1.n78_1) {
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$3 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_2 = delay(tmp$ret$3, $completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
        }
        if (!($this.r7q_1._v == null)) {
          // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
          var this_0 = $this.s7q_1;
          $l$block: {
            // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
            this_0.c36();
            try {
              $this.t7q_1.h3();
              break $l$block;
            }finally {
              this_0.e36();
            }
          }
          var tmp_3 = stream.e7i(ensureNotNull($this.r7q_1._v).lk_1, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          $this.r7q_1._v = null;
        }
        var tmp_4 = stream.f7i(temp, 0, temp.w77_1, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var read = tmp_4;
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_1 = $this.s7q_1;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_1.c36();
          try {
            $this.t7q_1.z7m(temp, 0, read);
            break $l$block_0;
          }finally {
            this_1.e36();
          }
        }
        if (stream.b7i() || $this.t7q_1.u2d() >= $this.u7q_1) {
          if (!started) {
            started = true;
            $this.q7q_1.h79();
          } else if ($this.t7q_1.u2d() >= imul($this.u7q_1, 2)) {
            while ($this.t7q_1.u2d() >= $this.u7q_1) {
              // Inline function 'korlibs.time.milliseconds' call
              // Inline function 'kotlin.time.Companion.milliseconds' call
              Companion_getInstance();
              var tmp$ret$9 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
              var tmp_5 = delay(tmp$ret$9, $completion);
              if (tmp_5 === get_COROUTINE_SUSPENDED())
                tmp_5 = yield tmp_5;
            }
          }
        }
        var tmp_6 = yield_0($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        if (stream.b7i())
          break $l$loop;
      }
      var tmp_7 = yield_0($completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      $this.p7q_1._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($this.p7q_1._v.j7n_1));
    }
    $this.v7q_1._v = true;
    var n = 0;
    $l$loop_0: while (true) {
      var tmp_8;
      if ($this.q7q_1.s78_1 && $this.t7q_1.u2d() > 0) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp_8 = _unary__edvuaz < 8;
      } else {
        tmp_8 = false;
      }
      if (!tmp_8) {
        break $l$loop_0;
      }
      var tmp_9 = delay_0(new Long(10, 0), $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      var tmp42_safe_receiver = $this.n7q_1.s7n_1;
      if (tmp42_safe_receiver == null)
        null;
      else
        tmp42_safe_receiver();
    } else {
      throw $p;
    }
  }
  finally {
    $this.q7q_1.i79();
    if ($this.l7q_1.h7q_1) {
      stream.p6();
    }
    $this.o7q_1._v = false;
    Companion_getInstance_16().x7q_1.g42($this.w7q_1);
    var tmp43_safe_receiver = $this.n7q_1.t7n_1;
    if (tmp43_safe_receiver == null)
      null;
    else
      tmp43_safe_receiver();
    var tmp44_safe_receiver = $this.l7q_1.j7q_1;
    if (tmp44_safe_receiver == null)
      null;
    else {
      var tmp_10 = tmp44_safe_receiver($completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
    }
  }
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
function SoundAudioStream$play$lambda($dequeLock, $flushing, $deque, $BUFFER_SAMPLES) {
  return function (it) {
    AudioSampleArray__fill$default_impl_gh9lh0(it.a79_1, Companion_getInstance_1().b79_1);
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $dequeLock;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.c36();
      try {
        if ($flushing._v || $deque.u2d() >= $BUFFER_SAMPLES) {
          $deque.e7n(it);
        }
        break $l$block;
      }finally {
        this_0.e36();
      }
    }
    return Unit_instance;
  };
}
function SoundAudioStream$play$slambda_0(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
  var i = new SoundAudioStream$play$slambda(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId);
  var l = function ($this$launch, $completion) {
    return i.f2y($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function volume$factory_2($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.p78_1;
  }, function (value) {
    $b0.p78_1 = value;
    return Unit_instance;
  });
}
function pitch$factory_2($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.k79();
  }, function (value) {
    return $b0.j79(value);
  });
}
function panning$factory_2($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.q78_1;
  }, function (value) {
    $b0.q78_1 = value;
    return Unit_instance;
  });
}
function volume$factory_3() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.d79();
  }, function (receiver, value) {
    return receiver.c79(value);
  });
}
function volume$factory_4() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.d79();
  }, function (receiver, value) {
    return receiver.c79(value);
  });
}
function pitch$factory_3() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.k79();
  }, function (receiver, value) {
    return receiver.j79(value);
  });
}
function pitch$factory_4() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.k79();
  }, function (receiver, value) {
    return receiver.j79(value);
  });
}
function panning$factory_3() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.f79();
  }, function (receiver, value) {
    return receiver.e79(value);
  });
}
function panning$factory_4() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.f79();
  }, function (receiver, value) {
    return receiver.e79(value);
  });
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForLambda(AudioFormat$decodeStream$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AudioDecodingProps, 'AudioDecodingProps', AudioDecodingProps);
initMetadataForClass(InvalidAudioFormatException, 'InvalidAudioFormatException');
initMetadataForClass(MP3Base, 'MP3Base', MP3Base, VOID, VOID, [2, 4]);
initMetadataForClass(MP3, 'MP3', MP3, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(ChannelMode, 'ChannelMode');
initMetadataForClass(Mp3Info, 'Mp3Info');
initMetadataForCompanion(Companion_3, VOID, VOID, [1]);
initMetadataForClass(SeekingTable, 'SeekingTable');
initMetadataForClass(Parser, 'Parser', VOID, VOID, VOID, [0, 2, 3, 1]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 4]);
initMetadataForClass(MiniMp3Program, 'MiniMp3Program', MiniMp3Program);
initMetadataForClass(Minimp3Decoder, 'Minimp3Decoder', Minimp3Decoder, VOID, [MiniMp3Program, AutoCloseable]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMp3DecoderInfo, 'BaseMp3DecoderInfo', BaseMp3DecoderInfo);
initMetadataForCompanion(Companion_5);
initMetadataForClass(AudioStream, 'AudioStream', VOID, VOID, [AutoCloseable], [1, 3, 0]);
initMetadataForClass(BaseMinimp3AudioFormat$createDecoderStream$2, VOID, VOID, VOID, VOID, [1, 3, 0]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(L12_subband_alloc_tStruct, 'L12_subband_alloc_tStruct');
initMetadataForClass(Mp3Dec, 'Mp3Dec', Mp3Dec.u7d);
initMetadataForClass(Bs, 'Bs', Bs);
initMetadataForClass(Mp3Scratch, 'Mp3Scratch', Mp3Scratch.e7k);
initMetadataForClass(Mp3FrameInfo, 'Mp3FrameInfo', Mp3FrameInfo);
initMetadataForClass(ArrayPtr, 'ArrayPtr');
initMetadataForClass(UByteArrayIntPtr, 'UByteArrayIntPtr');
initMetadataForClass(FloatArrayPtr, 'FloatArrayPtr');
initMetadataForClass(ShortArrayPtr, 'ShortArrayPtr');
initMetadataForClass(GrInfo, 'GrInfo', GrInfo);
initMetadataForClass(ScaleInfo, 'ScaleInfo', ScaleInfo);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_7, VOID, VOID, [2, 4]);
initMetadataForClass(Chunk, 'Chunk');
initMetadataForClass(ProcessedChunk, 'ProcessedChunk');
initMetadataForClass(WavAudioStream, 'WavAudioStream', VOID, VOID, VOID, [1, 3, 0]);
initMetadataForClass(Fmt, 'Fmt', Fmt);
initMetadataForLambda(WAV$parse$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(AudioSamplesDeque, 'AudioSamplesDeque');
initMetadataForCompanion(Companion_9);
initMetadataForLambda(createSound$slambda, VOID, VOID, [0]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(PlaybackTimes, 'PlaybackTimes');
initMetadataForCompanion(Companion_11);
initMetadataForClass(PlaybackParameters, 'PlaybackParameters', PlaybackParameters, VOID, [ReadonlySoundProps]);
initMetadataForClass(SoundChannel, 'SoundChannel', VOID, VOID, [SoundProps]);
initMetadataForInterface(SoundPlay, 'SoundPlay', VOID, VOID, VOID, [1, 2, 3]);
protoOf(Sound).s7o = play;
protoOf(Sound).t7o = play$default;
initMetadataForClass(Sound, 'Sound', VOID, VOID, [SoundProps, SoundPlay], [1, 0, 2, 3]);
initMetadataForClass(SoundChannelState, 'SoundChannelState');
initMetadataForClass(SoundAudioData$play$4);
initMetadataForClass(SoundAudioData, 'SoundAudioData', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForCompanion(Companion_12);
initMetadataForLambda(SoundAudioStream$play$slambda, VOID, VOID, [1]);
initMetadataForClass(SoundAudioStream$play$1);
initMetadataForClass(SoundAudioStream, 'SoundAudioStream', VOID, VOID, VOID, [1, 0, 2, 3]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_9 = new Companion_8();
DEFAULT_MAX_SAMPLES = 39690000;
Companion_instance_10 = new Companion_9();
//endregion
//region block: exports
export {
  readSound as readSoundcwkqnndcldwa,
  AudioDecodingProps as AudioDecodingProps3opb5jdts7txo,
  get_paused as get_paused1g95gdg2lui5k,
};
//endregion
